<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm12>
                <v-card>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 px-0>
                                <h3 class="commen-heading">
                                    <v-avatar size="39" color="white" class="mr-2 pa-2">
                                        <v-icon class="text-primary" @click="gotohome()">
                                            arrow_back
                                        </v-icon>
                                    </v-avatar>&nbsp; {{SurveyName}}
                                </h3>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap mt-3>
                            <v-flex xs6 sm6>
                                <h3 class="commen-heading pt-2 pl-2">
                                    Data Forms
                                </h3>
                            </v-flex>
                            <!--Popup Buttons-->
                            <v-flex xs6 sm6>
                                <!--More btn -->
                                <!-- <v-btn light fab small color="white" class="rounded-rect-btn float-right" @click.stop="MorePopup = true">
                                    <img src="@/assets/images/Options.svg" class="ic-small" alt="icon">
                                </v-btn> -->
                                <!-- <v-dialog v-model="MorePopup">
                                    <v-card>
                                        <v-container fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12>
                                                    <v-card-title>
                                                        <h4 class="grey--text text--darken-2">
                                                            <v-avatar size="28" color="grey lighten-3" class="mr-2">
                                                                <img src="@/assets/images/Options.svg" class="ic-small" alt="icon">
                                                            </v-avatar>Table Function
                                                        </h4>
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card>
                                </v-dialog> -->
                                <!--Filter btn-->
                                <!-- <v-btn light fab small color="white" class="rounded-rect-btn float-right" @click.stop="FilterPopup = true">
                                    <img src="@/assets/images/Filter.svg" class="ic-small" alt="icon">
                                </v-btn> -->
                                <!-- <v-dialog v-model="FilterPopup">
                                    <v-card>
                                        <v-container fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12>
                                                    <v-card-title>
                                                        <h4>
                                                            <v-avatar size="28" color="grey lighten-3" class="mr-2">
                                                                <img src="@/assets/images/Filter.svg" class="ic-small" alt="icon">
                                                            </v-avatar>Filter Options
                                                        </h4>
                                                    </v-card-title>
                                                    <v-divider></v-divider>

                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card>
                                </v-dialog> -->
                                <!--Search btn -->
                                <v-btn light fab small color="white" class="rounded-rect-btn float-right" @click="searchBox = true">
                                    <img src="@/assets/images/Search.svg" class="ic-small" alt="icon">
                                </v-btn>
                            </v-flex>
                            <!--Search box-->
                            <v-flex xs12 sm12 class="search-popup" style="top:65px; left:0px;">
                                <div class="small-input" style="width:100%">
                                    <v-text-field full-width class="mt-2 mb-0" transition="slide-x-transition" v-model="Search" label="Search" solo v-show="searchBox" prepend-icon="arrow_back" @click:prepend="searchBox = false" append-icon="search">
                                        <template v-slot:append>
                                            <img width="14" height="14" src="@/assets/images/Search.svg" alt="">
                                        </template>
                                    </v-text-field>
                                </div>
                            </v-flex>
                            <!--hide-actions -->
                            <v-flex xs12 sm12 mt-2>
                                <v-data-table :items="getSurveyForms" class="custom-data-table" hide-actions :headers="FormHeader" disable-initial-sort="true">
                                    <template v-slot:items="props">
                                        <tr>
                                            <td class="py-3">
                                                <h3>{{props.item.Name}}</h3>
                                                <h6>Version : v1.0</h6>
                                                <!-- <h6>Added on {{props.item.CreatedDate}}</h6> -->
                                                <h6> Added on {{ formatDate(props.item.CreatedDate) }}</h6>
                                            </td>
                                            <td class="text-xs-center" v-if="props.item.SurveyFormEntrycount>0">
                                                <h3>{{props.item.SurveyFormEntrycount}}</h3>
                                            </td>
                                            <td class="py-3">
                                                <v-btn light fab small color="white" class="rounded-rect-btn float-right" @click="GetActionPopUp(props.item.FormID,props.item.SurveyID)">
                                                    <img src="@/assets/images/Options.svg" class="ic-small" alt="icon">
                                                </v-btn>
                                                <!--</div>-->
                                                <!--Submitted Message Snackbar-->
                                                <v-snackbar class="custom-snackbar" color="grey darken-2" v-model="snackbarSubmitted" bottom auto-height vertical timeout="4000" multi-line>
                                                    <v-avatar color="white red--after" size="23" class="ic-shadow pa-2">
                                                        <img src="@/assets/images/Submit_Sucs.svg" alt="icon" />
                                                    </v-avatar>
                                                    1 form has been Submitted
                                                    <v-btn color="pink" flat @click="snackbarSubmitted = false">Undo</v-btn>
                                                </v-snackbar>
                                                <!--Deleted Message Snackbar-->
                                                <v-snackbar class="custom-snackbar" color="grey darken-2" v-model="snackbarDeleted" bottom auto-height vertical timeout="4000" multi-line>
                                                    <v-avatar color="white red--after" size="23" class="ic-shadow pa-2">
                                                        <img src="@/assets/images/Delete_Sucs.svg" alt="icon" />
                                                    </v-avatar>
                                                    1 form has been deleted
                                                    <v-btn color="pink" flat @click="snackbarDeleted = false">Undo</v-btn>
                                                </v-snackbar>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <!--dialogue box-->
                            <v-dialog v-model="TableActionPopup">
                                <v-card>
                                    <v-container fluid v-for="(form, index) in SurveyForm" :key="index">
                                        <v-card-title>
                                            <h4 class="text-primary">
                                                <v-avatar size="28" color="blue lighten-5" class="mr-2">
                                                    <v-icon class="text-primary">more_vert</v-icon>
                                                </v-avatar>{{form.Name}}
                                            </h4>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text class="pa-0">
                                            <v-layout row wrap v-if="form.CreatedBy!=form.UserID">
                                                <v-layout row wrap v-if="form.SurveyFormEntrycount>0">
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetSurveySections(form.SurveyID,form.FormID,0,false)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetEditedSurveyQuestion(form.SurveyID,form.FormID,1)">
                                                            <img src="@/assets/images/Edit.svg" alt="icon" class="ic-small mr-2">Create new Entry
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="router.push(`/surveyformentry/${form.FormID}/${Survey[0].SurveyID}`)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View Form Entries
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap v-else>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetSurveySections(form.SurveyID,form.FormID,0,false)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetEditedSurveyQuestion(form.SurveyID,form.FormID,1)">
                                                            <img src="@/assets/images/Edit.svg" alt="icon" class="ic-small mr-2">Create new Entry
                                                        </v-btn>
                                                    </v-flex>

                                                </v-layout>
                                            </v-layout>
                                            <v-layout row wrap v-else>
											
                                                <v-layout row wrap v-if="form.SurveyFormEntrycount>0">
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetSurveySections(form.SurveyID,form.FormID,0,false)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GetSurveySections(form.SurveyID,form.FormID,0,true)">
                                                            <img src="@/assets/images/Edit.svg" alt="icon" class="ic-small mr-2">Edit
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="FormSubmitAlert = true">
                                                            <img src="@/assets/images/Submit.svg" alt="icon" class="ic-small mr-2">Submit
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="router.push(`/surveyformentry/${form.FormID}/${Survey[0].SurveyID}`)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View Form Entries
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap v-else>
                                                    <v-flex xs12 sm12>
                                                        <!-- <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="PreLoader=true;GetSurveySections(form.SurveyID,form.FormID,0,false)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">View
                                                        </v-btn> -->
                                                    </v-flex>
													
                                                    <v-flex xs12 sm12 v-if="form.IsSaved == 'true'">
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="PreLoader=true;GetSurveySections(form.SurveyID,form.FormID,0,true)">
                                                            <img src="@/assets/images/Edit.svg" alt="icon" class="ic-small mr-2">Edit
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="GeneratePDF(form.SurveyID,form.FormID)">
                                                            <img src="@/assets/images/Details.svg" alt="icon" class="ic-small mr-2">Download PDF
                                                        </v-btn>
                                                    </v-flex>
                                                    <!--<v-flex xs12 sm12>
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="FormSubmitAlert = true">
                                                            <img src="@/assets/images/Submit.svg" alt="icon" class="ic-small mr-2">Submit
                                                        </v-btn>
                                                    </v-flex>-->
                                                    <v-flex xs12 sm12 v-if="form.IsSaved=='true'">
                                                        <v-btn flat grey--text class="text-none grey--text text--darken-2" @click="FormDeleteAlert=true">
                                                            <img src="@/assets/images/Delete.svg" alt="icon" class="ic-small mr-2">Delete
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>

                                            <!--Form Submission Alert popup-->
                                            <v-dialog v-model="FormSubmitAlert">
                                                <v-card>
                                                    <v-container fluid>
                                                        <v-layout row wrap>
                                                            <v-list two-line>
                                                                <v-list-tile>
                                                                    <v-list-tile-action>
                                                                        <img src="@/assets/images/Submit_Form_Vec.svg" alt="icon" />
                                                                    </v-list-tile-action>
                                                                    <v-list-tile-content class="pl-4">
                                                                        <h3 class="grey--text text--darken-2">Are you sure want to Submit the form ?</h3>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-list>
                                                        </v-layout>
                                                        <v-layout row justify-center mt-3>
                                                            <v-flex xs6 sm6 md6 class="pr-1">
                                                                <v-btn color="success-btn" dark block class="text-none" @click=" SubmitSurveyFom(true)">Submit Form</v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6 class="pl-1">
                                                                <v-btn color="grey lighten-2" block class="text-none" @click="FormSubmitAlert = false">Cancel and Exit</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card>
                                            </v-dialog>

                                            <!--Form Delete Alert popup-->
                                            <v-dialog v-model="FormDeleteAlert">
                                                <v-card>
                                                    <v-container fluid>
                                                        <v-layout row wrap>
                                                            <v-list two-line>
                                                                <v-list-tile>
                                                                    <v-list-tile-action>
                                                                        <img src="@/assets/images/Delete_Form_Vec.svg" alt="icon" />
                                                                    </v-list-tile-action>
                                                                    <v-list-tile-content class="pl-4">
                                                                        <h3 class="grey--text text--darken-2">Are you sure want to delete the form ?</h3>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-list>
                                                        </v-layout>
                                                        <v-layout row justify-center mt-3>
                                                            <v-flex xs6 sm6 md6 class="pr-1">
                                                                <v-btn color="success-btn" dark block class="text-none" @click="snackbarDeleted = true ,DeleteForm(form.FormID) ">Delete Form</v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6 class="pl-1">
                                                                <v-btn color="grey lighten-2" block class="text-none" @click="FormDeleteAlert = false">Cancel and Exit</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card>
                                            </v-dialog>

                                        </v-card-text>
                                    </v-container>
                                </v-card>
                            </v-dialog>
                            <v-dialog scrollable persistent v-model="ActiveAddQuestPopup" v-for="(items, index) in CurrentSectionQuestions" :key="index">
                                <v-card>
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 class="text-xs-center">
                                                <!-- <h1 class="text-center">
                                                    <img src="@/assets/images/CBZ_Logo.svg" alt="Genz">
                                                </h1> -->
                                                <h2 class="commen-heading">{{SurveyName}} </h2>
                                            </v-flex>
                                            <v-flex xs2 sm2>
                                                <v-avatar size="39" color="grey lighten-3" class="mr-2 pa-2" v-on:click="NextSectionQuestions(items.SurveyID,SelectedSection-1);$('#qstDiv').scrollTop(0);" v-if="SelectedSection>1">
                                                    <img src="@/assets/images/Left_chev_act.svg" alt="icon">
                                                </v-avatar>
                                            </v-flex>
                                            <v-flex xs8 sm8 class="text-xs-center">
                                                <h3 class="grey--text text--darken-2"> {{SelectedSection}} of  {{TotSections}} Questions</h3>
                                            </v-flex>
                                            <v-flex xs2 sm2 class="text-xs-right">
                                                <v-avatar size="39" color="grey lighten-3" class="mr-2 pa-2" v-if="SelectedSection < TotSections">
                                                    <img src="@/assets/images/Right_chev_act.svg" alt="icon" v-on:click="NextSectionQuestions(items.SurveyID,SelectedSection+1);$('#qstDiv').scrollTop(0);">
                                                </v-avatar>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-title>
                                    <v-card-text style="height:75vh;z-index:999;" id="qstDiv">
                                        <v-container grid-list-md id="container">
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 class="my-4">
                                                    <h4 class="form-label-2 idfc-yellow-strip grey--text text--darken-1">{{items.SectionName}}</h4>
                                                </v-flex>
                                            </v-layout>
											<div v-for="(question,i) in items.Questions" :key="i">
                                                <v-layout row wrap class="mt-2"
                                                    v-if="question.QuestionText == 'Salary'">
                                                </v-layout>
                                                <v-layout v-bind:id="(question && question.QuestionText) ? question.QuestionText + '_layout' : ''"
                                                    row wrap
                                                    class="mt-2"
                                                    v-bind:style="[((question && (question.QuestionText == 'ISDCodes' || question.QuestionText == 'CurrencyType') && question.QuestionType == 'Dropdown')) ? { 'float': 'left' } : {}]">
                                                <v-flex xs12 sm12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Notes'">
                                                                <label>{{ question.QuestionName }}</label>
                                                            </v-flex>
                                                        <v-flex xs12 sm12 md12 v-if="question.QuestionType=='Text'">
                                                            <label>{{question.QuestionName}}</label><sub v-if="question.IsMandatory==true" style="color:red;font-size:large">*</sub>
                                                            <div v-if="question.TextLength>0" class="small-input counter">
                                                                <v-col cols="12" sm="6">
                                                                    <v-text-field v-on:keypress="checkValidation($event,question.validationType)" v-on:keyup="checkValidationMb($event,question.validationType)" v-model="question.Answers"  onpaste="return false;" solo
                                                                                  :rules="[ value => value.length <= question.TextLength]" v-on:focusin="removeIDformat($event,question)" v-on:focusout="addIDformat($event,question)"
                                                                                  counter :value="question.DefaultValue" :disabled="question.Disabled" :pattern = question.pattern
                                                                                  v-bind:maxlength="question.TextLength" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,i)"
                                                                                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(new RegExp(this.pattern,'gi'), '');"></v-text-field>
                                                                </v-col>
                                                            </div>
                                                            <div v-else class="small-input">
                                                                <v-text-field class="mt-2" :id='question.QuestionName' :disabled="question.Disabled" oninput="javascript:  this.value = this.value.replace(new RegExp(this.pattern,'gi'),'');" :pattern = question.pattern v-on:focusin="removeIDformat($event,question)" v-on:focusout="addIDformat($event,question)" onpaste="return false;" solo full-width v-model="question.Answers" :value="question.DefaultValue" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,question.IsRepeatSection,question.RepeatOrder)"></v-text-field>
                                                            </div>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none">{{question.ErrorText}}</div>
                                                        </v-flex>
                                                        
                                                        <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ResidencePeriod'">
                                                                <label>{{ question.QuestionName }}
                                                                    (Year-Month)</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-col cols="12" sm="12">
                                                                        <v-text-field :autocomplete="'off'"
                                                                            type='number'
                                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);if (parseInt(this.value) < parseInt(this.min)) this.value = '';"
                                                                            style="width: 30%; float:left; padding-right: 10%;"
                                                                            v-model="years_period" name="year"
                                                                            placeholder="YY" pattern="\d*" maxlength="2"
                                                                            size="2" min="0" onpaste="return false;"
                                                                            solo></v-text-field>
                                                                        <span>-</span>
                                                                        <v-text-field :autocomplete="'off'"
                                                                            type='number'
                                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);if (parseInt(this.value) < parseInt(this.min)) this.value = '';if (parseInt(this.value) > parseInt(this.max)) this.value = this.max;"
                                                                            min="0" max="11"
                                                                            style="width: 30%;margin-top: -20px;padding-left: 10%;"
                                                                            v-model="months_period" name="month"
                                                                            placeholder="MM" pattern="\d*" maxlength="2"
                                                                            size="2" onpaste="return false;"
                                                                            solo></v-text-field>
                                                                    </v-col>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>

                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Number'"
                                                                v-show="!question.hide">
                                                                <label
                                                                    v-if="(question.QuestionText != 'ISDCode' && question.QuestionText != 'Salary')">{{ question.QuestionName }}</label><sub
                                                                    v-if="question.QuestionText != 'ISDCode' && question.QuestionText != 'Salary' && question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input" style="margin-bottom: 1rem;">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-if="question.QuestionText != 'ISDCode'"
                                                                        v-bind:maxlength="question.TextLength"
                                                                        v-bind:style="[question.QuestionText == 'Salary' ? { 'top': '7px' } : {}]"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @focus="Calculation(question.QuestionID, question.IsFormulaQuestion, question.RepeatOrder, question.SubRepeatOrder)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, '', question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"
                                                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');"></v-text-field>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-if="question.QuestionText == 'ISDCode'"
                                                                        v-bind:maxLength="[question.QuestionText == 'ISDCode' ? '15' : '']"
                                                                        v-bind:style="[question.QuestionText == 'ISDCode' ? { 'top': '15px' } : {}]"
                                                                        oninput="javascript: this.value = this.value.replace(/[^0-9]/gi, '');if(!this.value.match('^[1-9][0-9]*$')){this.value='';}"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @focus="Calculation(question.QuestionID, question.IsFormulaQuestion, question.RepeatOrder, question.SubRepeatOrder)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, '', question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                                <!-- </div> -->
                                                            </v-flex>

                                                            <v-flex xs12 sm12 style="background-color: lightgrey;"
                                                                v-if="question.QuestionType == 'Label'">
                                                                <label
                                                                    style="font-size: 15px;font-weight: bold;">{{ question.QuestionName }}</label>
                                                            </v-flex>

                                                            <!--Date field-->
                                                            <v-flex xs12 sm12 md12 v-if="question.QuestionType == 'Date'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field type="date" onkeydown="return false;"
                                                                        onpaste="return false;"
                                                                        v-bind:id="'dt_' + question.QuestionID" solo
                                                                        full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        v-bind:max="issuanceDateRestrictionMax(question.QuestionName)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!-- Issuance date -->
                                                            <v-flex xs12 sm12 md12
                                                                style="padding: 1px !important; margin-top: -10px !important;"
                                                                v-if="question.QuestionType == 'IssuanceDate'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        type="date" :disabled="question.Disabled"
                                                                        onkeydown="return false" onpaste="return false;"
                                                                        v-bind:id="'issuedt_' + question.QuestionID"
                                                                        v-bind:max="issuanceDateRestrictionMax(question.QuestionName)"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)">
                                                                    </v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!-- Expiry date -->
                                                            <v-flex xs12 sm12 md12
                                                                style="padding: 1px !important; margin-top: -10px !important;"
                                                                v-if="question.QuestionType == 'ExpiryDate'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        type="date"
                                                                        v-bind:id="'date_picker_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        onkeydown="return false" onpaste="return false;"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @click="expiryDateRestrictionMax(question.QuestionID, question.RepeatOrder, question.QuestionName)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled">
                                                                    </v-text-field>
                                                                </div>
                                                                <!-- <div v-if="expiryErrMsg" style="color:red;display:none" > Expiry date is required</div> -->
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>

                                                            </v-flex>
                                                            <!--Multiline field-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'MultiLine' || question.QuestionType == 'MultiLineText'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div v-if="question.TextLength > 0">
                                                                    <v-col cols="12" sm="12">
                                                                        <v-textarea v-model="question.Answers"
                                                                            @keypress="checkSpcialChar" @paste.prevent
                                                                            solo
                                                                            :rules="[value => value.length <= question.TextLength]"
                                                                            :counter="question.DefaultValue"
                                                                            :maxlength="question.TextLength"
                                                                            @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"></v-textarea>
                                                                    </v-col>
                                                                </div>
                                                                <!-- <v-text-field rows="10" cols="50" multi-line class="mt-2" solo full-width v-model="question.Answers"></v-text-field>-->
                                                                <v-col cols="12" md="12" v-else>
                                                                    <v-textarea @keypress.prevent="checkSpcialChar"
                                                                        @paste.prevent v-model="question.Answers"
                                                                        @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        solo></v-textarea>
                                                                </v-col>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--CheckBox-->
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType=='CheckBox'">
                                                            <label>{{question.QuestionName}}</label><sub v-if="question.IsMandatory==true" style="color:red;font-size:large">*</sub>
                                                            <ul class="list-style-none">
                                                                <li v-for="option in question.Options">
                                                                    <v-CheckBox :label="option.OptionText" :id="option.OptionID"
                                                                                class="my-0" v-model="question.Answers" v-bind:value="option.OptionValue" @change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-CheckBox>
                                                                </li>
                                                            </ul>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none">{{question.ErrorText}}</div>
                                                        </v-flex> -->

                                                        <v-flex xs12 sm12 v-if="question.QuestionType == 'CheckBox'">
                                                            <label>{{ question.QuestionName }}</label>
                                                            <sub v-if="question.IsMandatory == true" style="color:red;font-size:large">*</sub>
                                                            <ul class="list-style-none">
                                                            <li v-for="(option, i) in question.Options" :key="i">
                                                                <v-check-box
                                                                :label="option.OptionText"
                                                                :id="option.OptionID"
                                                                class="my-0"
                                                                v-model="question.Answers"
                                                                v-bind:value="option.OptionValue"
                                                                @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                ></v-check-box>
                                                            </li>
                                                            </ul>
                                                            <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder" style="color:red;display:none">
                                                            {{ question.ErrorText }}
                                                            </div>
                                                        </v-flex>
                                                            <!--Dropdown  items.DrpDwnopt-->
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && question.QuestionText != 'ISDCodes' && (question.QuestionText != 'Account Class(Current)' && question.QuestionText != 'Account Class(Savings)' && question.QuestionText != 'Account Class(Call)' && question.QuestionText != 'Source of Funds(Employed)' && question.QuestionText != 'Source of Funds(UnEmployed)' && question.QuestionText != 'Source of Funds(Pensioner)' && question.QuestionText != 'Source of Funds(SelfEmployed)')"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'ISDCodes') && (question.QuestionText != 'Account Class(Current)' && question.QuestionText != 'Account Class(Savings)' && question.QuestionText != 'Account Class(Call)' && question.QuestionText != 'Source of Funds(Employed)' && question.QuestionText != 'Source of Funds(UnEmployed)' && question.QuestionText != 'Source of Funds(Pensioner)' && question.QuestionText != 'Source of Funds(SelfEmployed)')"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionLabel }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <!--   <vue-multiselect v-if="question.DrpDwnopt.length>10" v-model="question.Answers" :options="question.DrpDwnopt" value="OptionValue" placeholder="Select one" label="OptionText" @input="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,question.IsRepeatSection,question.RepeatOrder)"></vue-multiselect>-->
                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Current)')"
                                                                v-show="question.QuestionText == 'Account Class(Current)' && dispCurrentAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Current)' && dispCurrentAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Savings)')"
                                                                v-show="question.QuestionText == 'Account Class(Savings)' && dispSavingAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Savings)' && dispSavingAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Call)')"
                                                                v-show="question.QuestionText == 'Account Class(Call)' && dispCallAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Call)' && dispCallAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(Employed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(Employed)' && isdispEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(Employed)' && isdispEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(UnEmployed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(UnEmployed)' && isdispUnEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(UnEmployed)' && isdispUnEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>


                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(Pensioner)')"
                                                                v-show="question.QuestionText == 'Source of Funds(Pensioner)' && isdispPensionerLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(Pensioner)' && isdispPensionerLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(SelfEmployed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(SelfEmployed)' && isdispSelfEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(SelfEmployed)' && isdispSelfEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>


                                                            <!-- masterdb -->
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType == 'masterdb'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <vue-multiselect v-if="question.DrpDwnopt.length > 10"
                                                                        v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        value="OptionValue" placeholder="Select one"
                                                                        label="OptionText"
                                                                        @input="GetHierarchyDrpdwn(question.QuestionID, question.SurveyID)"></vue-multiselect>
                                                                    <vue-multiselect v-else v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="false" :close-on-select="true"
                                                                        @input="GetHierarchyDrpdwn(question.QuestionID, question.SurveyID)"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex> -->


                                                            <!--Radio  -->
                                                            <!-- <v-flex xs12 sm12 style="padding: 1px !important;" v-if="question.QuestionType=='Radio'">
                                                            <p ><label>{{question.QuestionName}}</label></p>
                                                            <div >
                                                                <v-radio-group v-model="question.Answers" v-for="(option,i) in question.Options" style="float: left;clear: none;" row :disabled="question.Disabled">
                                                                    <v-radio :key="i"
                                                                             :label="option.OptionText" :id="option.OptionID" style="margin-right: 100px"
                                                                             :value="option.OptionValue" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,option.OptionText,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-radio>
                                                                </v-radio-group>
                                                            </div><br/><br/><br/><br/>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none;" >{{question.ErrorText}}</div>
                                                        </v-flex> -->
                                                            <v-flex xs12 sm12 style="padding: 1px !important;"
                                                                v-if="question.QuestionType == 'Radio'">
                                                                <div>
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                </div>


                                                                <div v-for="(option, i) in question.Options" :key="i"
                                                                    style="float: left; clear: none;">
                                                                    <v-radio-group v-model="question.Answers" row
                                                                        :disabled="question.Disabled">
                                                                        <v-radio :label="option.OptionText"
                                                                            :id="option.OptionID"
                                                                            style="margin-right: 100px"
                                                                            :value="option.OptionValue"
                                                                            @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, option.OptionText, question.IsRepeatSection, question.RepeatOrder)">
                                                                        </v-radio>
                                                                    </v-radio-group>
                                                                </div>
                                                                <br /><br /><br /><br />
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none;">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType=='Radio'">
                                                            <label>{{question.QuestionName}}</label><sub v-if="question.IsMandatory==true" style="color:red;font-size:large">*</sub>
                                                            <div>
                                                                <v-radio-group v-model="question.Answers" v-for="(option,i) in question.Options" row>
                                                                    <v-radio :key="i"
                                                                             :label="option.OptionText" :id="option.OptionID"
                                                                             :value="option.OptionValue" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,option.OptionText,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-radio>
                                                                </v-radio-group>
                                                            </div>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none">{{question.ErrorText}}</div>
                                                        </v-flex> -->
                                                            <!--Yes/No  -->
                                                            <v-flex xs12 sm12 v-if="question.QuestionType == 'Yes/No'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="radio-without-vuetify pt-2">
                                                                    <div v-for="(option, i) in question.Options"
                                                                        :key="i">
                                                                        <v-radio-group v-model="question.Answers" row>
                                                                            <v-radio :label="option.OptionText"
                                                                                :id="option.OptionID"
                                                                                :value="option.OptionValue"
                                                                                @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, option.OptionText)">
                                                                            </v-radio>
                                                                        </v-radio-group>
                                                                    </div>

                                                                    <!--<v-radio-group v-model="items.Answers" row>
                                                                    <v-radio :key="0"
                                                                             :label="`Yes`" :id="`Yes`"
                                                                             :value="1" @click="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,'Yes')">
                                                                    </v-radio>
                                                                    <v-radio :key="1"
                                                                             :label="`No`" :id="`No`" @click="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,'No')"
                                                                             :value="2"></v-radio>
                                                                </v-radio-group>-->
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--GPS v-model="hdngpslocation.longitude" v-model="hdngpslocation.latitude"-->
                                                            <v-flex xs12 sm12 md12 v-if="question.QuestionType == 'GPS'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">

                                                                    <label>Longitude</label>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-bind:id="'longitude_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        solo full-width
                                                                        v-model="question.longitude"></v-text-field>
                                                                    <label>Latitude</label>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-bind:id="'latitude_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        solo full-width
                                                                        v-model="question.latitude"></v-text-field>
                                                                    <v-flex xs6 sm6 md6 class="pr-1">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            @click="GetGPSLocation(question.QuestionID, question.RepeatOrder)">
                                                                            Get GPS Location
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                          


                                                            <!--sign-->
                                                            <v-flex xs12 sm12 v-if="question.QuestionType == 'Sign'">
                                                                    <label>{{ question.QuestionName }}</label>
                                                                    <sub v-if="question.IsMandatory == true" style="color:red;font-size:large">*</sub>
                                                                    <v-btn color="white" full-width :id="'btnsignaturepad_' + question.QuestionID + '_' + question.RepeatOrder" @click="GetSignaturePad(question.QuestionID, question.RepeatOrder)">Open Signature Pad</v-btn>
                                                                    
                                                                    <div :id="'signaturepaddiv_' + question.QuestionID + '_' + question.RepeatOrder" style="display:none;align-items:center">
                                                                        <canvas ref="signatureCanvas" :id="'signature-pad_' + question.QuestionID + '_' + question.RepeatOrder" width="400" height="200" style="border: 1px solid black;"></canvas>
                                                                        <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button>
                                                                        <button class="primary-btn text-none" :id="'save_' + question.QuestionID + '_' + question.RepeatOrder">Save</button>
                                                                        <button class="primary-btn text-none" :id="'clear_' + question.QuestionID + '_' + question.RepeatOrder">Clear</button>
                                                                    </div>
                                                                    
                                                                    <div v-for="(itm, index) in question.Blob" :key="index">
                                                                        <v-card-text class="py-1">
                                                                                <img v-if="itm" 
                                                                                    :src="URL ? URL.createObjectURL(itm) : ''" 
                                                                                    alt="Signature"
                                                                                    >
                                                                            </v-card-text>
                                                                    </div>
                                                                    
                                                                    <br />
                                                                    <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder" style="color:red;display:none">
                                                                        {{ question.ErrorText }}
                                                                    </div>
                                                                    </v-flex>
                                                            <!--image input field-->
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Image' && question.QuestionName != 'Documents for Source of Funds / Income Proof'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="custom-file-upload mt-2">
                                                                    <input class="mt-2"
                                                                        v-on:change="imagetoblob($event, question.QuestionID, question.RepeatOrder)"
                                                                        type="file" accept=".gif, .jpg, .jpeg, .png"
                                                                        multiple="multiple" />
                                                                    <div style="color: grey;">(Click on the icon to
                                                                        upload/capture the image)
                                                                    </div>
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <v-card-text class="py-1">
                                                                        <input type="image"
                                                                            v-bind:src="URL.createObjectURL(itm)">
                                                                    </v-card-text>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Image' && dispDocForSourceOfFunds && question.QuestionName == 'Documents for Source of Funds / Income Proof'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="custom-file-upload mt-2">
                                                                    <input class="mt-2"
                                                                        v-on:change="imagetoblob($event, question.QuestionID, question.RepeatOrder)"
                                                                        type="file" accept=".gif, .jpg, .jpeg, .png"
                                                                        multiple="multiple" />
                                                                    <div style="color: grey;">(Click on the icon to
                                                                        upload/capture the image)
                                                                    </div>
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <v-card-text class="py-1">
                                                                        <input type="image"
                                                                            v-bind:src="URL.createObjectURL(itm)">
                                                                    </v-card-text>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--Lite KYC Camera Upload -->

                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'CaptureImage'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow" id="captureImage"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureDocs($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera"><b>Capture the
                                                                                Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static" v-if="isModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <!-- <center> -->
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                    <!-- </center> -->
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas id="capture"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheImg($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>



                                                            <!--ProofOfResidence Upload Camera-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ProofOfResidence'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow" id="ProofOfResidence"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureResidenceProof($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera-ResidenceProof"><b>Capture
                                                                                the Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static"
                                                                    v-if="isResidenceProofModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <!-- <center> -->
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                    <!-- </center> -->
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas
                                                                                        id="captureProofOfResidence"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheProofOfResidence($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-residenceProof-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!--Utility Bill Upload Camera-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ProofOfUtilityBill'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow"
                                                                        id="ProofOfUtilityBill"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureUtilityBillProof($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera-UtilityBillProof"><b>Capture
                                                                                the Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static"
                                                                    v-if="isUtilityBillModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas
                                                                                        id="captureProofOfUtilityBill"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheProofOfUtilityBill($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-residenceProof-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!--Audio-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Audio'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>

                                                                <div class="custom-file-upload mt-2"
                                                                    style="height:auto">
                                                                    <!--<audio-recorder v-modal="question.Answers" :id="question.QuestionID" upload-url="some url"
                                                                        :attempts="1"
                                                                        :time="1"
                                                                        :before-recording="callback"
                                                                        :after-recording="audiotoblob"
                                                                        :before-upload="callback"
                                                                        :successful-upload="callback"
                                                                        :failed-upload="callback" />-->
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <audio id="player"
                                                                        v-bind:src="URL.createObjectURL(itm)" controls
                                                                        class="mt-4"></audio>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12>
                                                                <div
                                                                    v-bind:id="'question_subsection_' + question.QuestionID">

                                                                </div>
                                                            </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
											</div>
                                        </v-container>
                                    </v-card-text>
                                    <!-- <v-card-actions>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 md12 v-if="showProcessMsg">
                                                <v-layout row justify-center>
                                                    <v-flex xs12 sm12 md6 v-if="dataProcessed">
                                                        <v-alert :value="true"
                                                                 color="success"
                                                                 icon="check_circle"
                                                                 outline="" v-if="dataprocessedsuccess">
                                                            {{ProcessMsg}}
                                                        </v-alert>
                                                        <v-alert :value="true"
                                                                 color="error"
                                                                 icon="warning"
                                                                 outline="" v-if="dataprocessedfailure">
                                                            {{ProcessMsg}}
                                                        </v-alert>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6 class="text-xs-center" v-else>
                                                        <h4>Form Data Processing. Please wait...</h4>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12>
                                                <v-layout row justify-center v-if="IsEditable">
                                                    <v-flex xs6 sm6 md6 class="pr-1" v-if="!dataProcessed || !onceProcessed">
                                                        <v-btn id ="process-btn" color="grey lighten-2" block class="text-none" @click="SubmitDataProcess()">Next</v-btn>
                                                    </v-flex>
                                                    <v-flex xs6 sm6 md6 class="pr-1" v-else>
                                                        <v-btn id ="submit-btn" color="primary-btn" dark block class="text-none" @click="SubmitSurveyFom()">Submit Form</v-btn>
                                                    </v-flex>
                                                   
                                                </v-layout>
                                                <v-layout row justify-center v-else>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-btn color="grey lighten-2" block class="text-none" @click="CancelForm()">Cancel</v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-actions> -->
                                </v-card>
                            </v-dialog>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog persistent v-model="dialogSuccess">
            <v-card>
                <v-card-text>
                    <v-alert :value="true" color="success" icon="check_circle" outline>
                        {{successMessage}}
                        <ul id="example-1">
                            <li v-for="(item, index) in uploadSuccess" :key="index">
                                {{ item }}
                            </li>
                        </ul>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark @click="popUpOkButton()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogError">
            <v-card>
                <v-card-text>
                    <v-alert :value="true" color="error" icon="warning" outline>
                        {{ErrorMessage}}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark @click="ErrorpopUpOkButton()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogError1">
            <v-card>
                <v-card-text>
                    <v-alert :value="true" color="error" icon="warning" outline>
                        {{ErrorMessage}}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark @click="tolimitExceed()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="processingDiv" v-bind:class="{'show': processLoader==1||processLoader==2||processLoader==3||processLoader==4 ||processLoader==5}">
            <v-layout row wrap justify-center>
                <v-flex md4 class="text-xs-center">
                    <v-stepper class="elevation-0" v-model="processLoader" style="width:100%">
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <img src="@/assets/images/process_loader-1.gif" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{SubmitProgressMessage}}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <img src="@/assets/images/process_loader-2.gif" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{SubmitProgressMessage}}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <img src="@/assets/images/process_loader-3.gif" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{SubmitProgressMessage}}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="4">
                                <img src="@/assets/images/process_loader-4.gif" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{SubmitProgressMessage}}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="5">
                                <img src="@/assets/images/process_loader-5.gif" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{SubmitProgressMessage}}
                                </h3>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </div>
        <!--Preloader starts-->
        <div class="pre-loader" v-show="PreLoader==true">
            <v-container fluid="" justify-center="true" fill-height="true">
                <v-progress-circular :size="80"
                                     color="#0676d8"
                                     indeterminate>
                    <v-icon size="50" color="#0676d8">settings</v-icon>
                </v-progress-circular>
            </v-container>
        </div>
        <!--Preloader ends-->
    </v-container>
</template>
<style type="text/css">
        input[id="First Name"], input[id="Middle Name"], input[id="Last Name"] {
            text-transform: uppercase !important;
        }
                .btn-close {
                    position: relative;
                    bottom: 189px;
                    right: 25px;
                    border: none;
                    font-size: 40px;
                    padding: 10px;
                    cursor: pointer;
                    font-weight: bold;
                    color: #e3352a;
                    background: transparent;}
    </style>
<script type="text/javascript">
// var blobObject = new Array();
import 'core-js/modules/es.array.push.js';  
import router from '@/router';
import { db, SavedFormDisabledFields } from '@/sunidhiapp';
import '@/customJs/compressjs.js'
// import VCheckBox from '@/components/VCheckBox.vue';
import SignaturePad from '@/customJs/signature_pad.min.js'
// import SignaturePad from 'signature_pad';
import $ from 'jquery';
import jsPDF from 'jspdf';
// eslint-disable-next-line no-unused-vars
// import { VTextarea } from 'vuetify/lib/components/VTextarea';
// Vue.prototype.$http = axios;
//Vue.use(VueAudioRecorder);
// Vue.component('vue-multiselect', window.VueMultiselect.default);

// var cameraStream = null;
export default {
    name: 'HomeDataForm',
        data: function () {
            return {
                upload: {
                    blbImage: "",
                    blbAudio: "",
                    blbFile: [],
                    blbsignImage: [],
                    FileName: []
                },
                SurveyName: '',
                Search: "",
                loading: true,
                MorePopup: false,
                ActiveAddQuestPopup: false,
                TotSections: 0,
                SelectedSection: 1,
                MorePopupEditTab: false,
                FilterPopup: false,
                FilterPopupEditTab: false,
                SearchPopup: false,
                searchBox: false,
                searchBoxEditTab: false,
                TableActionPopup: false,
                ViewPopup: false,
                EditAddQuestPopup: false,
                FormSubmitAlert: false,
                FormDeleteAlert: false,
                snackbarDeleted: false,
                snackbarSubmitted: false,
                SurveySectionList: [],
                CurrentSectionQuestions: [],
                hdngpslocation: "",
                submitLoading: false,
                SectionOrder: "",
                RepeatSectionCount: 0,
                CurrentSectionOrder: 0,
                SelectedSurveyID: 0,
                sectionArray: [],
                SurveyForms: [],
                SurveyForm: [],
                SelectedFormID: 0,
                fileimageerrmsg: "",
                IsEditable: false,
                dialogSuccess: false,
                successMessage: "",
                successMessageUserName: "",
                successMessagePassword: "",
                successLoginDetails: "",
                UploadStatusMsg: "",
                UploadStatus: false,
                ErrorMessage: "",
                dialogError: false,
                dialogError1: false,
                FormHeader: [
                    { text: "Form Name", value: "", align: "left" },
                    { text: "Entry Count", value: "" },
                    { text: "", value: "" }
                ],
                SubmitProgressMessage: "",
                processLoader: 6,
                customerCreationNo: "",
                casaAccountNo: "",
                uploadSuccess: [],
                dataProcessed: false,
                showProcessMsg: false,
                ProcessMsg: "",
                onceProcessed: false,
                ProcessedSurveySectionList: [],
                processedFormId: 0,
                processedStatus: true,
                dataprocessedsuccess: false,
                dataprocessedfailure: false,
                PreLoader: false,
				years_period:"00",
				months_period:"00",
                dispSavingAccountClass: false,
                dispCurrentAccountClass: false,
                dispCallAccountClass: false,
                isdispEmployedLookup: false,
                isdispUnEmployedLookup: false,
                isdispPensionerLookup: false,
                isdispSelfEmployedLookup: false,
                dispDocForSourceOfFunds: false,
                isModalVisible: false,
                isResidenceProofModalVisible: false,
                isUtilityBillModalVisible: false,
                isSourceOfFundsModalVisible: false,
                expiryErrMsg: false
            }
        },
        //components: { VueAudioRecorder },

        mounted: async function () {
            
            this.$sunidhi.logoutBtnDisp = true;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.hdngpslocation = position.coords.latitude + "," + position.coords.longitude;
                });
            }

            await this.GetAllSurveyForms();
            this.todo();
        },computed: {
                        getSurveyForms(){
                        if(this.Search){
                        return this.SurveyForms.filter(item => {
                                        return Object.values(item)
                                            .join(",")
                                            .toLowerCase()
                                            .includes(this.Search.toLowerCase());
                                        
                                    });
                        }else{
                            return this.SurveyForms;
                        }
                        }
                    },
        methods: {
            formatDate(createdDate) {
            if (typeof createdDate === 'object' && createdDate instanceof Date) {
            // Extract string representation of the date
            const dateString = createdDate.toString();
            // Perform the replacement
            return dateString.replace(/GMT\+(\d{2})(\d{2})/, 'GMT+$1:$2');
        } else {
            // If createdDate is not a Date object, return as is
            return createdDate;
        }
},

            //Validation for inputs starts//
            checkValidation(event, type) {
            if (type === "onlySpaceAlphabet") {
                this.isAlphabetSpace(event);
            } else if (type === "onlyAlphabet") {
                this.isAlphabet(event);
            } else if (type === "AlphaNumeric") {
                this.isAlphaNumeric(event);
            } else if (type === "onlyEmailId") {
                this.emailRestrict(event);
            }
        }, checkValidationMb(event, type) {
            if (type === "onlySpaceAlphabet") {
                this.isAlphabetSpaceMb(event);
            } else if (type === "onlyAlphabet") {
                this.isAlphabetMb(event);
            } else if (type === "AlphaNumeric") {
                this.isAlphaNumeric(event);
            } else if (type === "onlyEmailId") {
                this.emailRestrictMb(event);
            }
        },

        isLetter(e, question) {
            // debugger
            // if(question.questionName == 'First Name' || question.questionName == 'Middle Name' || question.questionName == 'Surname' || question.questionName == 'Place of Birth' || question.questionName =='Name of Spouse' ||  question.questionName == "Employer's Name" )
            if (question.QuestionName == 'First Name') {
                var regex = new RegExp("^[a-zA-Z ]+$");
                var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                // var value = question.Answers

                // Test the value against the regular expression
                if (!regex.test(key)) {
                    e.preventDefault();
                }
            }
        },

        spaceRestrict: function (event) {
            if (event.keyCode === 32) {
                event.preventDefault();
            }


        },
        RemoveSpace(event, question) {
            // debugger
            let val = event.target._value;
            question.Answers = val.trim();

        },
        emailRestrict: function (event) {
            var regex = new RegExp("^[a-zA-Z0-9.@_]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, emailRestrictMb: function (event) {
            event.srcElement.value = event.srcElement.value.replace(/[^[a-zA-Z0-9.@_]/gi, '');
        },

        isAlphabet(event) {
            // debugger
            var regex = new RegExp("^[a-zA-Z ]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        isAlphabetSpace(event) {
            var regex = new RegExp("^[a-zA-Z ]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, isAlphaNumeric(event) {
            var regex = new RegExp("^[a-zA-Z0-9]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            } else {/*
						$input = event.srcElement.value;
						if ($input.length == 2) {
						  event.srcElement.value = event.srcElement.value+"-";
						}
						var isAlphabet =true;
						var regex = new RegExp("^[a-zA-Z ]+$");
						var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
						if (!regex.test(key)) {
						   isAlphabet = false;
						}
						if(isAlphabet){
						  if ($input.length == 9 || $input.length == 10) {
						  $input = $input.replace(/(\d{2})(\d{6,7})/, "$1-$2")
						  event.srcElement.value = $input + "-";
						  } else {
						   event.preventDefault();
						   return false;
						  }
						} else if($input.length == 10){
						  if(!isAlphabet){
						   event.preventDefault();
						   return false;
						  }
						}
						if (($input.length == 11 || $input.length == 12)&& ( $input[$input.length-1] !="-")) {
						  $input = $input.replace(/(\d{2})(\d{6,7})(\w{1})/, "$1-$2-$3")
						  event.srcElement.value = $input+"-"; 
						}
						var finalRegex =  new RegExp('^[0-9]{2}[\-][0-9]{6,7}[\-][A-Za-z][\-][0-9]{2}$');
						if(finalRegex.test($input)){
						   if(!isAlphabet){
						   event.preventDefault();
						   return false;
						  }
						}
						
						return true;*/
            }
        },
        isAlphabetSpaceMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^a-zA-Z ]/gi, '');
        },
        isNumberMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^0-9]/gi, '');
        }, spaceRestrictMb: function (event) {
            event.srcElement.value = event.srcElement.value.replace(" ", '');

        }, isAlphabetMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^a-zA-Z ]/gi, '');
        },
        isNumber: function (event) {
            // console.log(event)
            var regex = new RegExp("^[0-9]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, dateRestrictionMax: function (questionName) {
            if (questionName == "Date of Birth") {
                // Use Javascript
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
                var yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }

                var maxYear = yyyy - 18; //Calculate Maximum Age (>18)
                var max = maxYear + "-" + mm + "-" + dd;
                return max;
            }
        },
        removeIDformat(event, question) {
            if (question.QuestionName == "ID Number") {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/gi, '');
            }
        }, addIDformat(event, question) {
            //    debugger
            // var AnswerValue = question.Answers;

            //    question.Answers = AnswerValue.trim();
            if (question.QuestionName == "ID Number") {

                var $input = event.srcElement.value;

                var regex = new RegExp("^[0-9]{8,9}[A-Za-z][0-9]{2}$");
                if (regex.test($input)) {
                    $input = $input.replace(/(\d{2})(\d{6,7})(\w{1})(\d{2})/, "$1-$2-$3-$4")
                    //    $input = $input.replace(/(\d{2})(\w{8})(\d{2})/, "$1-$2-$3");
                    event.target.value = $input.toUpperCase();
                    question.Answers = $input.toUpperCase();
                    document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = "";
                    document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "none";

                } else {
                    var regex2 = new RegExp("^[0-9]{2}-[0-9]{6,7}-[A-Za-z]-[0-9]{2}$");
                    // var regex2 =new RegExp("^[0-9]{2}[\-][A-Za-z0-9]{8}[\-][0-9]{2}$");
                    if (regex2.test($input)) {
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = "";
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "none";

                    } else {
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = question.ErrorText;
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "inline";
                    }
                }
            }

        },

        //Validation for input ends // 

        //adding custom value to occupation
        addTag(newTag, question) {
            question.Answers = ({ "OptionValue": newTag, "OptionText": newTag });


        },

            gotohome() { this.$sunidhi.backbuttonpressed = false; router.push('/HomeDataForm') },
            tolimitExceed() {
                this.dialogError1 = false;
                this.ErrorMessage = "";
                window.location.reload();
            },
            async popUpOkButton() {
                    var IsSaved = this.$route.params.IsSaved;  
                    this.successMessage = "";
                    this.dialogSuccess = false;
                    //window.location.reload();
                    this.ActiveAddQuestPopup = false;
                    if((this.uploadSuccess != null && this.uploadSuccess.length >0)|| IsSaved) {
                        window.location.reload();
                    }else {
                    await this.GetAllSurveyForms();
                    }
            },
            async ErrorpopUpOkButton() {
                this.ErrorMessage = "";
                this.dialogError = false;
				window.location.reload();
            },
            async GetAllSurveyForms() {

                var SurveyID = parseInt(this.$route.params.surveyID);
                var IsSaved = this.$route.params.IsSaved;

                var SurveyFormsTable = await db.TbSurveyForm.where("SurveyID").equals(SurveyID).toArray();

                var Survey = await db.TbSurvey.where("SurveyID").equals(SurveyID).toArray();
                if (Survey != null && Survey.length > 0) {
                    this.SurveyName = Survey[0].SurveyName;
                }

                SurveyFormsTable = SurveyFormsTable.filter(x => x.IsActive == true);
                if (IsSaved == "true") {
                    SurveyFormsTable = SurveyFormsTable.filter(x => x.IsSubmitted == false);
                }
                else {
                    SurveyFormsTable = SurveyFormsTable.filter(x => x.IsSubmitted == true);
                }

                if (SurveyFormsTable != undefined && SurveyFormsTable.length > 0) {
                    for (var i = 0; i < SurveyFormsTable.length; i++) {
                        var SurveyFormEntry = await db.TbSurveyFormEntry.where("FormId").equals(SurveyFormsTable[i].FormID).count();
                        var object = new Object();
                        object.SurveyID = SurveyFormsTable[i].SurveyID;
                        object.Name = SurveyFormsTable[i].Name;
                        object.CreatedDate = SurveyFormsTable[i].CreatedDate;
                        object.FormID = SurveyFormsTable[i].FormID;
                        object.CreatedBy = SurveyFormsTable[i].CreatedBy;
                        object.SurveyFormEntrycount = SurveyFormEntry;
                        this.SurveyForms.push(object);
                    }
                }
            },
            async GetActionPopUp(FormID, SurveyID) {

                this.TableActionPopup = true;
                this.SelectedFormID = FormID;
                this.SelectedSurveyID = SurveyID;
                this.SurveyForm = [];
                var UserID;
                if (localStorage) {
                    UserID = parseInt(localStorage.getItem("UserId"));
                }

                var Surveyforms = await db.TbSurveyForm.where("SurveyID").equals(SurveyID).toArray();
                Surveyforms = Surveyforms.filter(x => x.FormID == FormID);
                var SurveyFormEntry = await db.TbSurveyFormEntry.where("FormId").equals(FormID).toArray();

                if (Surveyforms.length > 0) {
                    for (var i = 0; i < Surveyforms.length; i++) {
                        var object = new Object();
                        object.SurveyID = Surveyforms[i].SurveyID;
                        object.Name = Surveyforms[i].Name;
                        object.CreatedDate = Surveyforms[i].CreatedDate;
                        object.FormID = Surveyforms[i].FormID;
                        object.CreatedBy = Surveyforms[i].CreatedBy;
                        object.UserID = UserID;
                        object.SurveyFormEntrycount = SurveyFormEntry.length;
                        object.IsSaved = this.$route.params.IsSaved;
                        this.SurveyForm.push(object);
                    }
                }
            },
            async GetSurveySections(SurveyID, FormId, sectionOrder, IsEditable, IsDirect = false) {
                
                this.IsEditable = IsEditable;
                this.rptSubArray = [];

                if (!IsDirect) {
                    this.ActiveAddQuestPopup = true;
                    this.TableActionPopup = false;
                }
                this.SurveyName = "";
                this.SurveySectionList = [];
                this.CurrentSectionQuestions = [];
                this.SelectedFormID = FormId;
                this.TotSections = 0;
                this.SelectedSection = 1;
                var SurveySectionList = [];

                var surevy = await db.TbSurvey.where({ SurveyID: SurveyID }).toArray();
                this.SurveyName = (surevy != null && surevy.length > 0) ? surevy[0].SurveyName : "";

                this.sectionArray = [];
                var ans3 = await db.TbSurveySection.where({ SurveyId: SurveyID }).toArray();

                //ans3 = ans3.filter(function (obj) {
                //    return (obj.SectionId != 485 && obj.SectionId != 497 && obj.SectionId != 498 && obj.SectionId != 499 && obj.SectionId != 500 && obj.SectionId != 502);
                //});

                var ans = (ans3 != null ? ans3.sort(function (a, b) { return a.SectionOrder - b.SectionOrder }) : ans3);

                var totConditionQuestion = 0;

                for (var i = 0; i < ans.length; i++) {
                    var conArray = await db.TbSurveyQuestions.where({ ConditionSectionId: ans[i].SectionId }).toArray();
                    conArray = conArray.filter(x => x.IsConditionQuestion == true);

                    var RepeatArray = await db.TbSurveyQuestions.where({ RepeatSectionId: ans[i].SectionId }).toArray();
                    RepeatArray = RepeatArray.filter(x => x.IsRepeatSection == true);
                    totConditionQuestion += conArray.length + RepeatArray.length;

                    if (conArray.length == 0 && RepeatArray.length == 0) {
                        this.sectionArray.push(ans[i].SectionId);
                    }

                    var object = new Object();
                    object.SectionId = ans[i].SectionId;
                    object.SectionName = ans[i].Name;
                    object.SectionOrder = ans[i].SectionOrder;
                    object.SurveyID = ans[i].SurveyId;
                    object.SurveyName = this.SurveyName;
                    //var dd = await this.GetSectionQuestionList(ans[i].SectionId)

                    object.Questions = await this.GetSectionQuestionList(ans[i].SectionId, FormId);

                    object.IsConditionQuestion = conArray.length > 0 ? true : false;
                    object.IsRepeatSection = RepeatArray.length > 0 ? true : false;
                    SurveySectionList.push(object);
                }

                this.SurveySectionList = SurveySectionList;
                this.TotSections = ans.length > 0 ? (ans.length - totConditionQuestion) : 0;
                await this.FillConditionSectionAndRepeatSection();

                await this.FillSubRepeatConditionAnswers();

                this.CurrentSectionQuestions = await SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder]);
                this.PreLoader = false;
            },
            async GetSectionQuestionList(SectionId, FormId) {

                var SurveySectionList = [];
                var SurveyQuestion = await db.TbSurveyQuestions.where({ SectionId: SectionId }).toArray();

                for (var i = 0; i < SurveyQuestion.length; i++) {
                    var object = new Object();
                    object.QuestionID = SurveyQuestion[i].QuestionID;
                    object.QuestionName = SurveyQuestion[i].QuestionName;
					object.QuestionLabel = SurveyQuestion[i].QuestionLabel;
					object.QuestionText = SurveyQuestion[i].QuestionText;
                    object.QuestionType = SurveyQuestion[i].QuestionType;
                    object.QuestionOrder = SurveyQuestion[i].QuestionOrder;
					object.validationType = SurveyQuestion[i].validationType;
					// object.Disabled = SurveyQuestion[i].Disabled;
					object.Disabled = true;
                    object.SurveyID = SurveyQuestion[i].SurveyID;
                    object.SectionId = SurveyQuestion[i].SectionId;
                    object.IsConditionQuestion = SurveyQuestion[i].IsConditionQuestion;
                    object.ConditionSectionId = SurveyQuestion[i].ConditionSectionId;
                    object.ConditionType = SurveyQuestion[i].ConditionType;
                    object.ConditionValue1 = SurveyQuestion[i].ConditionValue1;
                    //if (SurveyQuestion[i].IsConditionQuestion == true)
                    //    object.ParentSectionId = SurveyQuestion[i].IsConditionQuestion == true ? SurveyQuestion[i].ConditionSectionId : SurveyQuestion[i].SectionId;
                    object.TotCount = SurveyQuestion[i].TotCount;
                    object.IsRepeatSection = SurveyQuestion[i].IsRepeatSection;
                    object.RepeatSectionId = SurveyQuestion[i].RepeatSectionId;
                    object.FieldVar = SurveyQuestion[i].FieldVar;
                    object.FormulaExpression = SurveyQuestion[i].FormulaExpression;
                    object.IsFormulaQuestion = SurveyQuestion[i].IsFormulaQuestion;
                    object.IsSearchable = SurveyQuestion[i].IsSearchable;
                    object.DefaultValue = SurveyQuestion[i].DefaultValue;
                    object.HierarchyQuestionOrder = SurveyQuestion[i].HierarchyQuestionOrder;
                    object.MinValue = SurveyQuestion[i].MinValue;
                    object.MaxValue = SurveyQuestion[i].MaxValue;
                    object.TextLength = SurveyQuestion[i].TextLength;
                    object.ErrorText = SurveyQuestion[i].ErrorText;
                    object.RegEx = SurveyQuestion[i].RegEx;
                    object.ValidationCondition = SurveyQuestion[i].ValidationCondition;
                    object.RepeatOrder = 0;
                    object.SubRepeatOrder = null;
                    object.IsMandatory = SurveyQuestion[i].IsMandatory;
                    if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" ||object.QuestionType == "Datalist") {
                        object.Options = await this.GetQuestionOptions(SurveyQuestion[i].QuestionText, object.QuestionType)
                    } else if (object.QuestionType == "Dropdown" || object.QuestionType == 'ConditionalDropdown') {
                        object.DrpDwnopt = await this.GetQuestionOptions(SurveyQuestion[i].QuestionText, object.QuestionType)
                    }
                    else if (object.QuestionType == "masterdb") {
                        object.DrpDwnopt = await this.GetMasterDBData(SurveyQuestion[i].HierarchyQuestionOrder, SurveyQuestion[i].DefaultValue)
                    }
                    SavedFormDisabledFields.forEach(item=>{
                            if(item == SurveyQuestion[i].QuestionName){
                            object.Disabled = true;
                            }
					});

                    
					if(object.validationType === "onlySpaceAlphabet") {
						object.pattern = "[^a-zA-Z ]"; 
					}else if(object.validationType === "onlyAlphabet"){
						object.pattern = "[^a-zA-Z ]";
					} else if(object.validationType === "AlphaNumeric") {
						object.pattern = "[^a-zA-Z0-9]";
					}else if(object.validationType === "onlyEmailId") {
						object.pattern = "[^a-zA-Z0-9@._]";
					}
                    object.Answers = [];
                    object.FileName = "";
                    object.longitude = "";
                    object.latitude = "";
                    object.OrginalFileName = "";
                    object.Blob = [];
                    object.arrFileName = [];

                    var RepeatQuestionCount = await db.TbSurveyQuestions.where({ RepeatSectionId: object.SectionId }).count();

                    var Answers = await this.GetSectionAnswer(object.QuestionID, FormId, object.QuestionType);

                    if (Answers != null && Answers.length > 0 && RepeatQuestionCount == 0) {

                        switch (object.QuestionType) {
                            case "Text":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
							case "Label":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "MultiLineText":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "Number":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                    if(Answers[0].Answer != 0){
                                      object.Answers = parseInt(Answers[0].Answer);
									} else {
                                        object.Answers = Answers[0].Answer;
									}
                                }
                                break;
							case "ResidencePeriod":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
									var period = object.Answers.split("-");
									this.years_period = period[0];
									this.months_period = period[1];
                                }
                                break;
                            case "Date":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "IssuanceDate":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "ExpiryDate":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "CheckBox":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                    object.OptionID = Answers[0].OptionID;
                                }
								if(object.QuestionText === "Interest") {
									setTimeout(() => {
										$("#IntrestSpecify_layout").hide();},1000);
									if(object.Answers && object.Answers.length>0) {
										for(var k=0;k<object.Answers.length;k++){
											if(object.Answers[k] == "Other"){
												setTimeout(() => {
												$("#IntrestSpecify_layout").show();},1000);
												}
										}
									}
								}
                                break;
                            case "Dropdown":

                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                    //var splt = Answers[0].Answer.split("-");
									var splt = null;
                                    if (splt != null && splt.length > 1) {
                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                    } else {
                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                    }
                                }
								if(object.QuestionName === "Marital Status") {
									if(object.Answers.OptionValue == "Married") {
										setTimeout(() => {
											$("#SpouseName_layout").show();},1000);
									} else {
										setTimeout(() => {
										$("#SpouseName_layout").hide();},1000);
									}
								}
								
								
                                break;
                                case "ConditionalDropdown":

                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                    var splt1 = Answers[0].Answer.split("-")
                                    if (splt1 != null && splt1.length > 1) {
                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": splt1[1] })
                                    } else {
                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                    }
                                }
                                break;
                            case "Radio":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                    object.Answers = Answers[0].Answer;
                                }
                                break;
                            case "Yes/No":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
                                    object.Answers = parseInt(Answers[0].Answer);
                                }
								if(object.QuestionText === "IsAccountPresent") {
									if(object.Answers == 1) {
										setTimeout(() => {
											$("#AccountNumber_layout").show();},1000);
										} else {
											setTimeout(() => {
												$("#AccountNumber_layout").hide();},1000);
											}
									}
								
                                break;
                            case "Image":
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                }
                                break;
                            case "CaptureImage":
                                
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                    object.arrFileName = Answers[0].OrginalFileName.split(",");
                                }
                                // if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                //     doc.text(object.QuestionName + ":-", 10, vacharheight);
                                //     vacharheight = vacharheight + 8;
                                //     object.Answers = Answers[0].Answers
                                //     object.OrginalFileName = Answers[0].OrginalFileName;
                                //     object.Blob = Answers[0].Blob;
                                //     var base64 = await this.ConverttoBase64(object.Blob[0]);

                                //     doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                //     vacharheight = vacharheight + 40;
                                //     }
                                break;
                            case "ProofOfResidence":
                                
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                    object.arrFileName = Answers[0].OrginalFileName.split(",");
                                }
                                
                                break;
                            case "ProofOfUtilityBill":
                                
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                    object.arrFileName = Answers[0].OrginalFileName.split(",");
                                }
                                
                                break;
                            case "ProofForSourceOfFunds":
                                
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                    object.arrFileName = Answers[0].OrginalFileName.split(",");
                                }
                                
                                break;
                            case "Audio":
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers;
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                }
                                break;
                            case "Sign":
                                if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    object.Answers = Answers[0].Answers
                                    object.OrginalFileName = Answers[0].OrginalFileName;
                                    object.Blob = Answers[0].Blob;
                                }
                                break;
                            case "GPS":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
                                    object.Answers = Answers[0].Answer;
                                    var arr = Answers[0].Answer.split(",");
                                    object.latitude = arr[0];
                                    object.longitude = arr[1];
                                }
                                break;
                            case "masterdb":
                                if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
                                    var splt2 = Answers[0].Answer;
                                    splt2 = splt2.substring(splt2.indexOf("-") + 1);
                                    object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": splt2 });
                                }
                                break;
                            
                        }
                    }
                    $("input[type='date']").keydown(function (event) { event.preventDefault(); });

                    if(object.QuestionType == 'Dropdown'){

                    if(object.Answers.OptionValue){
                        if(object.Answers.OptionValue && object.QuestionText != 'Account Class(Current)'){
                            this.dispCurrentAccountClass = true;
                            this.dispSavingAccountClass= false,
                            this.dispCallAccountClass= false,
                        SurveySectionList.push(object); 
                        }
                        else if(object.Answers.OptionValue && object.QuestionText != 'Account Class(Savings)'){
                            this.dispCurrentAccountClass = false;
                            this.dispSavingAccountClass= true,
                            this.dispCallAccountClass= false,
                        SurveySectionList.push(object); 
                        }
                        else if(object.Answers.OptionValue && object.QuestionText != 'Account Class(Call)'){
                            this.dispCurrentAccountClass = false;
                            this.dispSavingAccountClass= false,
                            this.dispCallAccountClass= true,
                        SurveySectionList.push(object); 
                        } else if(object.Answers.OptionValue == 'Employed' && object.QuestionText == 'Customer Type'){
                        this.isdispEmployedLookup = true;
                        this.isdispUnEmployedLookup=false;
                        this.isdispPensionerLookup=false;
                        this.isdispSelfEmployedLookup = false;
                        this.dispDocForSourceOfFunds = true;
                        } 
                        else if(object.Answers.OptionValue == 'Unemployed' && object.QuestionText == 'Customer Type'){
                            this.isdispEmployedLookup = false;
                            this.isdispUnEmployedLookup=true;
                            this.isdispPensionerLookup=false;
                            this.isdispSelfEmployedLookup = false;
                            this.dispDocForSourceOfFunds = true;
                        }
                        else if(object.Answers.OptionValue == 'Pensioner' && object.QuestionText == 'Customer Type'){
                            this.isdispEmployedLookup = false;
                            this.isdispUnEmployedLookup=false;
                            this.isdispPensionerLookup=true;
                            this.isdispSelfEmployedLookup = false;
                            this.dispDocForSourceOfFunds = true;
                        }
                        else if(object.Answers.OptionValue == 'Self Employed' && object.QuestionText == 'Customer Type'){
                            this.isdispEmployedLookup = false;
                            this.isdispUnEmployedLookup=false;
                            this.isdispPensionerLookup=false;
                            this.isdispSelfEmployedLookup = true;
                            this.dispDocForSourceOfFunds = true;
                        }
                    }
                   else if(object.Answers.length != 0 && (object.QuestionText != 'Account Class(Current)' || object.QuestionText != 'Account Class(Savings)' || object.QuestionText != 'Account Class(Call)' ) && object.IsMandatory != 0 )
                    {
                    SurveySectionList.push(object);
                    } 
                } else {
                    SurveySectionList.push(object);
                }

                }

                return SurveySectionList;
            },
            async GetQuestionOptions(QuestionText, QuestionType) {
            var Options = [];
            var DrpDwnopt = [];

            const QuestionOptions = await db.TbQuestionOptions.where("QuestionID").equals(QuestionText).toArray();

            for (var i = 0; i < QuestionOptions.length; i++) {
                switch (QuestionType) {
                    case "CheckBox":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (var j = 0; j < QuestionOptions.length; j++) {
                                var obj = new Object();
                                obj.OptionValue = QuestionOptions[j].OptionValue;
                                obj.OptionText = QuestionOptions[j].OptionText;
                                Options.push(obj);
                            }
                            return Options;

                        }
                        break;
                    case "Datalist":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                    case "Dropdown":
                        
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                    case "Radio":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for ( j = 0; j < QuestionOptions.length; j++) {
                                 obj = new Object();
                                obj.OptionValue = QuestionOptions[j].OptionValue;
                                obj.OptionText = QuestionOptions[j].OptionText;
                                Options.push(obj);
                            }
                            return Options;
                        }
                        break;

                    case "ConditionalDropdown":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for ( j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                }
            }

            if (QuestionType == "Yes/No") {
                for (j = 1; j <= 2; j++) {
                    obj = new Object();
                    obj.OptionValue = j;
                    obj.OptionText = (j == 1 ? "Yes" : "No");
                    Options.push(obj);
                }
                return Options;

            }

            return null;
        },
            async GetMasterDBData(HierarchyQuestionOrder, DefaultValue) {

                var DrpDwnopt = [];
                var tableName = DefaultValue;
                var TableValue = [];
                if (HierarchyQuestionOrder.includes("0")) {
                    TableValue = await db.TbMasterTable.where("TableName").equals(tableName).toArray();

                    if (TableValue.length > 0) {
                        TableValue.sort((a, b) => (a.ItemName > b.ItemName) ? 1 : -1);
                    }
                    for (var index = 0; index < TableValue.length; index++) {
                        DrpDwnopt.push({ "OptionValue": TableValue[index].ItemId, "OptionText": TableValue[index].ItemName });
                    }
                    return DrpDwnopt;
                }
                return DrpDwnopt;
            },
            async GetGPSLocation(QuestionID, RepeatOrder = 0) {

                if (navigator.geolocation) {
                    var gpslocation = "";
                    navigator.geolocation.getCurrentPosition(position => {
                        gpslocation = position.coords;
                        if (gpslocation == null || gpslocation == "") {
                            alert("Google Location Service Is Disabled. Please turn on the GPS.");
                            return false;
                        }
                        else {
                            if (gpslocation.longitude != "" && gpslocation.latitude != "" && gpslocation.longitude != undefined && gpslocation.latitude != undefined) {

                                if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                                    var currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder)
                                    if (currentqst != null && currentqst.length > 0) {
                                        currentqst[0].latitude = gpslocation.longitude;
                                        currentqst[0].longitude = gpslocation.latitude;
                                        currentqst[0].Answers = gpslocation.latitude + "," + gpslocation.longitude;
                                    }
                                }
                            }
                        }
                    })
                }
            },
            imagetoblob: async function (e, qstId, RepeatOrder = 0) {

var actObj = this.upload;
var arr = e.srcElement.files;
var blobObject = new Array();
actObj.blbImage = [];

if (arr.length > 5) {
    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Maximum 5 files can be uploaded.";
    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
    return false;
} else {
    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
}

if (arr != null && arr.length > 0) {
    var bytes = 0;
    var imagecount = 0;
    for (var j = 0; j < arr.length; j++) {
        bytes += arr[j].size;

        if (!arr[j].type.includes('image')) {
            imagecount++;
        }
    }

    var totsize = this.$sunidhi.bytestosize(bytes);
    var splt = totsize.split(' ');

    if (splt[1] == 'GB' || splt[1] == 'TB') {
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
        return false;
    }
    else if (splt[1] == 'MB' && splt[0] > 10) {
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
        return false;
    } else {
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
    }

    if (imagecount > 0) {
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Only Image file(s) allowed.(.jpeg,.jpg,.png,.gif etc)";
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
        return false;
    } else {
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
        document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
    }

    var currentqst = [];

    if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
        currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == qstId && x.RepeatOrder == RepeatOrder)
        if (currentqst != null && currentqst.length > 0) {
            currentqst[0].Blob = [];
            currentqst[0].OrginalFileName = "";
            currentqst[0].Answers = "";
        }
    }

    for (var i = 0; i < arr.length; i++) {
        if (arr[i].type.includes('image')) {
            await this.$sunidhi.FileCompress(arr[i], 600).then(function (blob) {
                blobObject.push(blob);
                actObj.blbImage.push(URL.createObjectURL(blob));

                if (currentqst != null) {
                    var filename1 = (arr[i].name != null ? arr[i].name.split('.')[0] + '_' + qstId + "_" + RepeatOrder + '.' + arr[i].name.split('.')[1] : arr[i].name);
                    currentqst[0].Blob.push(blob);
                    currentqst[0].OrginalFileName = currentqst[0].OrginalFileName != "" ? currentqst[0].OrginalFileName + ',' + filename1 : filename1;
                    currentqst[0].Answers = currentqst[0].Answers != "" ? currentqst[0].Answers + ',' + filename1 : filename1;
                }
            });
        }
        else {
            blobObject.push(arr[i]);
            actObj.blbImage.push(window.location.origin + "/Content/assets/images/Uploaded-File-Image.png");
        }
    }
}
},

filetoblob: async function (e, qstId, RepeatOrder = 0) {
            var blobObject = new Array();
            var actObj = this.upload;
            var arr = e.srcElement.files;
            var FileblobObject = new Array();

            actObj.FileName = [];
            actObj.blbFile = [];

            if (arr.length > 5) {
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Maximum 5 file(s) can be uploaded.";
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                return;
            }

            if (arr != null && arr.length > 0) {
                var bytes = 0;
                for (var j = 0; j < arr.length; j++) {
                    bytes += arr[j].size;
                }

                var totsize = this.$sunidhi.bytestosize(bytes);
                var splt = totsize.split(' ');

                if (splt[1] == 'GB' || splt[1] == 'TB') {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                }
                else if (splt[1] == 'MB' && splt[0] > 10) {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                } else {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
                }

                var currentqst = [];

                if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                    currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == qstId && x.RepeatOrder == RepeatOrder)
                    if (currentqst != null && currentqst.length > 0) {
                        currentqst[0].Blob = [];
                        currentqst[0].OrginalFileName = "";
                        currentqst[0].Answers = "";
                    }
                }

                var fileReader = new FileReader();
                var base64 = "";

                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].type.includes('application')) {

                            var blob = this.$sunidhi.dataURLToBlob(base64);
                            FileblobObject.push(blob);
                            actObj.blbFile.push(URL.createObjectURL(blob));
                            actObj.FileName.push(arr[i].name);

                            if (currentqst != null) {
                                var filename1 = (arr[i].name != null ? arr[i].name.split('.')[0] + '_' + qstId + "_" + RepeatOrder + '.' + arr[i].name.split('.')[1] : arr[i].name);
                                currentqst[0].Blob.push(blob);
                                currentqst[0].OrginalFileName = currentqst[0].OrginalFileName != "" ? currentqst[0].OrginalFileName + ',' + filename1 : filename1;
                                currentqst[0].Answers = currentqst[0].Answers != "" ? currentqst[0].Answers + ',' + filename1 : filename1;
                            }
                        }
                        else {
                            blobObject.push(arr[i]);
                            actObj.blbFile.push(window.location.origin + "/Content/assets/images/Uploaded-File-Image.png");
                        }
                    }
                };
                // Convert data to base64
                fileReader.readAsDataURL(arr[0]);
            }
        },
        audiotoblob: function (e) {
            var actObj = this.upload;
            actObj.blbAudio = [];
            var AudioBlobObj = new Array();
            AudioBlobObj.push(e.blob);
            actObj.blbAudio.push(URL.createObjectURL(e.blob));

            var currentqst = [];

            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionType == "Audio")
                if (currentqst != null && currentqst.length > 0) {
                    currentqst[0].Blob = [];
                    currentqst[0].OrginalFileName = "";
                    currentqst[0].Answers = "";
                }
            }

            currentqst[0].Blob = AudioBlobObj;
            currentqst[0].OrginalFileName = "Audio.mp3";
            currentqst[0].Answers = "Audio.mp3";
        },
        async GetSignaturePad(QuestionID, RepeatOrder = 0) {
      var isSaveClicked = false;
      var saveCount = 0;
      var blob = null;
      var actObj = this.upload;
      actObj.blbsignImage = [];

      document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "none";
      document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "inline";

      var saveButton = document.getElementById('save_' + QuestionID + '_' + RepeatOrder);
      var cancelButton = document.getElementById('clear_' + QuestionID + '_' + RepeatOrder);
      var canvas = document.getElementById('signature-pad_' + QuestionID + '_' + RepeatOrder);
      var closeButton = document.getElementById('btn-close_' + QuestionID + "_" + RepeatOrder);

      var currentqst = [];

      if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
        currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder);
      }

      // Initialize the signature pad
      if (canvas && canvas.getContext) {
        this.signaturePad = new SignaturePad(canvas, {
          minWidth: 3,
          maxWidth: 5,
          backgroundColor: 'rgb(255, 255, 255)',
        });
      } else {
        console.error('Canvas element or context not found');
      }

      // Event listener to clear the signature pad
      cancelButton.addEventListener('click', () => {
        this.signaturePad.clear();
      });

      // Event listener to close the signature pad
      closeButton.addEventListener('click', () => {
        document.getElementById('signaturepaddiv_' + QuestionID + "_" + RepeatOrder).style.display = "none";
        document.getElementById('btnsignaturepad_' + QuestionID + "_" + RepeatOrder).style.display = "inline";
      });

      // Event listener to save the signature
      saveButton.addEventListener('click', () => {
    if (!isSaveClicked) {
      if (this.signaturePad.isEmpty()) {
        alert("Please provide a signature first.");
        saveCount = 1;
      } else {
        var dataURL = this.signaturePad.toDataURL("image/jpeg");
        blob = this.$sunidhi.dataURLToBlob(dataURL);
        if (currentqst != null && currentqst.length > 0) {
          currentqst[0].Blob = [blob];
          currentqst[0].OrginalFileName = "Signature_" + QuestionID + "_" + RepeatOrder + ".jpeg";
          currentqst[0].Answers = currentqst[0].OrginalFileName;

          document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "none";
          document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "inline";
          if (saveCount === 0) {
            alert("Signature successfully saved!");
            saveCount = 1;
          }
        }
      }
    }
  });
    },


    // async GetSignaturePad() {
    //   if (!this.signaturePad) {
    //     this.initializeSignaturePad();
    //   }
    //   // Your logic to use signaturePad
    // },
        async GetOptionIfYes_No(QuestionID, ConditionValue) {

            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                var currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID)
                if (currentqst != null && currentqst.length > 0) {
                    currentqst[0].Answers = "";

                    var answer = 0;
                    switch (ConditionValue) {
                        case "No":
                            answer = 2;
                            break;
                        case "Yes":
                            answer = 1;
                            break;
                        default:
                            answer = currentqst[0].Answers
                    }

                    currentqst[0].Answers = answer
                }
            }

        },
        async NextSectionQuestions(surveyId, sectionOrder) {
            // debugger
            var sessionExpired = false;
            sessionExpired = await this.$sunidhi.formsSessionTimeout();
            console.log("session", sessionExpired);
            if (sessionExpired) {
                return false;
            }
            else if (!sessionExpired) {
                var errorCount = await this.ValidateCurrentForm();
                if (errorCount > 0) {
                    return false;
                }
                else {

                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Date of Birth') {
                            const currentDate = new Date();
                            console.log("currentDate:", currentDate);
                            // Calculate the birth date from the provided DOB
                            const birthDate = new Date(this.CurrentSectionQuestions[0].Questions[i].Answers);
                            console.log("birthDate:", birthDate)
                            // Calculate the age by subtracting the birth year from the current year
                            const age = currentDate.getFullYear() - birthDate.getFullYear();
                            console.log("age:", age)
                            // Check if the age is less than 18
                            if (age < 18) {
                                // errorcount++;
                                this.isMinor = true;
                                this.ErrorMessage = "Minimum age to open account should be greater than 18. Kindly check your DOB and Resubmit."
                                this.dialogError = true;


                            } else {
                                this.isMinor = false;
                            }

                        }
                    }

                    if (this.isMinor == false) {

                        this.SelectedSection = sectionOrder;

                        if (sectionOrder > this.SelectedSection) {
                            var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 2]);
                            if (ss != null && ss.length > 0) {
                                ss[0].Questions = this.CurrentSectionQuestions[0].Questions;

                            }
                        }

                        if (this.SelectedSection == this.SurveySectionList.length) {
                            this.dispProcessBtn = true;
                        }
                        this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
                    }
                }
            }
        },
        // async PreviousSectionQuestions(surveyId, sectionOrder) {
        //     // debugger
        //     if (this.SelectedSection == 1) {
        //         this.ActiveAddQuestPopup = false;

        //     } else {
        //         if (this.isResidenceProofModalVisible || this.isUtilityBillModalVisible || this.isSourceOfFundsModalVisible || this.isModalVisible) {
        //             //if any camera is open close the camera
        //             this.isResidenceProofModalVisible = false;
        //             this.isUtilityBillModalVisible = false;
        //             this.isSourceOfFundsModalVisible = false;
        //             this.isModalVisible = false;
        //             if (null != cameraStream) {
        //                 cameraStream.getTracks().forEach(function (track) {
        //                     track.stop();
        //                 });
        //                 cameraStream = null;
        //             }
        //         }
        //         var errorCount = await this.ValidateCurrentFormToRemoveError();
        //         if (errorCount > 0) {
        //             return true;
        //         }
        //         // else {

        //         this.dispProcessBtn = false;
        //         this.SelectedSection = sectionOrder;

        //         if (sectionOrder > this.SelectedSection) {
        //             var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 2]);
        //             if (ss != null && ss.length > 0) {
        //                 ss[0].Questions = this.CurrentSectionQuestions[0].Questions;

        //             }
        //         }
        //         // this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
        //         this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
        //         // await this.removeValidation();
        //         setTimeout(() => {
        //             // eslint-disable-next-line no-unused-vars
        //             this.CurrentSectionQuestions[0].Questions.forEach(item => {
                        
        //             });
        //             $("input[type='date']").keydown(function (event) { event.preventDefault(); });
        //         }, 0);
        //     }
        // },
        async ValidateCurrentFormToRemoveError() {
            // debugger
            var QstList = this.CurrentSectionQuestions[0].Questions;
            var errorcount = 0;

            for (var i = 0; i < QstList.length; i++) {
                var item = QstList[i];
                var ageval = 0;
                switch (item.QuestionType) {
                    case "CheckBox":
                        if (item.IsMandatory) {


                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                                var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Dropdown":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "ConditionalDropdown":
                        // if (item.IsMandatory && item.QuestionName == msgLBL.BOK_FORM_PAGE_DUAL_CITIZENSHIP_MSG && this.dispDualCitizen == true) {
                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }
                        // }

                        break;
                    case "Radio":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            } else if (item.Answers == "Yes" || item.Answers == "No") {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined" || item.Answers != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "Number":

                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers != null && item.Answers != "" && item.Answers.length != 0 || (item.QuestionID == 36)) {
                            if (item.MinValue > 0 || item.MaxValue > 0) {
                                if (item.Answers != "" && item.Answers != 0) {
                                    if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                            var regex = new RegExp(item.RegEx);

                                            if (!(regex.test(item.Answers))) {
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                            }
                                        }
                                    }
                                }
                            }

                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                ((item.Answers != null || item.Answers != "" || item.Answers.length != "undefined") || item.Answers.length != 0) && ageval == 0) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                if (!result) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        break;
                    case "Text":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "ConditionalText":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }


                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                        result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "EmpConditionalText":
                        if (item.IsMandatory && this.dispEmpName == true) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Date":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "IssuanceDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ExpiryDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "Yes/No":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined")) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Image":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "CaptureImage":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Audio":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Sign":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "GPS":
                        if (item.IsMandatory) {
                            if (item.latitude.length == 0 || item.longitude.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "masterdb":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    // default:
                    // code block
                }
            }


            return errorcount;
        },
        // eslint-disable-next-line no-unused-vars
        async GetHierarchyDrpdwn(QuestionID, SurveyId) {

            var ParentDrpdwnValue = [];
            ParentDrpdwnValue = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);
            if (ParentDrpdwnValue.length == 0) {
                // datap
                ParentDrpdwnValue = this.SurveyQuestionList[0].Questions.filter(x => x.optionIfYes.length > 0);
                ParentDrpdwnValue = ParentDrpdwnValue[0].optionIfYes[0].IfYesQuestions.filter(x => x.QuestionID == QuestionID);
            }

            var HierarchyQuestionOrder = ParentDrpdwnValue[0].HierarchyQuestionOrder.split(';')[0] + ';' + (parseInt(ParentDrpdwnValue[0].HierarchyQuestionOrder.split(';')[1]) + 1);
            //var DependentQuestion = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
            var DependentQuestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.HierarchyQuestionOrder == HierarchyQuestionOrder);

            if (DependentQuestion.length > 0) {
                var heirarchy1 = HierarchyQuestionOrder;
                var DependentQuestion1 = this.CurrentSectionQuestions[0];
                var k = 1;

                while (k > 0) {
                    // eslint-disable-next-line no-redeclare
                    var DependentQuestion1 = this.CurrentSectionQuestions[0];
                    if (DependentQuestion1 != null && DependentQuestion1.Questions.length > 0) {
                        var DependentQuestion2 = DependentQuestion1.Questions.filter(x => x.HierarchyQuestionOrder == heirarchy1);

                        if (DependentQuestion2.length == 0) {
                            k = 0;
                        }

                        if (DependentQuestion2.length > 0) {
                            for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                                if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == DependentQuestion2[0].QuestionID) {
                                    this.CurrentSectionQuestions[0].Questions[j].Answers = [];
                                    this.CurrentSectionQuestions[0].Questions[j].DrpDwnopt = [];
                                }
                            }
                        }
                    }

                    heirarchy1 = heirarchy1.split(';')[0] + ';' + (parseInt(heirarchy1.split(';')[1]) + 1);
                }
            }

            if (DependentQuestion.length > 0) {
                // if (DependentQuestion[0].QuestionType == "masterdb") {

                //     var tableName = DependentQuestion[0].DefaultValue;
                //     var TableValue = [];
                //     TableValue = await db.TbMasterTable.where("TableName").equals(tableName).toArray();
                //     TableValue = TableValue.filter(x => x.ItemParentId == ParentDrpdwnValue[0].Answers.OptionValue);

                //     if (TableValue.length > 0) {
                //         TableValue.sort((a, b) => (a.ItemName > b.ItemName) ? 1 : -1);
                //     }
                //     DrpDwnopt = [];
                //     for (var index = 0; index < TableValue.length; index++) {
                //         DrpDwnopt.push({ "OptionValue": TableValue[index].ItemId, "OptionText": TableValue[index].ItemName });
                //     }

                //     for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                //         if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == DependentQuestion[0].QuestionID) {
                //             this.CurrentSectionQuestions[0].Questions[j].Answers = [];
                //             this.CurrentSectionQuestions[0].Questions[j].DrpDwnopt = DrpDwnopt;
                //         }
                //     }
                // }
            }
        },
            // eslint-disable-next-line no-unused-vars
            async AppendSection(QuestionID, QuestionType, IsConditionQuestion, answer = "", IsRepeatSection = false, repeatOrder = 0) {
            var ConditionSectionId = 0;
            var ConditionType = 0;
            // eslint-disable-next-line no-unused-vars
            var ConditionValue = "";
            var CurrentAnswer = "";
            var ConditionMatch = false;
            // var ConditionSectionQuestions = "";
            // var surveyId = 0
            var custCategory = [];

            // to replace variabel name in Question
            var cntQuestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);




            // if(cntQuestion[0].QuestionText == "Account Type"){
            //     if(cntQuestion[0].Answers.OptionValue != ''){
            //         console.log(AccountType);
            //     }
            // }
            if (cntQuestion != null && cntQuestion.length > 0) {
                if (cntQuestion[0].FieldVar != null && cntQuestion[0].FieldVar.length > 0) {
                    var field_var = cntQuestion[0].FieldVar;
                    var answer1 = cntQuestion[0].Answers;

                    for (var n = 0; n < this.SurveySectionList.length; n++) {
                        for (var p = 0; p < this.SurveySectionList[n].Questions.length; p++) {
                            if (this.SurveySectionList[n].Questions[p].QuestionName.includes(field_var)) {
                                this.SurveySectionList[n].Questions[p].QuestionName = this.SurveySectionList[n].Questions[p].QuestionName.replace(field_var, answer1);
                            }
                        }
                    }
                }
            }


            if (IsConditionQuestion) {

                var qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);

                if (qst != null && qst.length > 0) {
                    ConditionSectionId = qst[0].ConditionSectionId;
                    ConditionType = qst[0].ConditionType; //">=";//
                    // ConditionValue = qst[0].ConditionValue1; 
                    surveyId = qst[0].SurveyID;

                    var CurrentQuestionList = this.CurrentSectionQuestions[0].Questions;

                    //if (repeatOrder == 0) {
                    //    var removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                    //    this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    //}


                    switch (QuestionType) {
                        case "CheckBox":

                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                for (var i = 0; i < qst[0].Answers.length; i++) {
                                    var QuestionOption = qst[0].Options.filter(x => x.OptionValue == qst[0].Answers[i]);
                                    if (QuestionOption != null && QuestionOption.length > 0) {
                                        CurrentAnswer = QuestionOption[0].OptionText;
                                        if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                            ConditionMatch = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            break;
                        case "Dropdown":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Radio":
                            if (eval("answer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Number":

                            CurrentAnswer = parseInt(qst[0].Answers);
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Text":
                            CurrentAnswer = qst[0].Answers;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "MultiLineText":
                            CurrentAnswer = qst[0].Answers;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Datalist":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Date":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                var spDate = qst[0].Answers.split("-");
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        case "Yes/No":
                            if (eval("answer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;

                        case "ConditionalDropdown":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;

                        case "IssuanceDate":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                spDate = qst[0].Answers.split("-");
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        case "ExpiryDate":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                spDate = qst[0].Answers.split("-");
                                // eslint-disable-next-line no-unused-vars
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        // default:
                        // code block
                    }

                    if (repeatOrder == 0 && !ConditionMatch) {
                        var removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId != ConditionSectionId);

                        var array = [];
                        var array1 = [];
                        var array2 = [];

                        var dd = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);
                        var rpt4 = dd;


                        if (dd != null && dd.length > 0) {
                            dd = dd[0].Questions.filter(x => x.IsConditionQuestion == true);
                            for (var j = 0; j < dd.length; j++) {
                                array.push(dd[j].ConditionSectionId);
                                array2.push(dd[j].ConditionSectionId);
                                //Array.prototype.push.apply(array, dd[j].ConditionSectionId);
                            }

                            if (array != null && array.length > 0) {
                                // eslint-disable-next-line no-redeclare
                                for (var j = 0; j < array.length; j++) {
                                    var id = parseInt(array[j]);
                                    var kl = this.SurveySectionList.filter(x => x.SectionId == id);

                                    if (kl != null && kl.length > 0) {
                                        kl = kl[0].Questions.filter(x => x.IsConditionQuestion == true);

                                        for (var m = 0; m < kl.length; m++) {
                                            array1.push(kl[m].ConditionSectionId);
                                            array2.push(kl[m].ConditionSectionId);
                                        }
                                    }
                                }
                            }

                            if (array1 != null && array1.length > 0) {
                                for ( j = 0; j < array1.length; j++) {

                                    id = parseInt(array1[j]);
                                    kl = this.SurveySectionList.filter(x => x.SectionId == id);

                                    if (kl != null && kl.length > 0) {
                                        kl = kl[0].Questions.filter(x => x.IsConditionQuestion == true);

                                        for (m = 0; m < kl.length; m++) {
                                            array2.push(kl[m].ConditionSectionId);
                                        }
                                    }
                                }
                            }
                        }

                        if (array2 != null && array2.length > 0) {
                            for (var k = 0; k < array2.length; k++) {
                                id = parseInt(array2[k]);
                                removedConditionquestion = removedConditionquestion.filter(x => x.SectionId != id);
                            }
                        }

                        if (rpt4 != null && rpt4.length > 0) {
                            rpt4 = rpt4[0].Questions.filter(x => x.IsRepeatSection == true);
                            var repSectionId = 0;
                            if (rpt4 != null && rpt4.length > 0) {
                                repSectionId = rpt4[0].RepeatSectionId;
                                removedConditionquestion = removedConditionquestion.filter(x => x.SectionId != repSectionId);
                            }
                        }

                        this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    }

                    if (ConditionMatch == true) {
                        var sectionQst = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);

                        var curentsectionQuestions = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == ConditionSectionId && x.RepeatOrder == repeatOrder);

                        if (sectionQst != null && sectionQst.length > 0 && curentsectionQuestions.length == 0) {

                            var position = 0;
                            // eslint-disable-next-line no-redeclare
                            for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                                if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == QuestionID && this.CurrentSectionQuestions[0].Questions[j].RepeatOrder == repeatOrder) {
                                    position = j;
                                    break;
                                }
                            }

                            position = position + 1;
                            var SectionHead = await this.GetConditionHead(ConditionSectionId, surveyId, repeatOrder);
                            this.CurrentSectionQuestions[0].Questions.splice(position, 0, SectionHead);

                            //for (var k = 0; k < sectionQst[0].Questions.length; k++) {
                            //    debugger;
                            //    sectionQst[0].Questions[k].RepeatOrder = repeatOrder;
                            //    debugger;
                            //    this.CurrentSectionQuestions[0].Questions.splice(position + k + 2, 0, sectionQst[0].Questions[k]);
                            //}

                            for (i = 0; i < sectionQst[0].Questions.length; i++) {
                                position = position + 1;
                                var object = new Object();
                                object.QuestionID = sectionQst[0].Questions[i].QuestionID;
                                object.QuestionName = sectionQst[0].Questions[i].QuestionName;
                                object.QuestionType = sectionQst[0].Questions[i].QuestionType;
                                object.QuestionOrder = sectionQst[0].Questions[i].QuestionOrder;
                                object.SurveyID = sectionQst[0].Questions[i].SurveyID;
                                object.SectionId = sectionQst[0].Questions[i].SectionId;
                                object.IsConditionQuestion = sectionQst[0].Questions[i].IsConditionQuestion;
                                object.ConditionSectionId = sectionQst[0].Questions[i].ConditionSectionId;
                                object.ConditionType = sectionQst[0].Questions[i].ConditionType;
                                object.ConditionValue1 = sectionQst[0].Questions[i].ConditionValue1;
                                object.TotCount = sectionQst[0].Questions[i].TotCount;
                                object.IsRepeatSection = sectionQst[0].Questions[i].IsRepeatSection;
                                object.RepeatSectionId = sectionQst[0].Questions[i].RepeatSectionId;
                                object.FieldVar = sectionQst[0].Questions[i].FieldVar;
                                object.FormulaExpression = sectionQst[0].Questions[i].FormulaExpression;
                                object.IsFormulaQuestion = sectionQst[0].Questions[i].IsFormulaQuestion;
                                object.IsSearchable = sectionQst[0].Questions[i].IsSearchable;
                                object.DefaultValue = sectionQst[0].Questions[i].DefaultValue;
                                object.HierarchyQuestionOrder = sectionQst[0].Questions[i].HierarchyQuestionOrder;
                                object.MinValue = sectionQst[0].Questions[i].MinValue;
                                object.MaxValue = sectionQst[0].Questions[i].MaxValue;
                                object.TextLength = sectionQst[0].Questions[i].TextLength;
                                object.ErrorText = sectionQst[0].Questions[i].ErrorText;
                                object.RegEx = sectionQst[0].Questions[i].RegEx;
                                object.ValidationCondition = sectionQst[0].Questions[i].ValidationCondition;
                                object.RepeatOrder = repeatOrder;
                                object.SubRepeatOrder = null;
                                object.IsMandatory = sectionQst[0].Questions[i].IsMandatory;

                                if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" || object.QuestionType == "Datalist") {

                                    object.Options = await this.GetQuestionOptions(sectionQst[0].Questions[i].QuestionText, object.QuestionType)
                                } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                    object.DrpDwnopt = await this.GetQuestionOptions(sectionQst[0].Questions[i].QuestionText, object.QuestionType)
                                }
                                else if (object.QuestionType == "masterdb") {
                                    object.DrpDwnopt = await this.GetMasterDBData(sectionQst[0].Questions[i].HierarchyQuestionOrder, sectionQst[0].Questions[i].DefaultValue)
                                }

                                if (CurrentQuestionList != null && CurrentQuestionList.length > 0) {
                                    var prevAnswer = CurrentQuestionList.filter(x => x.QuestionID == object.QuestionID && x.RepeatOrder == repeatOrder);

                                    if (prevAnswer != null && prevAnswer.length > 0) {

                                        object.Answers = prevAnswer[0].Answers;
                                    } else {
                                        object.Answers = [];
                                    }
                                } else {
                                    object.Answers = [];
                                }

                                object.FileName = "";
                                object.longitude = "";
                                object.latitude = "";
                                object.OrginalFileName = "";
                                object.Blob = [];
                                this.CurrentSectionQuestions[0].Questions.splice(position, 0, object);
                            }
                        }
                    } else {
                        removedConditionquestion = [];

                        if (repeatOrder > 0) {
                            for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                                if (this.CurrentSectionQuestions[0].Questions[i].SectionId == ConditionSectionId &&
                                    this.CurrentSectionQuestions[0].Questions[i].RepeatOrder == repeatOrder) {
                                    this.CurrentSectionQuestions[0].Questions[i].ConditionSectionId = "Delete";
                                }
                            }

                            removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => (x.ConditionSectionId != "Delete"));

                        } else {
                            removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => (x.SectionId != ConditionSectionId));
                        }

                        this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    }
                }
            } else if (IsRepeatSection == true) {

                qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == repeatOrder);
                var answerNumber = 0;
                var repeatSectionId = 0;
                // eslint-disable-next-line no-unused-vars
                var repeatSectionName = "";
                var surveyId = 0;


                if (qst != null && qst.length > 0) {
                    answerNumber = qst[0].Answers;
                    repeatSectionId = qst[0].RepeatSectionId;
                    surveyId = qst[0].SurveyID;

                    var repeatSection = this.SurveySectionList.filter(x => x.SectionId == repeatSectionId);

                    if (repeatSection != null && repeatSection.length > 0) {
                        // repeatSectionName = repeatSection[0].SectionName;


                        var itemstodeleted = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder > answerNumber);

                        if (itemstodeleted != null && itemstodeleted.length > 0) {
                            const dist = [...new Set(itemstodeleted.map(x => x.RepeatOrder))];

                            if (dist != null && dist.length > 0) {
                                for (j = 0; j < dist.length; j++) {
                                    var delSect = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder == dist[j]);
                                    if (delSect != null && delSect.length > 0) {
                                        for (k = 0; k < delSect.length; k++) {
                                            var thisindex = this.CurrentSectionQuestions[0].Questions.findIndex(x => x.QuestionID === delSect[k].QuestionID && x.RepeatOrder == delSect[k].RepeatOrder);
                                            this.CurrentSectionQuestions[0].Questions.splice(thisindex, 1);
                                        }
                                    }
                                }
                            }
                        }

                        position = 0;
                        for (j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                            if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == QuestionID && this.CurrentSectionQuestions[0].Questions[j].RepeatOrder == repeatOrder) {
                                position = j;
                                break;
                            }
                        }

                        for (k = 1; k <= answerNumber; k++) {

                            var subrpt = repeatOrder > 0 ? k + "_" + repeatOrder : null;
                            var isexist = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder == k && x.SubRepeatOrder == subrpt);

                            if (isexist != null && isexist.length > 0 && repeatSection != null && repeatSection[0] != null && repeatSection[0].Questions != null) {
                                position = position + (repeatSection[0].Questions.length + 1);
                            }

                            if (isexist == null || isexist.length == 0) {
                                SectionHead = await this.GetRepeatHead(repeatSectionId, surveyId, k, subrpt);
                                position = position + 1;
                                this.CurrentSectionQuestions[0].Questions.splice(position, 0, SectionHead);

                                for (i = 0; i < repeatSection[0].Questions.length; i++) {

                                    position = position + 1;
                                    object = new Object();
                                    object.QuestionID = repeatSection[0].Questions[i].QuestionID;
                                    object.QuestionName = repeatSection[0].Questions[i].QuestionName;
                                    object.QuestionType = repeatSection[0].Questions[i].QuestionType;
                                    object.QuestionOrder = repeatSection[0].Questions[i].QuestionOrder;
                                    object.SurveyID = repeatSection[0].Questions[i].SurveyID;
                                    object.SectionId = repeatSection[0].Questions[i].SectionId;
                                    object.IsConditionQuestion = repeatSection[0].Questions[i].IsConditionQuestion;
                                    object.ConditionSectionId = repeatSection[0].Questions[i].ConditionSectionId;
                                    object.ConditionType = repeatSection[0].Questions[i].ConditionType;
                                    object.ConditionValue1 = repeatSection[0].Questions[i].ConditionValue1;
                                    object.TotCount = repeatSection[0].Questions[i].TotCount;
                                    object.IsRepeatSection = repeatSection[0].Questions[i].IsRepeatSection;
                                    object.RepeatSectionId = repeatSection[0].Questions[i].RepeatSectionId;
                                    object.FieldVar = repeatSection[0].Questions[i].FieldVar;
                                    object.FormulaExpression = repeatSection[0].Questions[i].FormulaExpression;
                                    object.IsFormulaQuestion = repeatSection[0].Questions[i].IsFormulaQuestion;
                                    object.IsSearchable = repeatSection[0].Questions[i].IsSearchable;
                                    object.DefaultValue = repeatSection[0].Questions[i].DefaultValue;
                                    object.HierarchyQuestionOrder = repeatSection[0].Questions[i].HierarchyQuestionOrder;
                                    object.MinValue = repeatSection[0].Questions[i].MinValue;
                                    object.MaxValue = repeatSection[0].Questions[i].MaxValue;
                                    object.TextLength = repeatSection[0].Questions[i].TextLength;
                                    object.ErrorText = repeatSection[0].Questions[i].ErrorText;
                                    object.RegEx = repeatSection[0].Questions[i].RegEx;
                                    object.ValidationCondition = repeatSection[0].Questions[i].ValidationCondition;
                                    object.RepeatOrder = k;
                                    object.SubRepeatOrder = subrpt;
                                    object.IsMandatory = repeatSection[0].Questions[i].IsMandatory;
                                    if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" || object.QuestionType == "Datalist") {
                                        object.Options = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                    } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                        object.DrpDwnopt = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                    }
                                    else if (object.QuestionType == "masterdb") {
                                        object.DrpDwnopt = await this.GetMasterDBData(repeatSection[0].Questions[i].HierarchyQuestionOrder, repeatSection[0].Questions[i].DefaultValue)
                                    }

                                    object.Answers = [];

                                    if (repeatSection[0].Questions[i].DefaultValue != null &&
                                        repeatSection[0].Questions[i].DefaultValue != '' &&
                                        repeatSection[0].Questions[i].DefaultValue != 'undefined' &&
                                        repeatSection[0].Questions[i].QuestionType == "Text") {

                                        var defaultval = [];
                                        // eslint-disable-next-line no-redeclare
                                        for (var j = 0; j < this.SurveySectionList.length; j++) {
                                            defaultval = this.SurveySectionList[j].Questions.filter(x => x.IsConditionQuestion == false && x.IsRepeatSection == false);

                                            if (defaultval.length > 0) {
                                                defaultval = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == repeatSection[0].Questions[i].DefaultValue);
                                                break;
                                            }
                                        }

                                        if (defaultval != null && defaultval.length > 0) {
                                            defaultval = defaultval.filter(x => x.RepeatOrder == object.RepeatOrder);

                                            if (defaultval != null && defaultval.length > 0 && !Array.isArray(defaultval[0].Answers)) {
                                                object.Answers = defaultval[0].Answers;
                                            }
                                        }

                                        if (object.Answers == null || object.Answers.length == 0) {
                                            object.Answers = repeatSection[0].Questions[i].DefaultValue;
                                        }
                                    }

                                    if (repeatSection[0].Questions[i].DefaultValue != null &&
                                        repeatSection[0].Questions[i].DefaultValue != '' &&
                                        repeatSection[0].Questions[i].DefaultValue != 'undefined') {
                                        if (repeatSection[0].Questions[i].QuestionType == "Number" ||
                                            repeatSection[0].Questions[i].QuestionType == "MultiLineText") {
                                            object.Answers = repeatSection[0].Questions[i].DefaultValue;
                                        }
                                    }

                                    object.FileName = "";
                                    object.longitude = "";
                                    object.latitude = "";
                                    object.OrginalFileName = "";
                                    object.Blob = [];
                                    this.CurrentSectionQuestions[0].Questions.splice(position, 0, object);
                                }
                            }
                        }
                    }
                }
            }
            /*var isOCRField = OCRFields.filter(item =>item == cntQuestion[0].QuestionName);
            if(isOCRField.length>0){
             this.reviewerCheck = true;
            }*/


            // if(cntQuestion[0].QuestionText === "Account Type") {
            //     // setTimeout(()=>{
            // 		if(cntQuestion[0].Answers != "") {
            // 			$("#Account Class_layout").hide();
            //             console.log("1st hide");
            // 		} else {
            // 			$("#Account Class_layout").hide();
            //             console.log("2nd hide");
            // 		}
            // 	// },0);

            // } 

            else if (cntQuestion[0].QuestionText === "Interest") {
                $("#IntrestSpecify_layout").hide();
                if (cntQuestion[0].Answers && cntQuestion[0].Answers.length > 0) {
                    // eslint-disable-next-line no-redeclare
                    for (var k = 0; k < cntQuestion[0].Answers.length; k++) {
                        if (cntQuestion[0].Answers[k] == "Other") {
                            $("#IntrestSpecify_layout").show();
                        }
                    }
                }
            }

            else if (cntQuestion[0].QuestionName == "Nationality") {
                var NationalityValue = cntQuestion[0].Answers.OptionValue;
                // if(NationalityValue == 'Botswana'){
                // eslint-disable-next-line no-redeclare
                for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                    if (NationalityValue == 'Botswana') {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Number" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Expiry Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Country") {

                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            this.CurrentSectionQuestions[0].Questions[i].hide = true;
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            document.getElementById("lbl_" + this.CurrentSectionQuestions[0].Questions[i].QuestionID + "_" + this.CurrentSectionQuestions[0].Questions[i].RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + this.CurrentSectionQuestions[0].Questions[i].QuestionID + "_" + this.CurrentSectionQuestions[0].Questions[i].RepeatOrder).style.display = "none";

                        } if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "National ID Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: 'Botswana', OptionText: 'Botswana' };

                        }
                    } else if (NationalityValue != 'Botswana') {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Number" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Expiry Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
                            this.CurrentSectionQuestions[0].Questions[i].hide = false;
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';

                        }
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "National ID Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';

                        }
                    }
                }
                // } 
            }

            // else if (cntQuestion[0].QuestionName === "Marital Status") {
            //     var MaritalStatusValue = cntQuestion[0].Answers.OptionValue;
                
            // }


            else if (cntQuestion[0].QuestionName === "Customer Type") {
                var custCategoryValue = cntQuestion[0].Answers.OptionValue;
                if (custCategoryValue == "Employed") {
                    this.isdispEmployedLookup = true;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                           
                        }


                    }
                } else if (custCategoryValue == "Unemployed") {
                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = true;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            
                        }

                    }
                } else if (custCategoryValue == "Pensioner") {

                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = true;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                       

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                           
                        }


                    }
                }
                else if (custCategoryValue == "Self Employed") {

                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = true;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 1;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            // await db.TbSurveyQuestions.where({QuestionID: 59}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                        }



                    }

                } else {
                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;

                    this.dispDocForSourceOfFunds = false;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            // await db.TbSurveyQuestions.where({QuestionID: 59}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 60}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 63}).delete();
                        }




                    }
                }

            }

            else if (cntQuestion[0].QuestionName == "Source of Funds / Income Proof") {
                if (this.isdispEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // for(var j=0; j< this.CurrentSectionQuestions[0].Questions.length; j++){
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 1;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }

                        // await db.TbSurveyQuestions.where({QuestionID: 60}).delete();
                        // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                        // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                        // }
                    }

                }
                else if (this.isdispUnEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // for(var j=0; j< this.CurrentSectionQuestions[0].Questions.length; j++){
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 1;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
                else if (this.isdispPensionerLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }

                    }
                }
                else if (this.isdispSelfEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
                else {
                    this.dispDocForSourceOfFunds = false;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
            }
            else if (cntQuestion[0].QuestionName == "Is Physical Address same as Postal Address?") {
                var currentHouseNumber = '';
                var currentAreaTown = '';
                var currentCity = '';
                var currentState = '';
                var currentCountry = '';
                if (cntQuestion[0].Answers == null) {
                    cntQuestion[0].Answers = "No";
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;

                        }
                    }
                }
                else if (cntQuestion[0].Answers.length > 0) {
                    if (cntQuestion[0].Answers == "yes") {

                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Current)') {
                                currentHouseNumber = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Current)') {
                                currentAreaTown = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Current)') {
                                currentCity = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Current)') {
                                currentState = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }

                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Current)') {
                                currentCity = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'District(Current)') {
                                currentState = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Current)') {
                                currentCountry = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                        }


                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentHouseNumber;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentAreaTown;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCity;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            } if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCity;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'District(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentState;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentState;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCountry;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                        }
                    }
                    else if (cntQuestion[0].Answers == "no" || cntQuestion[0].Answers == null) {
                        cntQuestion[0].Answers = "No";
                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                                || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'
                                || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = false;

                            }
                        }
                    }


                }
                else if (cntQuestion[0].Answers.length == 0) {
                    cntQuestion[0].Answers = "No";
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;

                        }
                    }
                }
            }

            else if (cntQuestion[0].QuestionName === "Account Class") {
                var AcctClassValue = cntQuestion[0].Answers.OptionValue;
                if (this.dispTransactionalAccountClass == true) {
                    if (this.$sunidhi.TransactionalAccountClass.length > 0) {
                        custCategory = this.$sunidhi.TransactionalAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    } else if (this.$sunidhi.TransactionalAccountClass.length == 0) {
                        await this.$sunidhi.getTransactionalAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.TransactionalAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    }
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }
                if (this.dispCurrentAccountClass == true) {
                    if (this.$sunidhi.CurrentAccountClass.length > 0) {

                        custCategory = this.$sunidhi.CurrentAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    } else if (this.$sunidhi.CurrentAccountClass.length == 0) {
                        await this.$sunidhi.getCurrentAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.CurrentAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }

                    // eslint-disable-next-line no-redeclare
                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }

                else if (this.dispSavingAccountClass == true) {
                    if (this.$sunidhi.SavingsAccountClass.length > 0) {
                        custCategory = this.$sunidhi.SavingsAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }
                        });
                    } else if (this.$sunidhi.SavingsAccountClass.length == 0) {
                        await this.$sunidhi.getSavingsAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.SavingsAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }
                    // eslint-disable-next-line no-redeclare
                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }


                else if (this.dispCallAccountClass == true) {
                    if (this.$sunidhi.CallAccountClass.length > 0) {
                        custCategory = this.$sunidhi.CallAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }
                        });
                    } else if (this.$sunidhi.CallAccountClass.length == 0) {
                        await this.$sunidhi.getCallAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.CallAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }

                    }
                }


            }

            else if (cntQuestion[0].QuestionName === "Account Type") {

                // if(cntQuestion[0].Answers.OptionValue == null){
                //     this.dispFullKycAccountClass = false;
                // }


                if (cntQuestion[0].Answers.OptionValue == 'Savings') {

                    // await SavingsAcctClass();
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 1;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 0;

                    this.dispSavingAccountClass = true;
                    this.dispCallAccountClass = false;
                    this.dispCurrentAccountClass = false;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = false;

                }
                else if (cntQuestion[0].Answers.OptionValue == 'Current') {
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 1;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 0;
                    this.dispSavingAccountClass = false;
                    this.dispCallAccountClass = false;
                    this.dispCurrentAccountClass = true;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = false;


                }
                else if (cntQuestion[0].Answers.OptionValue == 'Call') {
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 1;
                    this.dispCurrentAccountClass = false;
                    this.dispSavingAccountClass = false;
                    this.dispCallAccountClass = true;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = true;

                    // await db.TbSurveyQuestions.where({QuestionID: "Account Class(Savings)"}).delete();

                    //  await db.TbSurveyQuestions.where({QuestionID: "Account Class(Current)"}).delete();

                    // await CallAcctClass();


                }

                //         this.CurrentSectionQuestions[0].Questions.forEach(qtn => {
                //     if(qtn.QuestionName == "Account Currency" && qtn.QuestionID == '52'){
                //                                 debugger
                //                                 if(this.isCallAcct){
                //                                     qtn.Answers =  ''
                //                                     qtn.Disabled = false
                //                                     qtn.hide = false
                //                                     qtn.IsMandatory = 1
                //                                 } else if(!this.isCallAcct){
                //                                     qtn.Answers= 'Botswana Pula'
                //                                 //    qtn.Disabled = true
                //                                 //    qtn.hide = true
                //                                    qtn.IsMandatory = 0
                //                                 }
                //                             }
                //    })

                // eslint-disable-next-line no-redeclare
                for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                    if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Account Currency' && this.CurrentSectionQuestions[0].Questions[i].QuestionID == '52') {
                        if (this.isCallAcct) {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: '', OptionText: '' };
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
                            //    this.CurrentSectionQuestions[0].Questions[i].hide = false;
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        }
                        if (!this.isCallAcct) {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: 'Botswana Pula', OptionText: 'Botswana Pula' };
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            //    this.CurrentSectionQuestions[0].Questions[i].hide = true;
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        }
                    }
                }



                // else if (cntQuestion[0].Answers.OptionValue == 'Transactional'){ 
                //         this.dispTransactionalAccountClass = true;
                //         this.dispCurrentAccountClass = false;
                //         this.dispSavingAccountClass=false;
                //         this.dispCallAccountClass=false;
                //     }
                // else{
                //     this.dispTransactionalAccountClass = false;
                //     this.dispCurrentAccountClass = false;
                //         this.dispSavingAccountClass=false;
                //         this.dispCallAccountClass=false;
                // }


                //     AccountClass.forEach(item =>{
                //        if(cntQuestion[0].Answers.OptionValue){
                // 			if(cntQuestion[0].Answers.OptionValue == item.LookUpValue){
                // 				this.CurrentSectionQuestions[0].Questions.forEach(qtn =>{
                // 				if(qtn.QuestionName == "Account Class"){
                // 					qtn.Answers = item.LookUpCode;
                // 				} 
                //                 // else if(qtn.QuestionName == "Account Currency") {
                // 				// 	qtn.Answers = item.CIFCode;
                // 				// }
                // 				});
                // 			} 
                // 		}
                //         else {
                // 			this.CurrentSectionQuestions[0].Questions.forEach(qtn =>{
                // 				if(qtn.QuestionName == "Account Class"){
                // 					qtn.Answers = '';
                // 				} 
                //                 // else if(qtn.QuestionName == "Account Currency") {
                // 				// 	qtn.Answers = '';
                // 				// }
                // 			});
                // 		}
                //   });


            }
        },
            async GetConditionHead(sectionId, SurveyId, repeatOrder = 0) {
                var sections = await db.TbSurveySection.where({ SectionId: sectionId }).toArray();
                var object = new Object();
                object.QuestionID = 0;
                if (sections != null && sections.length > 0) {
                    object.QuestionName = sections[0].Name;
                } else {
                    object.QuestionName = "";
                }
                object.QuestionType = "Notes";
                object.QuestionOrder = 1;
                object.SurveyID = SurveyId;
                object.SectionId = sectionId;
                object.IsConditionQuestion = false;
                object.ConditionSectionId = 0;
                object.ConditionType = null;
                object.ConditionValue1 = null;
                object.TotCount = 0;
                object.IsRepeatSection = false;
                object.RepeatSectionId = null;
                object.FieldVar = null;
                object.FormulaExpression = null;
                object.IsFormulaQuestion = false;
                object.IsSearchable = false;
                object.DefaultValue = null;
                object.HierarchyQuestionOrder = null;
                object.MinValue = 0;
                object.MaxValue = 0;
                object.TextLength = 0;
                object.ErrorText = null;
                object.RegEx = null;
                object.ValidationCondition = null;
                object.RepeatOrder = repeatOrder;
                object.SubRepeatOrder = null;
                object.IsMandatory = false;
                object.Options = [];
                object.DrpDwnopt = [];
                object.Answers = [];
                object.FileName = "";
                object.longitude = "";
                object.latitude = "";
                object.OrginalFileName = "";
                object.Blob = [];
                object.arrFileName = [];
                return object;
            },
            async GetRepeatHead(sectionId, SurveyId, RepeatOrder, SubRepeatOrder) {
                var sections = await db.TbSurveySection.where({ SectionId: sectionId }).toArray();
                var object = new Object();
                object.QuestionID = 0;
                if (sections != null && sections.length > 0) {
                    object.QuestionName = sections[0].Name + ": " + RepeatOrder;
                } else {
                    object.QuestionName = "";
                }
                object.QuestionType = "Notes";
                object.QuestionOrder = 1;
                object.SurveyID = SurveyId;
                object.SectionId = sectionId;
                object.IsConditionQuestion = false;
                object.ConditionSectionId = 0;
                object.ConditionType = null;
                object.ConditionValue1 = null;
                object.TotCount = 0;
                object.IsRepeatSection = false;
                object.RepeatSectionId = null;
                object.FieldVar = null;
                object.FormulaExpression = null;
                object.IsFormulaQuestion = false;
                object.IsSearchable = false;
                object.DefaultValue = null;
                object.HierarchyQuestionOrder = null;
                object.MinValue = 0;
                object.MaxValue = 0;
                object.TextLength = 0;
                object.ErrorText = null;
                object.RegEx = null;
                object.ValidationCondition = null;
                object.RepeatOrder = RepeatOrder;
                object.SubRepeatOrder = SubRepeatOrder;
                object.IsMandatory = false;
                object.Options = [];
                object.DrpDwnopt = [];
                object.Answers = [];
                object.FileName = "";
                object.longitude = "";
                object.latitude = "";
                object.OrginalFileName = "";
                object.Blob = [];
                object.arrFileName = [];
                return object;
            },

            async Calculation(QuestionId, IsFormulaQuestion, RepeatOrder = 0, SubRepeatOrder = null) {
            if (IsFormulaQuestion) {
                var Question = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionId && x.RepeatOrder == RepeatOrder);

                if (SubRepeatOrder != null) {
                    Question = Question.filter(x => x.SubRepeatOrder == SubRepeatOrder);
                }

                var SurveyId = 0;
                var FormulaExpression = "";

                if (Question != null && Question.length > 0) {
                    SurveyId = Question[0].SurveyID;
                    FormulaExpression = Question[0].FormulaExpression.replace("{", '(').replace("}", ')');
                }

                var isFunction = false;
                var functions = "";
                var fnsubstr = "";
                var survey = await db.TbSurvey.where("SurveyID").equals(SurveyId).toArray();
                var SurveyQuestions = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
                SurveyQuestions = SurveyQuestions.filter(x => x.FieldVar != null && x.FieldVar != "" && x.FieldVar != undefined);

                if (SurveyQuestions != null) {
                    for (var i = 0; i < SurveyQuestions.length; i++) {
                        var fieldvar = SurveyQuestions[i].FieldVar;
                        var answer = "";
                        // var QuestionRepeatOrder = 0;

                        var repeatQst = [];
                        for (var j = 0; j < this.SurveySectionList.length; j++) {
                            var dd = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == fieldvar);
                            repeatQst = dd;
                            //if (QuestionRepeatOrder > 0) {
                            //    dd = dd.filter(x => x.RepeatOrder == QuestionRepeatOrder);
                            //}

                            if (dd != null && dd.length > 0) {
                                if (RepeatOrder > 0) {
                                    dd = dd.filter(x => x.RepeatOrder == RepeatOrder);
                                }

                                if (SubRepeatOrder != null) {
                                    dd = dd.filter(x => x.SubRepeatOrder == SubRepeatOrder);
                                }

                                if (dd.length > 0 && !Array.isArray(dd[0].Answers) && dd[0].Answers > 0) {
                                    answer = dd[0].Answers;
                                }
                            }

                            var repeatAnwer = "";
                            if (repeatQst != null && repeatQst.length > 0) {

                                for (var k = 0; k < repeatQst.length; k++) {
                                    var count = k + 1;
                                    var newfiled = fieldvar + "[" + count + "]";
                                    // var regex1 = new RegExp(newfiled, "g");

                                    if (repeatQst[k].QuestionType == "CheckBox" ||
                                        repeatQst[k].QuestionType == "Radio" ||
                                        repeatQst[k].QuestionType == "Dropdown" ||
                                        repeatQst[k].QuestionType == "ConditionalDropdown"

                                    ) {

                                        if (repeatQst[k].Answers != null &&
                                            repeatQst[k].Answers > 0 || (repeatQst[k].QuestionType == "Dropdown" && repeatQst[k].Answers != null) || (repeatQst[k].QuestionType == "ConditionalDropdown" && repeatQst[k].Answers != null)) {
                                            var wer = !Array.isArray(repeatQst[k].Answers) ? repeatQst[k].Answers : repeatQst[k].Answers[0];

                                            if (repeatQst[k].QuestionType == "CheckBox" ||
                                                repeatQst[k].QuestionType == "Radio") {

                                                var SurveyQuestionOptions = await db.TbQuestionOptions.where("OptionID").equals(parseInt(wer)).toArray();

                                                if (SurveyQuestionOptions != null && SurveyQuestionOptions.length > 0) {
                                                    wer = SurveyQuestionOptions[0].OptionText;
                                                }
                                            } else if (repeatQst[k].QuestionType == "Dropdown" || repeatQst[k].QuestionType == "ConditionalDropdown") {
                                                wer = (wer != null ? wer.OptionText : wer);
                                            }

                                            if (repeatAnwer.length > 0) {
                                                repeatAnwer += "," + wer;
                                            } else {
                                                repeatAnwer += wer;
                                            }

                                            if (wer > 0) {
                                                FormulaExpression = FormulaExpression.replace(newfiled, wer);
                                            }
                                        }

                                    } else {

                                        if (repeatQst[k].Answers != null && !Array.isArray(repeatQst[k].Answers) &&
                                            repeatQst[k].Answers > 0) {

                                            wer = repeatQst[k].Answers;

                                            if (repeatAnwer.length > 0) {
                                                repeatAnwer += "," + wer;
                                            } else {
                                                repeatAnwer += wer;
                                            }

                                            if (wer > 0) {
                                                FormulaExpression = FormulaExpression.replace(newfiled, wer);
                                            }
                                        }
                                    }
                                }
                            }

                            if (fieldvar != null && fieldvar.length > 0) {
                                var indexnumber = FormulaExpression.indexOf(fieldvar);
                                var indexItem = FormulaExpression.substr(indexnumber + fieldvar.length, 1);
                                var indexItem1 = 0;
                                if (indexnumber > 0) {
                                    indexItem1 = FormulaExpression.substr(indexnumber - 1, 1);
                                }


                                if (indexItem != null && indexItem.includes("'") && indexItem1 != 0 && indexItem1.includes("'")) {
                                    if (repeatAnwer.length > 0) {
                                        FormulaExpression = FormulaExpression.replace(fieldvar, repeatAnwer);
                                    }
                                }
                            }
                        }

                        var regex = new RegExp(fieldvar, "g");
                        if (answer > 0) {
                            FormulaExpression = FormulaExpression.replace(regex, answer);
                        }
                    }
                }

                var SurveyFunction = (survey[0].FormulaFunction != null && survey[0].FormulaFunction.length > 0) ? survey[0].FormulaFunction.split('~') : "";

                if (SurveyFunction != null && SurveyFunction.length > 0) {
                    // eslint-disable-next-line no-redeclare
                    for (var j = 0; j < SurveyFunction.length; j++) {
                        fnsubstr = SurveyFunction[j].substr(0, SurveyFunction[j].indexOf('('));
                        if (fnsubstr != null && fnsubstr.length > 0 && FormulaExpression.includes(fnsubstr)) {
                            isFunction = true;
                            functions = SurveyFunction[j];
                        }
                    }
                }

                var calanswer;

                if (!isFunction) {
                    calanswer = eval(FormulaExpression);
                } else {
                    var ss = "function " + functions + ";" + FormulaExpression
                    calanswer = eval(ss);
                }

                Question[0].Answers = calanswer > 0 ? Math.round(calanswer) : calanswer;

                if (Question[0].IsConditionQuestion) {
                    this.AppendSection(Question[0].QuestionID, Question[0].QuestionType, Question[0].IsConditionQuestion, "", Question[0].IsRepeatSection)
                }
            }
        },
        async ValidateCurrentForm() {
            var QstList = this.CurrentSectionQuestions[0].Questions;
            var errorcount = 0;
            var isAccountNo = false;
            var otherSpecify = false;
            var isMarried = false;
            var isGrossCur = false;
            var isNetCur = false;
            var netId = "";
            var grossId = "";
            for (var i = 0; i < QstList.length; i++) {
                var item = QstList[i];
                var ageval = 0;
                if (item.QuestionText === "IsAccountPresent") {
                    if (item.Answers == 1) {
                        isAccountNo = true;
                    }
                }
                if (item.QuestionText === "Interest") {
                    if (item.Answers && item.Answers.length > 0) {
                        for (var k = 0; k < item.Answers.length; k++) {
                            if (item.Answers[k] == "Other") {
                                otherSpecify = true;
                            }
                        }
                    }
                }
                if (item.QuestionName === "Marital Status") {
                    if (item.Answers == "Married") {
                        isMarried = true;
                    }
                }
                if (item.QuestionName === "Gross salary currency type") {
                    // eslint-disable-next-line no-unused-vars
                    grossId = item.QuestionID;
                    if (item.Answers) {
                        isGrossCur = true;
                    }
                }
                if (item.QuestionName === "Net salary currency type") {
                    // eslint-disable-next-line no-unused-vars
                    netId = item.QuestionID;
                    if (item.Answers) {
                        isNetCur = true;
                    }
                }
                switch (item.QuestionType) {
                    case "CheckBox":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Dropdown":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Radio":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined" || item.Answers != 0)) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Number":

                        if (item.QuestionText === "AccountNumber") {
                            if (isAccountNo) {
                                if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {

                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        else if (item.IsMandatory) {


                            if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        else {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }
                        if (item.QuestionText === "ISDCode") {
                            if (item.Answers && item.Answers.length < 9 && (item.Answers.length != 0 || item.IsMandatory)) {
                                if (item.QuestionName != 'Primary Mobile Number') {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Enter valid Mobile number";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        if (item.QuestionName === "Gross salary" && item.Answers && item.Answers.length != 0) {
                            if (!isGrossCur) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Select currency type";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";

                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";

                            }
                        }
                        if (item.QuestionName === "Net salary") {
                            if (item.Answers && !isNetCur) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Select currency type";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";

                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";

                            }
                        }

                        if (item.Answers != null && item.Answers != "" && item.Answers.length != 0 || (item.QuestionID == 36)) {
                            if (item.MinValue > 0 || item.MaxValue > 0) {
                                if (item.Answers != "" && item.Answers != 0) {
                                    if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                        errorcount++;
                                        if (item.QuestionID == 36) {
                                            item.ErrorText = "";
                                            ageval++;
                                        }
                                        if (item.ErrorText == null || item.ErrorText == "") {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Value should be between " + item.MinValue + " and " + item.MaxValue;
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        } else if (item.ErrorText.length > 0) {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        }
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                            var regex = new RegExp(item.RegEx);
                                            if (!(regex.test(item.Answers))) {

                                                errorcount++;
                                                if (item.ErrorText.length > 0) {
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                                }
                                            }
                                            else {
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                            }

                                        } else {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                        }
                                    }
                                }
                            }

                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                ((item.Answers != null || item.Answers != "" || item.Answers.length != "undefined") || item.Answers.length != 0) && ageval == 0) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                if (!result) {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        if (item.QuestionName === "Address Line3 [Street no]") {
                            if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = 0;
                                item.Answers = 0;
                            }
                        }
                        break;
                    case "Text":
                        if ((item.QuestionText === "IntrestSpecify") || (item.QuestionText === "SpouseName")) {
                            if (item.IsMandatory && (item.QuestionText === "IntrestSpecify" && otherSpecify) || (item.QuestionText === "SpouseName" && isMarried)) {
                                if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        else if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers && item.Answers != '' && item.validationType == "onlyEmailId") {
                            var regEx = /^([A-Za-z0-9_.])+@([A-Za-z0-9_.])+\.([A-Za-z]{2,4})$/;
                            if (!(regEx.test(item.Answers))) {
                                errorcount++;
                                if (item.ErrorText.length > 0) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        } else {
                            if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                regex = new RegExp(item.RegEx);
                                if (!(regex.test(item.Answers))) {
                                    errorcount++;
                                    if (item.ErrorText.length > 0) {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    } else if (item.ErrorText == null && item.ErrorText == "") {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    }
                                }
                                else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "MultiLineText":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                errorcount++;
                                if (item.ErrorText.length > 0) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if (item.ValidationCondition != null && item.Answers.length > 0 && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Date":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Date is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {

                                if (item.QuestionName == "Date of Birth") {
                                    const currentDate = new Date();
                                    console.log("currentDate:", currentDate);
                                    // Calculate the birth date from the provided DOB
                                    const birthDate = new Date(item.Answers);
                                    console.log("birthDate:", birthDate)
                                    // Calculate the age by subtracting the birth year from the current year
                                    const age = currentDate.getFullYear() - birthDate.getFullYear();
                                    console.log("age:", age)
                                    // Check if the age is less than 18
                                    if (age < 18) {
                                        // errorcount++;
                                        this.isMinor = true;
                                        // this.ErrorMessage = "Minimum age to open account should be greater than 18. Kindly check your DOB and Resubmit."
                                        // this.dialogError = true;



                                    } else {
                                        this.isMinor = false;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                    }

                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }





                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "IssuanceDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.QuestionName + " is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ExpiryDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                this.expiryErrMsg = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.QuestionName + " is required";
                                // this.expiryError = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                this.expiryErrMsg = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                // this.expiryError = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Yes/No":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined")) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ResidencePeriod":
                        if (item.IsMandatory) {
                            var period = "";

                            if (this.years_period && this.months_period) {
                                if (this.years_period > 0 || this.months_period > 0) {
                                    period = this.years_period + "-" + this.months_period;
                                }
                            }
                            this.CurrentSectionQuestions[0].Questions[i].Answers = period;
                            item.Answers = period;
                            if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else {
                            period = "";
                            if (!this.years_period) {
                                this.years_period = "00"
                            }
                            if (!this.months_period) {
                                this.months_period = "00"
                            }

                            if (this.years_period && this.months_period) {
                                period = this.years_period + "-" + this.months_period;
                            }
                            this.CurrentSectionQuestions[0].Questions[i].Answers = period;
                            item.Answers = period;
                        }
                        break;
                    case "Image":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Image(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "CaptureImage":
                        //const source_proofOfidentification = $("#captureImage")[0];
                        // var resultProofOfidentification = jic.compress(source_proofOfidentification, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfidentification)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "ProofOfResidence":
                        // const source_proofOfResidence = $("#ProofOfResidence")[0];
                        // var resultProofOfResidence = jic.compress(source_proofOfResidence, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfResidence)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ProofOfUtilityBill":
                        // const source_ProofOfUtilityBill = $("#ProofOfUtilityBill")[0];
                        // var resultProofOfUtilityBill = jic.compress(source_ProofOfUtilityBill, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfUtilityBill)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ProofForSourceOfFunds":
                        // const source_ProofOfUtilityBill = $("#ProofOfUtilityBill")[0];
                        // var resultProofOfUtilityBill = jic.compress(source_ProofOfUtilityBill, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfUtilityBill)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "Audio":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Audio is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Sign":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Signature is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "GPS":
                        if (item.IsMandatory) {
                            if (item.latitude.length == 0 || item.longitude.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "GPS required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "masterdb":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    // default:
                    // code block
                }
            }


            return errorcount;
        },
        async ValidateAllForms() {
            // debugger
            var errorcount = 0;

            if (this.sectionArray != null && this.sectionArray.length > 0) {

                for (var k = 0; k < this.sectionArray.length; k++) {

                    var sections = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[k])
                    var QstList;

                    if (sections != null && sections.length > 0) {
                        QstList = sections[0].Questions;
                    }

                    if (QstList != null && QstList.length > 0) {
                        var isAccountNo = false;
                        var otherSpecify = false;
                        var isMarried = false;
                        var isGrossCur = false;
                        var isNetCur = false;
                        var netId = "";
                        var grossId = "";
                        for (var i = 0; i < QstList.length; i++) {
                            var item = QstList[i];
                            if (item.QuestionText === "IsAccountPresent") {
                                if (item.Answers == 1) {
                                    isAccountNo = true;
                                }
                            }
                            if (item.QuestionText === "Interest") {
                                if (item.Answers && item.Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    for (var k = 0; k < item.Answers.length; k++) {
                                        if (item.Answers[k] == "Other") {
                                            otherSpecify = true;
                                        }
                                    }
                                }
                            }

                            if (item.QuestionName === "Marital Status") {
                                if (item.Answers == "Married") {
                                    isMarried = true;
                                }
                            }

                            if (item.QuestionName === "Gross salary currency type") {
                                // eslint-disable-next-line no-unused-vars
                                grossId = item.QuestionID;
                                if (item.Answers) {
                                    isGrossCur = true;
                                }
                            }
                            if (item.QuestionName === "Net salary currency type") {
                                // eslint-disable-next-line no-unused-vars
                                netId = item.QuestionID;
                                if (item.Answers) {
                                    isNetCur = true;
                                }
                            }
                            switch (item.QuestionType) {
                                case "CheckBox":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Dropdown":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Datalist":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Radio":
                                    if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Number":
                                    if (item.QuestionText === "AccountNumber") {
                                        if (isAccountNo) {
                                            if (item.Answers == null || item.Answers.toString() == "" || item.Answers.length == 0) {
                                                errorcount++;
                                            }
                                        }
                                    }
                                    else if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                            errorcount++;
                                        }
                                    }
                                    if (item.QuestionText === "ISDCode" && item.Answers && item.Answers.length < 9 && (item.Answers.length != 0 || item.IsMandatory)) {
                                        if (item.QuestionName != "Primary Mobile Number") {
                                            errorcount++;
                                        }

                                    }
                                    if (item.QuestionName === "Gross salary" && item.Answers && item.Answers.length != 0) {
                                        if (!isGrossCur) {
                                            errorcount++;
                                        }

                                    }
                                    if (item.QuestionName === "Net salary") {
                                        if (item.Answers && !isNetCur) {
                                            errorcount++;
                                        }
                                    }
                                    if (item.Answers != null && item.Answers != "" && item.Answers.length != 0) {
                                        if (item.MinValue > 0 || item.MaxValue > 0) {
                                            if (item.Answers != "" || item.Answers != 0) {
                                                if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                                    errorcount++;

                                                } else {
                                                    if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 &&
                                                        (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                                        var regex = new RegExp(item.RegEx);
                                                        if (!(regex.test(item.Answers))) {
                                                            errorcount++;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case "Text":
                                    if ((item.QuestionText === "IntrestSpecify") || (item.QuestionText === "SpouseName")) {
                                        if (item.IsMandatory && (item.QuestionText === "IntrestSpecify" && otherSpecify) || (item.QuestionText === "SpouseName" && isMarried)) {
                                            if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                                errorcount++;
                                            }
                                        }
                                    } else if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }

                                    if (item.Answers && item.Answers != '' && item.validationType == "onlyEmailId") {
                                        var regEx = /^([A-Za-z0-9_.]+)@([A-Za-z0-9_.]+)\.([A-Za-z]{2,4})$/;
                                        if (!(regEx.test(item.Answers))) {
                                            errorcount++;
                                        }
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                            regex = new RegExp(item.RegEx);
                                            if (!(regex.test(item.Answers))) {
                                                errorcount++;
                                            }
                                        }
                                    }
                                    break;
                                case "MultiLineText":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }

                                    if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                        regex = new RegExp(item.RegEx);

                                        if (!(regex.test(item.Answers))) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Date":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "IssuanceDate":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "ExpiryDate":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Yes/No":
                                    if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers == "" || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Image":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "CaptureImage":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Audio":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Sign":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "GPS":
                                    if (item.IsMandatory) {
                                        if (item.latitude.length == 0 || item.longitude.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "masterdb":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "ConditionalDropdown":
                                    // if (item.IsMandatory &&item.QuestionName == msgLBL.BOK_FORM_PAGE_DUAL_CITIZENSHIP_MSG && this.dispDualCitizen == true) {
                                    //     if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                    //         errorcount++;
                                    //     }
                                    // }
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                // default:
                                // code block
                            }
                        }
                    }
                }
            }

            return errorcount;
        },
            async SubmitSurveyFom(IsDirectSubmit = false) {

                clearInterval(this.intervalid1);
                this.$sunidhi.backbuttonpressed = false;
                var errorCount = 0;
                var UserId = 0;
                this.showProcessMsg = false;
				// console.log(IsDirectSubmit);

                if (IsDirectSubmit) {
                    await this.GetSurveySections(this.SelectedSurveyID, this.SelectedFormID, 0, false, true);
                }

                errorCount = await this.ValidateCurrentForm();

                if (errorCount > 0) {
                    return false;
                } else {
                    errorCount = await this.ValidateAllForms();

                    if (errorCount > 0) {
                        this.ErrorMessage = "Please fill all mandatory questions in all sections before submitting the form !";
                        this.dialogError = true;
                        return false;
                    } else {
                        if (localStorage) {
                            UserId = localStorage.getItem("UserId");
                        }
						
                        this.SaveToClientDB(this.SurveySectionList, UserId, true, false, this.sectionArray, this.SelectedFormID, 0);
						$("#submit-btn").attr("disabled",true);
						$("#submit-btn").removeClass("primary-btn");
						$("#submit-btn").addClass("grey lighten-2");
						$("#submit-btn").css("color","black");
                    }
                }
            },
            async SaveAndExitForm() {
                this.$sunidhi.backbuttonpressed = false;
                var errorCount = 0;
                var UserId = 0;

                errorCount = await this.ValidateCurrentForm();

                if (errorCount > 0) {
                    return false;
                } else {
                    if (localStorage) {
                        UserId = localStorage.getItem("UserId");
                    }

                    var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[this.SelectedSection - 1]);

                    if (ss != null && ss.length > 0) {
                        ss[0].Questions = this.CurrentSectionQuestions[0].Questions;
                    }

                    this.SaveToClientDB(this.SurveySectionList, UserId, false, true, this.sectionArray, this.SelectedFormID, 0);
                }
            },
            
            // eslint-disable-next-line no-unused-vars
        async SaveToClientDB(SurveySectionList, UserId, IsSubmitted, IsSaved, SectionList, FormId = 0, EntryId = 0) {
            this.uploadSuccess = [];
            // var unName = "";
            // var password = "";
            var userTokenID = "";

            var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata1 != null || genzdata1.length > 0) {
                // eslint-disable-next-line no-unused-vars
                userTokenID = genzdata1[0].token;
            }

            if (IsSubmitted) {
                this.processLoader = 1;
                this.SubmitProgressMessage = "Processing Form Submission to dc...";

                if (this.processedFormId > 0) {
                    await db.ClientSyncQueue.where("FormID").equals(this.processedFormId).delete();
                    await db.TbSurveyForm.where("FormID").equals(this.processedFormId).delete();
                    await db.TbAnswers.where("FormID").equals(this.processedFormId).delete();
                    this.processedFormId = 0;
                }
            }

            if (SectionList != null && SectionList.length > 0) {

                var SurveyId = 0;
                var SurveyName = 0;

                if (SurveySectionList != null && SurveySectionList.length > 0) {
                    SurveyId = SurveySectionList[0].SurveyID;
                    SurveyName = SurveySectionList[0].SurveyName;
                }

                var ID = this.$sunidhi.IDGenerator();
                var FormCount = await db.TbSurveyForm.where("SurveyID").equals(SurveyId).toArray();
                var FormName = SurveyName + '_' + (FormCount.length + 1);

                // eslint-disable-next-line no-unused-vars
                var pkId = await db.TbSurveyForm.put({ FormID: ID, Name: FormName, SurveyID: SurveyId, CreatedDate: Date(), CreatedBy: parseInt(UserId), IsActive: true, IsSubmitted: IsSubmitted, IsSaved: IsSaved, UserID: parseInt(UserId) });

                for (var i = 0; i < SectionList.length; i++) {
                    var Section = SurveySectionList.filter(x => x.SectionId == SectionList[i]);

                    if (Section != null && Section.length > 0 &&
                        Section[0].Questions != null && Section[0].Questions.length > 0) {

                        ///  Insert into TbSurveyAnswers Table
                        for (var j = 0; j < Section[0].Questions.length; j++) {
                            var item = Section[0].Questions[j];

                            if (item.QuestionType == "Dropdown" || item.QuestionType == "masterdb" || item.QuestionType == "ConditionalDropdown") {
                                if (Object.keys(item.Answers).length > 0) {
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers.OptionValue, OptionID: item.Answers.OptionValue, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: null, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: null, Blob: null });
                                }
                            }
                            else if (item.QuestionType == "Image" || item.QuestionType == "Audio" || item.QuestionType == "Sign") {
                                if (item.Blob.length > 0 && item.OrginalFileName != "") {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            else if (item.QuestionType == "CaptureImage" || item.QuestionType == "ProofOfResidence" || item.QuestionType == "ProofOfUtilityBill" || item.QuestionType == "ProofForSourceOfFunds") {
                                if (item.Blob.length > 0) {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            else if (item.QuestionType == "CheckBox" || item.QuestionType == "Radio") {
                                if (item.Answers.length == 0) {
                                    item.Answers = "No";
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                } else {
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }

                            }
                            else if (item.Answers > 0 || item.Answers.length > 0) {

                                if (item.Answers instanceof Array) {

                                    if (typeof item.Answers[item.Answers.length - 1] != 'string') {

                                        AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                    else {
                                        AnswerID = await db.TbAnswers.put({ Answer: item.Answers[item.Answers.length - 1], QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                }
                                else {
                                    if (item.QuestionName == "First Name" || item.QuestionName == "Last Name" || item.QuestionName == "Name on Debit card") {
                                        item.Answers = (item.Answers != null && item.Answers != undefined) ? item.Answers.toUpperCase() : "";
                                    }

                                    // eslint-disable-next-line no-unused-vars
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }
                            }
                        }
                    }
                }

                ///  Insert into ClientSyncQueue Table
                if (IsSubmitted == true) {
                    this.processLoader = 2;
                    this.SubmitProgressMessage = "Processing Form Submission to dc...2";
                    // eslint-disable-next-line no-unused-vars
                    var SyncQueuePKID = await db.ClientSyncQueue.put({ FormID: ID, SurveyID: SurveyId, CreatedDate: Date(), TagName: "SurveyForm" });
                }


                // eslint-disable-next-line no-unused-vars
                var success = false;

                if (IsSubmitted == false) {
                    //  alert("saved Successfully");
                    this.Issubmitclicked = 'False';
                    this.dialogSuccess = true;
                    this.successMessage = "saved Successfully";
                } else {

                    if (window.navigator.onLine) {
                        this.processLoader = 3;
                        this.SubmitProgressMessage = "Processing Form Submission to dc...3";
                        var response = await this.$sunidhi.submitgenz(1, ID);

                        if (response != null && response != undefined && response.Message == "Success") {

                            this.SubmitProgressMessage = "Submission Completed";
                            this.processLoader = 5;
                            this.processLoader = 6;
                            //this.submitLoading = false;
                            // this.successMessage = "Submitted Successfully,";
                            this.successMessage1 = "Submitted Successfully";
                            this.successMessage2 = "Thank you for your application,";
                            this.successMessage = "account information will be sent to the registered email / SMS.";

                            this.uploadSuccess.push("Ref No : " + response.resultStatus); //ReferenceNumber
                            this.dialogSuccess = true;
                        }
                        else {
                            this.processLoader = 6;
                            await db.TbSurveyForm.where("FormID").equals(this.processedFormId).modify({ IsSubmitted: false, IsSaved: true });
                            var err = "Sorry an error has occured. Please try after sometime. Forms Available under saved tab.";
                            this.ErrorMessage = err;
                            this.dialogError1 = true;
                            return false;
                            // alert("Form Submition Failed, Message : " + response.Message);
                        }
                        this.Issubmitclicked = 'False';
                    }
                    else {
                        await db.TbSurveyForm.where("FormID").equals(this.processedFormId).modify({ IsSubmitted: false, IsSaved: true });
                        this.processLoader = 6;
                        this.Issubmitclicked = 'False';
                        err = "Sorry an error has occured. Please try after sometime. Forms Available under saved tab.";
                        this.ErrorMessage = err;
                        this.dialogError1 = true;
                        return false;
                    }
                }

                //if (success) {
                //    window.location.reload();
                // }
            }
        },
            async CancelForm() {
                this.IsEditable = false;
                this.SurveyName = "";
                this.SurveySectionList = [];
                this.CurrentSectionQuestions = [];
                this.TotSections = 0;
                this.SelectedSection = 0;
                this.sectionArray = [];
                this.ActiveAddQuestPopup = false;
                this.SelectedFormID = 0;
                this.SelectedSurveyID = 0;
            },
            // eslint-disable-next-line no-unused-vars
            async GetSectionAnswer(QuestionId, FormId, QuestionType) {

                var Answers = await db.TbAnswers.where("QuestionID").equals(QuestionId).toArray();
                Answers = Answers.filter(x => x.FormID == FormId && (x.EntryId == undefined || x.EntryId == 0 || x.EntryId == null));
                
                return Answers;
            },
            // async DeleteForm(FormID) {
            //     var SurveyID = this.$route.params.surveyID;
            //     IsSaved = this.$route.params.IsSaved;
            //     this.TableActionPopup = false;
            //     this.FormDeleteAlert = false;

            //     if (IsSaved == "true") {
            //         var forms = await db.TbSurveyForm.where("SurveyID").equals(parseInt(SurveyID)).toArray();
            //         forms = forms.filter(x => x.FormID == FormID);
            //         await db.TbSurveyForm.where("FormID").equals(FormID).modify({ IsActive: false })

            //         window.location.reload();
            //     }
            // },
            async FillConditionSectionAndRepeatSection() {
                // this.SubCondition = [];

                if (this.sectionArray != null && this.sectionArray.length > 0) {

                    for (var i = 0; i < this.sectionArray.length; i++) {
                        var section = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[i]);

                        if (section != null && section.length > 0 &&
                            section[0].Questions != null && section[0].Questions.length > 0) {

                            for (var j = 0; j < section[0].Questions.length; j++) {

                                var item = section[0].Questions[j];

                                if (item.IsConditionQuestion) {
                                    // this.SubCondition.push(item.ConditionSectionId);

                                    var ans = "";

                                    if (item.QuestionType == "Yes/No" && item.Answers != null && item.Answers != null && item.Answers.length != 0) {
                                        ans = parseInt(item.Answers) == 1 ? "Yes" : "No";
                                    } else if (item.QuestionType == "Radio" && item.Answers != null && item.Answers.length > 0) {
                                        ans = item.Answers
                                        //var option = await db.TbQuestionOptions.where("OptionID").equals(parseInt(item.Answers)).toArray();
                                        //if (option != null && option.length > 0) {
                                        //    ans = option[0].OptionText;
                                        //}
                                    }

                                    await this.AppendSavedSection(item.QuestionID, item.QuestionType, item.IsConditionQuestion, ans, item.IsRepeatSection, item.SectionId);
                                } else if (item.IsRepeatSection) {
                                    await this.FillRepeatConditionAnswers(item.QuestionID, item.SectionId);
                                }
                            }
                        }
                    }
                }
            },
            async FillRepeatConditionAnswers(QuestionID, sectionId) {

                // var qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);
                var qst = [];
                // var rptArray = [];

                var section = this.SurveySectionList.filter(x => x.SectionId == sectionId);
                if (section != null && section.length > 0) {
                    qst = section[0].Questions.filter(x => x.QuestionID == QuestionID);
                }

                var answerNumber = 0;
                var repeatSectionId = 0;
                var repeatSectionName = "";
                var surveyId = 0;

                if (qst != null && qst.length > 0) {

                    answerNumber = qst[0].Answers;
                    repeatSectionId = qst[0].RepeatSectionId;
                    surveyId = qst[0].SurveyID;

                    var repeatSection = this.SurveySectionList.filter(x => x.SectionId == repeatSectionId);

                    if (repeatSection != null && repeatSection.length > 0) {
                        // eslint-disable-next-line no-unused-vars
                        repeatSectionName = repeatSection[0].SectionName;

                        var removedRepeatSection = section[0].Questions.filter(x => x.SectionId != repeatSectionId);
                        section[0].Questions = removedRepeatSection;

                        var position = 0;
                        for (var k = 0; k < section[0].Questions.length; k++) {
                            if (section[0].Questions[k].QuestionID == QuestionID) {
                                position = k;
                                break;
                            }
                        }

                        // eslint-disable-next-line no-redeclare
                        for (var k = 1; k <= answerNumber; k++) {
                            var SectionHead = await this.GetRepeatHead(repeatSectionId, surveyId, k);
                            position = position + 1;
                            section[0].Questions.splice(position, 0, SectionHead);

                            for (var i = 0; i < repeatSection[0].Questions.length; i++) {
                                position = position + 1;
                                var object = new Object();
                                object.QuestionID = repeatSection[0].Questions[i].QuestionID;
                                object.QuestionName = repeatSection[0].Questions[i].QuestionName;
                                object.QuestionType = repeatSection[0].Questions[i].QuestionType;
                                object.QuestionOrder = repeatSection[0].Questions[i].QuestionOrder;
                                object.SurveyID = repeatSection[0].Questions[i].SurveyID;
                                object.SectionId = repeatSection[0].Questions[i].SectionId;
                                object.IsConditionQuestion = repeatSection[0].Questions[i].IsConditionQuestion;
                                object.ConditionSectionId = repeatSection[0].Questions[i].ConditionSectionId;
                                object.ConditionType = repeatSection[0].Questions[i].ConditionType;
                                object.ConditionValue1 = repeatSection[0].Questions[i].ConditionValue1;
                                object.TotCount = repeatSection[0].Questions[i].TotCount;
                                object.IsRepeatSection = repeatSection[0].Questions[i].IsRepeatSection;
                                if (object.IsRepeatSection) {
                                    var obj = new Object();
                                    obj.QuestionID = object.QuestionID;
                                    obj.SectionId = object.SectionId;
                                    obj.RepeatOrder = k;
                                    this.rptSubArray.push(obj);
                                }
                                object.RepeatSectionId = repeatSection[0].Questions[i].RepeatSectionId;
                                object.FieldVar = repeatSection[0].Questions[i].FieldVar;
                                object.FormulaExpression = repeatSection[0].Questions[i].FormulaExpression;
                                object.IsFormulaQuestion = repeatSection[0].Questions[i].IsFormulaQuestion;
                                object.IsSearchable = repeatSection[0].Questions[i].IsSearchable;
                                object.DefaultValue = repeatSection[0].Questions[i].DefaultValue;
                                object.HierarchyQuestionOrder = repeatSection[0].Questions[i].HierarchyQuestionOrder;
                                object.MinValue = repeatSection[0].Questions[i].MinValue;
                                object.MaxValue = repeatSection[0].Questions[i].MaxValue;
                                object.TextLength = repeatSection[0].Questions[i].TextLength;
                                object.ErrorText = repeatSection[0].Questions[i].ErrorText;
                                object.RegEx = repeatSection[0].Questions[i].RegEx;
                                object.ValidationCondition = repeatSection[0].Questions[i].ValidationCondition;
                                object.RepeatOrder = k;
                                object.SubRepeatOrder = repeatSection[0].Questions[i].SubRepeatOrder;
                                object.IsMandatory = repeatSection[0].Questions[i].IsMandatory;
                                if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" ||object.QuestionType == "Datalist") {
                                    object.Options = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                    object.DrpDwnopt = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                }
                                else if (object.QuestionType == "masterdb") {
                                    object.DrpDwnopt = await this.GetMasterDBData(repeatSection[0].Questions[i].HierarchyQuestionOrder, repeatSection[0].Questions[i].DefaultValue)
                                }
                                object.Answers = [];
                                object.FileName = "";
                                object.longitude = "";
                                object.latitude = "";
                                object.OrginalFileName = "";
                                object.Blob = [];
                                object.arrFileName = [];

                                var Answers = await this.GetSectionAnswer(object.QuestionID, this.SelectedFormID, object.QuestionType, k);
                                Answers = (Answers != null && Answers.length > 0) ? Answers.filter(x => x.RepeatOrder == k) : Answers;

                                if (Answers != null && Answers.length > 0) {

                                    switch (object.QuestionType) {
                                        case "Text":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "MultiLineText":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "Number":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
										case "Datalist":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "Date":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "IssuanceDate":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "ExpiryDate":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "CheckBox":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                                object.OptionID = Answers[0].OptionID;
                                            }
                                            break;
                                        case "Dropdown":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "ConditionalDropdown":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "Radio":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
                                        case "Yes/No":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
                                        case "Image":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "CaptureImage":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "ProofOfResidence":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "ProofOfUtilityBill":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "ProofForSourceOfFunds":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "Audio":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers;
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "Sign":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "GPS":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                                var arr = Answers[0].Answer.split(",");
                                                object.latitude = arr[0];
                                                object.longitude = arr[1];
                                            }
                                            break;
                                        case "masterdb":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                    }
                                }

                                section[0].Questions.splice(position, 0, object);

                                if (object.IsConditionQuestion) {

                                    var ans = "";
                                    if (object.QuestionType == "Yes/No" && object.Answers != null && object.Answers > 0) {
                                        ans = parseInt(object.Answers) == 1 ? "Yes" : "No";
                                    } else if (object.QuestionType == "Radio" && object.Answers != null && object.Answers > 0) {
                                        var option = await db.TbQuestionOptions.where("OptionID").equals(parseInt(object.Answers)).toArray();
                                        if (option != null && option.length > 0) {
                                            ans = option[0].OptionText;
                                        }
                                    }

                                    // eslint-disable-next-line no-redeclare
                                    var object = await this.RepeatAppendSection(object.QuestionID, object.QuestionType, object.IsConditionQuestion, ans, object.IsRepeatSection, object.SectionId, this.RepeatOrder)

                                    if (object != null && object.Question != null && object.Questions.length > 0) {

                                        for (var p = 0; p < object.Questions.length; p++) {
                                            position += 1;
                                            section[0].Questions.splice(position, 0, object.Questions[p]);
                                        }
                                    }
                                }
                            }
                        }

                        this.SurveySectionList.filter(x => x.SectionId == sectionId)[0].Questions = section[0].Questions;
                    }
                }

            },
            async FillSubRepeatConditionAnswers() {

                // var qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);
                var QuestionID = 0;
                var sectionId = 0;
                var RepeatOrder = 0;

                if (this.rptSubArray != null && this.rptSubArray.length > 0) {

                    for (var m = 0; m < this.rptSubArray.length; m++) {

                        QuestionID = this.rptSubArray[m].QuestionID;
                        sectionId = this.rptSubArray[m].SectionId;
                        RepeatOrder = this.rptSubArray[m].RepeatOrder;

                        var qst = [];

                        //to get parent section
                        var parentSectionId = 0;
                        var dd = await db.TbSurveyQuestions.where("RepeatSectionId").equals(parseInt(sectionId)).toArray();
                        do {
                            if (dd != null && dd.length > 0) {
                                parentSectionId = dd[0].SectionId;
                                dd = await db.TbSurveyQuestions.where("RepeatSectionId").equals(parseInt(dd[0].SectionId)).toArray();
                            }
                        }
                        while (dd.length > 0);
                        //to get parent section


                        // eslint-disable-next-line no-redeclare
                        var dd = await db.TbSurveyQuestions.where("ConditionSectionId").equals(parseInt(parentSectionId)).toArray();
                        do {
                            if (dd != null && dd.length > 0) {
                                parentSectionId = dd[0].SectionId;
                                dd = await db.TbSurveyQuestions.where("ConditionSectionId").equals(parseInt(dd[0].SectionId)).toArray();
                            }
                        }
                        while (dd.length > 0);

                        var section = this.SurveySectionList.filter(x => x.SectionId == parentSectionId);
                        if (section != null && section.length > 0) {
                            qst = section[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder);
                        }

                        var answerNumber = 0;
                        var Answers = await this.GetSectionAnswer(QuestionID, this.SelectedFormID, qst[0].QuestionType, RepeatOrder);

                        if (Answers != null && Answers.length > 0) {
                            answerNumber = Answers[0].Answer;
                        }

                        var repeatSectionId = 0;
                        var repeatSectionName = "";
                        var surveyId = 0;

                        if (qst != null && qst.length > 0) {

                            //  answerNumber = qst[0].Answers;
                            repeatSectionId = qst[0].RepeatSectionId;
                            surveyId = qst[0].SurveyID;

                            var repeatSection = this.SurveySectionList.filter(x => x.SectionId == repeatSectionId);

                            if (repeatSection != null && repeatSection.length > 0) {
                                // eslint-disable-next-line no-unused-vars
                                repeatSectionName = repeatSection[0].SectionName;

                                //var removedRepeatSection = section[0].Questions.filter(x => x.SectionId != repeatSectionId);
                                //section[0].Questions = removedRepeatSection;

                                var position = 0;
                                for (var k = 0; k < section[0].Questions.length; k++) {
                                    if (section[0].Questions[k].QuestionID == QuestionID && section[0].Questions[k].RepeatOrder == RepeatOrder) {
                                        position = k;
                                        break;
                                    }
                                }

                                // eslint-disable-next-line no-redeclare
                                for (var k = 1; k <= answerNumber; k++) {
                                    var subrpt = RepeatOrder > 0 ? k + "_" + RepeatOrder : null;
                                    var SectionHead = await this.GetRepeatHead(repeatSectionId, surveyId, k, subrpt);
                                    position = position + 1;
                                    section[0].Questions.splice(position, 0, SectionHead);

                                    for (var i = 0; i < repeatSection[0].Questions.length; i++) {
                                        position = position + 1;
                                        var object = new Object();
                                        object.QuestionID = repeatSection[0].Questions[i].QuestionID;
                                        object.QuestionName = repeatSection[0].Questions[i].QuestionName;
                                        object.QuestionType = repeatSection[0].Questions[i].QuestionType;
                                        object.QuestionOrder = repeatSection[0].Questions[i].QuestionOrder;
                                        object.SurveyID = repeatSection[0].Questions[i].SurveyID;
                                        object.SectionId = repeatSection[0].Questions[i].SectionId;
                                        object.IsConditionQuestion = repeatSection[0].Questions[i].IsConditionQuestion;
                                        object.ConditionSectionId = repeatSection[0].Questions[i].ConditionSectionId;
                                        object.ConditionType = repeatSection[0].Questions[i].ConditionType;
                                        object.ConditionValue1 = repeatSection[0].Questions[i].ConditionValue1;
                                        object.TotCount = repeatSection[0].Questions[i].TotCount;
                                        object.IsRepeatSection = repeatSection[0].Questions[i].IsRepeatSection;
                                        object.RepeatSectionId = repeatSection[0].Questions[i].RepeatSectionId;
                                        object.FieldVar = repeatSection[0].Questions[i].FieldVar;
                                        object.FormulaExpression = repeatSection[0].Questions[i].FormulaExpression;
                                        object.IsFormulaQuestion = repeatSection[0].Questions[i].IsFormulaQuestion;
                                        object.IsSearchable = repeatSection[0].Questions[i].IsSearchable;
                                        object.DefaultValue = repeatSection[0].Questions[i].DefaultValue;
                                        object.HierarchyQuestionOrder = repeatSection[0].Questions[i].HierarchyQuestionOrder;
                                        object.MinValue = repeatSection[0].Questions[i].MinValue;
                                        object.MaxValue = repeatSection[0].Questions[i].MaxValue;
                                        object.TextLength = repeatSection[0].Questions[i].TextLength;
                                        object.ErrorText = repeatSection[0].Questions[i].ErrorText;
                                        object.RegEx = repeatSection[0].Questions[i].RegEx;
                                        object.ValidationCondition = repeatSection[0].Questions[i].ValidationCondition;
                                        object.RepeatOrder = k;
                                        object.SubRepeatOrder = subrpt;
                                        object.IsMandatory = repeatSection[0].Questions[i].IsMandatory;
                                        if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" ||object.QuestionType == "Datalist") {
                                            object.Options = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                        } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                            object.DrpDwnopt = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                        }
                                        else if (object.QuestionType == "masterdb") {
                                            object.DrpDwnopt = await this.GetMasterDBData(repeatSection[0].Questions[i].HierarchyQuestionOrder, repeatSection[0].Questions[i].DefaultValue)
                                        }
                                        object.Answers = [];
                                        object.FileName = "";
                                        object.longitude = "";
                                        object.latitude = "";
                                        object.OrginalFileName = "";
                                        object.Blob = [];
                                        object.arrFileName = [];

                                        // eslint-disable-next-line no-redeclare
                                        var Answers = await this.GetSectionAnswer(object.QuestionID, this.SelectedFormID, object.QuestionType, 0, subrpt);
                                        Answers = (Answers != null && Answers.length > 0) ? Answers.filter(x => x.RepeatOrder == k) : Answers;

                                        if (Answers != null && Answers.length > 0) {

                                            switch (object.QuestionType) {
                                                case "Text":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                    }
                                                    break;
                                                case "MultiLineText":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                    }
                                                    break;
                                                case "Number":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                        object.Answers = parseInt(Answers[0].Answer);
                                                    }
                                                    break;
												case "Datalist":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                                    }
                                                    break;
                                                case "Date":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                    }
                                                    break;
                                                case "IssuanceDate":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                    }
                                                    break;
                                                case "ExpiryDate":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                    }
                                                    break;
                                                case "CheckBox":
												
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                        object.OptionID = Answers[0].OptionID;
                                                    }
													
                                                    break;
                                                case "Dropdown":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                                    }
                                                    break;
                                                case "ConditionalDropdown":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                                    }
                                                    break;
                                                case "Radio":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                        object.Answers = parseInt(Answers[0].Answer);
                                                    }
                                                    break;
                                                case "Yes/No":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
                                                        object.Answers = parseInt(Answers[0].Answer);
                                                    }
													
                                                    break;
                                                case "Image":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                        object.Answers = Answers[0].Answers
                                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                                        object.Blob = Answers[0].Blob;
                                                    }
                                                    break;
                                                case "CaptureImage":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                        object.Answers = Answers[0].Answers
                                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                                        object.Blob = Answers[0].Blob;
                                                        object.arrFileName = Answers[0].OrginalFileName.split(",");
                                                    }
                                                    break;
                                                    case "ProofOfResidence":
                                                        if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                            object.Answers = Answers[0].Answers
                                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                                            object.Blob = Answers[0].Blob;
                                                            object.arrFileName = Answers[0].OrginalFileName.split(",");
                                                        }
                                                        break;
                                                    case "ProofOfUtilityBill":
                                                        if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                            object.Answers = Answers[0].Answers
                                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                                            object.Blob = Answers[0].Blob;
                                                            object.arrFileName = Answers[0].OrginalFileName.split(",");
                                                        }
                                                        break;
                                                    case "ProofForSourceOfFunds":
                                                        if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                            object.Answers = Answers[0].Answers
                                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                                            object.Blob = Answers[0].Blob;
                                                            object.arrFileName = Answers[0].OrginalFileName.split(",");
                                                        }
                                                        break;
                                                case "Audio":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                        object.Answers = Answers[0].Answers;
                                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                                        object.Blob = Answers[0].Blob;
                                                    }
                                                    break;
                                                case "Sign":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                        object.Answers = Answers[0].Answers
                                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                                        object.Blob = Answers[0].Blob;
                                                    }
                                                    break;
                                                case "GPS":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
                                                        object.Answers = Answers[0].Answer;
                                                        var arr = Answers[0].Answer.split(",");
                                                        object.latitude = arr[0];
                                                        object.longitude = arr[1];
                                                    }
                                                    break;
                                                case "masterdb":
                                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
                                                        object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                                    }
                                                    break;
                                            }
                                        }

                                        section[0].Questions.splice(position, 0, object);

                                        if (object.IsConditionQuestion) {

                                            var ans = "";
                                            if (object.QuestionType == "Yes/No" && object.Answers != null && object.Answers > 0) {
                                                ans = parseInt(object.Answers) == 1 ? "Yes" : "No";
                                            } else if (object.QuestionType == "Radio" && object.Answers != null && object.Answers > 0) {
                                                var option = await db.TbQuestionOptions.where("OptionID").equals(parseInt(object.Answers)).toArray();
                                                if (option != null && option.length > 0) {
                                                    ans = option[0].OptionText;
                                                }
                                            }

                                            // eslint-disable-next-line no-redeclare
                                            var object = await this.RepeatAppendSection(object.QuestionID, object.QuestionType, object.IsConditionQuestion, ans, object.IsRepeatSection, object.SectionId, this.RepeatOrder)

                                            if (object != null && object.Question != null && object.Questions.length > 0) {

                                                for (var p = 0; p < object.Questions.length; p++) {
                                                    position += 1;
                                                    section[0].Questions.splice(position, 0, object.Questions[p]);
                                                }
                                            }
                                        }
                                    }
                                }

                                this.SurveySectionList.filter(x => x.SectionId == parentSectionId)[0].Questions = section[0].Questions;
                            }
                        }
                    }
                }
            },
            // eslint-disable-next-line no-unused-vars
            async AppendSavedSection(QuestionID, QuestionType, IsConditionQuestion, answer = "", IsRepeatSection = false, sectionId = 0) {

                var ConditionSectionId = 0;
                var ConditionType = 0;
                var ConditionValue = "";
                var CurrentAnswer = "";
                var ConditionMatch = false;
                // eslint-disable-next-line no-unused-vars
                var ConditionSectionQuestions = "";
                var surveyId = 0

                if (IsConditionQuestion) {
                    var qst = [];

                    var section = this.SurveySectionList.filter(x => x.SectionId == sectionId);
                    if (section != null && section.length > 0) {
                        qst = section[0].Questions.filter(x => x.QuestionID == QuestionID);
                    }

                    if (qst != null && qst.length > 0) {
                        ConditionSectionId = qst[0].ConditionSectionId;
                        ConditionType = qst[0].ConditionType; //">=";//
                        // eslint-disable-next-line no-unused-vars
                        ConditionValue = qst[0].ConditionValue1; //"Option_2";//
                        surveyId = qst[0].SurveyID;

                        var removedConditionquestion = section[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                        section[0].Questions = removedConditionquestion;

                        switch (QuestionType) {
                            case "CheckBox":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    for (var i = 0; i < qst[0].Answers.length; i++) {
                                        var QuestionOption = qst[0].Options.filter(x => x.OptionValue == qst[0].Answers[i]);
                                        if (QuestionOption != null && QuestionOption.length > 0) {
                                            CurrentAnswer = QuestionOption[0].OptionText;
                                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                                ConditionMatch = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                                break;
                            case "Dropdown":
                                CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "ConditionalDropdown":
                                CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Radio":
                                if (eval("answer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Number":
                                CurrentAnswer = parseInt(qst[0].Answers);
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Text":
                                CurrentAnswer = qst[0].Answers;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
							case "Datalist":
                                CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "MultiLineText":
                                CurrentAnswer = qst[0].Answers;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Date":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    var spDate = qst[0].Answers.split("-");
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                                case "IssuanceDate":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    var spDate = qst[0].Answers.split("-");
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                            case "ExpiryDate":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    var spDate = qst[0].Answers.split("-");
                                    // eslint-disable-next-line no-unused-vars
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                            case "Yes/No":
                                if (eval("answer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            // default:
                            // code block
                        }

                        if (ConditionMatch == true) {

                            //to get parent section
                            var parentSectionId = 0;
                            var dd = await db.TbSurveyQuestions.where("ConditionSectionId").equals(parseInt(ConditionSectionId)).toArray();
                            do {
                                if (dd != null && dd.length > 0) {
                                    parentSectionId = dd[0].SectionId;
                                    dd = await db.TbSurveyQuestions.where("ConditionSectionId").equals(parseInt(dd[0].SectionId)).toArray();
                                }
                            }
                            while (dd.length > 0);
                            //to get parent section

                            var sectionQst = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);
                            var parentSection = this.SurveySectionList.filter(x => x.SectionId == parentSectionId);

                            if (sectionQst != null && sectionQst.length > 0 &&
                                parentSection != null && parentSection.length > 0) {

                                var position = 0;
                                for (var j = 0; j < parentSection[0].Questions.length; j++) {
                                    if (parentSection[0].Questions[j].QuestionID == QuestionID) {
                                        position = j;
                                        break;
                                    }
                                }
                                position += 1;
                                var SectionHead = await this.GetConditionHead(ConditionSectionId, surveyId);
                                parentSection[0].Questions.splice(position, 0, SectionHead);

                                for (var k = 0; k < sectionQst[0].Questions.length; k++) {

                                    position += 1;
                                    parentSection[0].Questions.splice(position, 0, sectionQst[0].Questions[k]);

                                    if (sectionQst[0].Questions[k].IsRepeatSection && sectionQst[0].Questions[k].Answers > 0) {
                                        var obj = await this.FillRepeatInsideConditionAnswers(sectionQst[0].Questions[k].QuestionID, sectionQst[0].Questions[k].SectionId);

                                        if (obj != null && obj.Questions != null && obj.Questions.length > 0) {

                                            for (var rptCount = 0; rptCount < obj.Questions.length; rptCount++) {
                                                position = position + 1;
                                                parentSection[0].Questions.splice(position, 0, obj.Questions[rptCount]);
                                            }
                                        }
                                    }
                                }
                                this.SurveySectionList.filter(x => x.SectionId == parentSectionId)[0].Questions = parentSection[0].Questions;
                            }
                        } else {
                            // eslint-disable-next-line no-redeclare
                            var removedConditionquestion = section[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                            this.SurveySectionList.filter(x => x.SectionId == sectionId)[0].Questions = removedConditionquestion;
                        }
                    }
                }
            },
            async ValidationConditionSection(SurveyId, QuestionId) {

var validCondition = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionId)

if (validCondition != null && validCondition.length > 0) {
    validCondition = validCondition[0].ValidationCondition.replace("{", '(').replace("}", ')');
}

var isRepeatIncluded = validCondition.includes("[");

var Questions = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
Questions = Questions.filter(x => x.FieldVar != null && x.FieldVar != "" && x.FieldVar != undefined);

if (Questions != null && !isRepeatIncluded) {
    for (var i = 0; i < Questions.length; i++) {
        var fieldvar = Questions[i].FieldVar;
        var answer = "";

        for (var j = 0; j < this.SurveySectionList.length; j++) {
            var dd = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == fieldvar);
            if (dd.length > 0) {
                answer = dd[0].Answers;
            }
        }


        for (j = 0; j < this.CurrentSectionQuestions.length; j++) {
            dd = this.CurrentSectionQuestions[j].Questions.filter(x => x.FieldVar == fieldvar);
            if (dd.length > 0) {
                answer = dd[0].Answers;
            }
        }

        var textArray = [];
        if (Questions[i].QuestionType == "CheckBox" &&
            Questions[i].QuestionID == QuestionId) {

            for (var cnt = 0; cnt < answer.length; cnt++) {
                var text = await db.TbQuestionOptions.where("OptionID").equals(parseInt(answer[cnt])).toArray();
                text = (text != null && text.length > 0 ? text[0].OptionText : "");
                if (text.length > 0) {
                    textArray.push(text);
                }
            }
        }

        if (textArray.length > 0) {
            validCondition = validCondition.replace(fieldvar, textArray);
        } else {
            if (answer != null && answer != "" && (answer.length > 0 || answer > 0)) {
                validCondition = validCondition.replace(fieldvar, answer);
            }
            else {
                validCondition = validCondition.replace(fieldvar, 0);
            }
        }
    }
}

var isFunction = false;
var calanswer;

var formulafunction = await db.TbSurvey.where("SurveyID").equals(SurveyId).toArray();
var formulas = [];
if (formulafunction != null && formulafunction.length > 0 &&
    formulafunction[0].FormulaFunction != null && formulafunction[0].FormulaFunction.length > 0) {
    formulas = formulafunction[0].FormulaFunction.split('~');

    for (var k = 0; k < formulas.length; k++) {

        var substr = formulas[k].substr(0, formulas[k].indexOf('('));
        if (substr != null && substr.length > 0 && validCondition.includes(substr)) {
            isFunction = true;
            var firstfn = validCondition.split('(');
            if (firstfn != null && firstfn.length > 0) {
                firstfn = firstfn[1].split(')');
                if (firstfn != null && firstfn.length > 0) {
                    firstfn = firstfn[0].split(',');
                    for (var z = 0; z < firstfn.length; z++) {
                        firstfn[z] = !isNaN(firstfn[z]) ? parseInt(firstfn[z]) : firstfn[z];
                    }
                }
            }

            eval("var fun= function " + formulas[k]);
            // eslint-disable-next-line no-undef
            calanswer = fun.apply(this, firstfn);
        }
    }
}

if (!isFunction) {
    calanswer = eval(validCondition);
}

return calanswer;
}, 
            // eslint-disable-next-line no-unused-vars
            async RepeatAppendSection(QuestionID, QuestionType, IsConditionQuestion, answer = "", IsRepeatSection = false, sectionId = 0, repeatOrder = 0) {

                var ConditionSectionId = 0;
                var ConditionType = 0;
                var ConditionValue = "";
                var CurrentAnswer = "";
                var ConditionMatch = false;
                // eslint-disable-next-line no-unused-vars
                var ConditionSectionQuestions = "";
                var surveyId = 0

                if (IsConditionQuestion) {
                    var qst = [];

                    var section = this.SurveySectionList.filter(x => x.SectionId == sectionId);
                    if (section != null && section.length > 0) {
                        qst = section[0].Questions.filter(x => x.QuestionID == QuestionID);
                    }

                    if (qst != null && qst.length > 0) {
                        ConditionSectionId = qst[0].ConditionSectionId;
                        ConditionType = qst[0].ConditionType; //">=";//
                        // eslint-disable-next-line no-unused-vars
                        ConditionValue = qst[0].ConditionValue1; //"Option_2";//
                        surveyId = qst[0].SurveyID;

                        var removedConditionquestion = section[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                        section[0].Questions = removedConditionquestion;

                        switch (QuestionType) {
                            case "CheckBox":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    for (var i = 0; i < qst[0].Answers.length; i++) {
                                        var QuestionOption = qst[0].Options.filter(x => x.OptionValue == qst[0].Answers[i]);
                                        if (QuestionOption != null && QuestionOption.length > 0) {
                                            CurrentAnswer = QuestionOption[0].OptionText;
                                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                                ConditionMatch = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                                break;
                            case "Dropdown":
                                CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "ConditionalDropdown":
                                CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Radio":
                                if (eval("answer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Number":
                                CurrentAnswer = parseInt(qst[0].Answers);
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Text":
                                CurrentAnswer = qst[0].Answers;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
							case "Datalist":
                               CurrentAnswer = qst[0].Answers.OptionText;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "MultiLineText":
                                CurrentAnswer = qst[0].Answers;
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            case "Date":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    var spDate = qst[0].Answers.split("-");
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                            case "IssuanceDate":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    var spDate = qst[0].Answers.split("-");
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                            case "ExpiryDate":
                                if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    var spDate = qst[0].Answers.split("-");
                                    // eslint-disable-next-line no-unused-vars
                                    CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                    if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                        ConditionMatch = true;
                                    }
                                }
                                break;
                            case "Yes/No":
                                if (eval("answer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                                break;
                            // default:
                            // code block
                        }

                        if (ConditionMatch == true) {

                            var sectionQst = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);

                            if (sectionQst != null && sectionQst.length > 0) {

                                var position = 0;
                                for (var j = 0; j < section[0].Questions.length; j++) {
                                    if (section[0].Questions[j].QuestionID == QuestionID) {
                                        position = j;
                                        break;
                                    }
                                }

                                position += 1;
                                var SectionHead = await this.GetConditionHead(ConditionSectionId, surveyId);
                                section[0].Questions.splice(position, 0, SectionHead);

                                for (var k = 0; k < sectionQst[0].Questions.length; k++) {
                                    position += 1;
                                    section[0].Questions.splice(position, 0, sectionQst[0].Questions[k]);
                                }

                                //this.SurveySectionList.filter(x => x.SectionId == sectionId)[0].Questions = section[0].Questions;
                            }
                        }
                        //else {
                        //    var removedConditionquestion = section[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                        //    this.SurveySectionList.filter(x => x.SectionId == sectionId)[0].Questions = removedConditionquestion;
                        //}
                    }
                }

                return section[0].Questions;
            },
            async FillRepeatInsideConditionAnswers(QuestionID, sectionId) {

                var qst = [];

                var section = this.SurveySectionList.filter(x => x.SectionId == sectionId);
                if (section != null && section.length > 0) {
                    qst = section[0].Questions.filter(x => x.QuestionID == QuestionID);
                }

                var answerNumber = 0;
                var repeatSectionId = 0;
                var repeatSectionName = "";
                var surveyId = 0;

                if (qst != null && qst.length > 0) {

                    answerNumber = qst[0].Answers;
                    repeatSectionId = qst[0].RepeatSectionId;
                    surveyId = qst[0].SurveyID;

                    var repeatSection = this.SurveySectionList.filter(x => x.SectionId == repeatSectionId);

                    if (repeatSection != null && repeatSection.length > 0) {
                        // eslint-disable-next-line no-unused-vars
                        repeatSectionName = repeatSection[0].SectionName;

                        var removedRepeatSection = section[0].Questions.filter(x => x.SectionId != repeatSectionId);
                        section[0].Questions = removedRepeatSection;

                        var position = 0;
                        for (var k = 0; k < section[0].Questions.length; k++) {
                            if (section[0].Questions[k].QuestionID == QuestionID) {
                                position = k;
                                break;
                            }
                        }

                        // eslint-disable-next-line no-redeclare
                        for (var k = 1; k <= answerNumber; k++) {
                            var SectionHead = await this.GetRepeatHead(repeatSectionId, surveyId, k);
                            position = position + 1;
                            section[0].Questions.splice(position, 0, SectionHead);

                            for (var i = 0; i < repeatSection[0].Questions.length; i++) {
                                position = position + 1;
                                var object = new Object();
                                object.QuestionID = repeatSection[0].Questions[i].QuestionID;
                                object.QuestionName = repeatSection[0].Questions[i].QuestionName;
                                object.QuestionType = repeatSection[0].Questions[i].QuestionType;
                                object.QuestionOrder = repeatSection[0].Questions[i].QuestionOrder;
                                object.SurveyID = repeatSection[0].Questions[i].SurveyID;
                                object.SectionId = repeatSection[0].Questions[i].SectionId;
                                object.IsConditionQuestion = repeatSection[0].Questions[i].IsConditionQuestion;
                                object.ConditionSectionId = repeatSection[0].Questions[i].ConditionSectionId;
                                object.ConditionType = repeatSection[0].Questions[i].ConditionType;
                                object.ConditionValue1 = repeatSection[0].Questions[i].ConditionValue1;
                                object.TotCount = repeatSection[0].Questions[i].TotCount;
                                object.IsRepeatSection = repeatSection[0].Questions[i].IsRepeatSection;
                                object.RepeatSectionId = repeatSection[0].Questions[i].RepeatSectionId;
                                object.FieldVar = repeatSection[0].Questions[i].FieldVar;
                                object.FormulaExpression = repeatSection[0].Questions[i].FormulaExpression;
                                object.IsFormulaQuestion = repeatSection[0].Questions[i].IsFormulaQuestion;
                                object.IsSearchable = repeatSection[0].Questions[i].IsSearchable;
                                object.DefaultValue = repeatSection[0].Questions[i].DefaultValue;
                                object.HierarchyQuestionOrder = repeatSection[0].Questions[i].HierarchyQuestionOrder;
                                object.MinValue = repeatSection[0].Questions[i].MinValue;
                                object.MaxValue = repeatSection[0].Questions[i].MaxValue;
                                object.TextLength = repeatSection[0].Questions[i].TextLength;
                                object.ErrorText = repeatSection[0].Questions[i].ErrorText;
                                object.RegEx = repeatSection[0].Questions[i].RegEx;
                                object.ValidationCondition = repeatSection[0].Questions[i].ValidationCondition;
                                object.RepeatOrder = k;
                                object.SubRepeatOrder = repeatSection[0].Questions[i].SubRepeatOrder;
                                object.IsMandatory = repeatSection[0].Questions[i].IsMandatory;
                                if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" ||object.QuestionType == "Datalist") {
                                    object.Options = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                    object.DrpDwnopt = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                }
                                else if (object.QuestionType == "masterdb") {
                                    object.DrpDwnopt = await this.GetMasterDBData(repeatSection[0].Questions[i].HierarchyQuestionOrder, repeatSection[0].Questions[i].DefaultValue)
                                }
                                object.Answers = [];
                                object.FileName = "";
                                object.longitude = "";
                                object.latitude = "";
                                object.OrginalFileName = "";
                                object.Blob = [];
                                object.arrFileName = [];

                                var Answers = await this.GetSectionAnswer(object.QuestionID, this.SelectedFormID, object.QuestionType);
                                Answers = (Answers != null && Answers.length > 0) ? Answers.filter(x => x.RepeatOrder == k) : Answers;

                                if (Answers != null && Answers.length > 0) {

                                    switch (object.QuestionType) {
                                        case "Text":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "MultiLineText":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "Number":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
										case "Datalist":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "Date":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "IssuanceDate":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "ExpiryDate":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                            }
                                            break;
                                        case "CheckBox":
										
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                                object.OptionID = Answers[0].OptionID;
                                            }
                                            break;
                                        case "Dropdown":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "ConditionalDropdown":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                        case "Radio":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
                                        case "Yes/No":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
                                                object.Answers = parseInt(Answers[0].Answer);
                                            }
                                            break;
                                        case "Image":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "CaptureImage":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                            case "ProofOfResidence":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "ProofOfUtilityBill":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "ProofForSourceOfFunds":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                                object.arrFileName = Answers[0].OrginalFileName.split(",");
                                            }
                                            break;
                                        case "Audio":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers;
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "Sign":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                                object.Answers = Answers[0].Answers
                                                object.OrginalFileName = Answers[0].OrginalFileName;
                                                object.Blob = Answers[0].Blob;
                                            }
                                            break;
                                        case "GPS":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
                                                object.Answers = Answers[0].Answer;
                                                var arr = Answers[0].Answer.split(",");
                                                object.latitude = arr[0];
                                                object.longitude = arr[1];
                                            }
                                            break;
                                        case "masterdb":
                                            if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
                                                object.Answers = ({ "OptionValue": Answers[0].OptionID, "OptionText": Answers[0].Answer })
                                            }
                                            break;
                                    }
                                }

                                section[0].Questions.splice(position, 0, object);

                                if (object.IsConditionQuestion) {

                                    var ans = "";
                                    if (object.QuestionType == "Yes/No" && object.Answers != null && object.Answers > 0) {
                                        ans = parseInt(object.Answers) == 1 ? "Yes" : "No";
                                    } else if (object.QuestionType == "Radio" && object.Answers != null && object.Answers > 0) {
                                        var option = await db.TbQuestionOptions.where("OptionID").equals(parseInt(object.Answers)).toArray();
                                        if (option != null && option.length > 0) {
                                            ans = option[0].OptionText;
                                        }
                                    }

                                    // eslint-disable-next-line no-redeclare
                                    var object = await this.RepeatAppendSection(object.QuestionID, object.QuestionType, object.IsConditionQuestion, ans, object.IsRepeatSection, object.SectionId, this.RepeatOrder)

                                    if (object != null && object.Question != null && object.Questions.length > 0) {

                                        for (var p = 0; p < object.Questions.length; p++) {
                                            position += 1;
                                            section[0].Questions.splice(position, 0, object.Questions[p]);
                                        }
                                    }
                                }
                            }
                        }

                        //this.SurveySectionList.filter(x => x.SectionId == sectionId)[0].Questions = section[0].Questions;
                        return section[0].Questions;
                    }
                }
            },
            async  GeneratePDF(SurveyID, FormId) {

                var UserToken = "";
                var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                if (genzdata != null && genzdata.length > 0) {
                    if (genzdata[0].token != null && genzdata[0].token != undefined && genzdata[0].token.length > 0) {
                        UserToken = genzdata[0].token;
                    }
                }

                var referenceNumber = "";
                // eslint-disable-next-line no-unused-vars
                var splitRegex = /\r\n|\r|\n/g;
                jsPDF.API.myText = function (txt, options, x, y) {
                    options = options || {};
                    /* Use the options align property to specify desired text alignment
                     * Param x will be ignored if desired text alignment is 'center'.
                     * Usage of options can easily extend the function to apply different text
                     * styles and sizes
                    */
                    if (options.align == "center") {
                        // Get current font size
                        var fontSize = this.internal.getFontSize();

                        // Get page width
                        var pageWidth = this.internal.pageSize.width;

                        // Get the actual text's width
                        /* You multiply the unit width of your string by your font size and divide
                         * by the internal scale factor. The division is necessary
                         * for the case where you use units other than 'pt' in the constructor
                         * of jsPDF.
                        */
                        var txtWidth = this.getStringUnitWidth(txt) * fontSize / this.internal.scaleFactor;

                        // Calculate text's x coordinate
                        x = (pageWidth - txtWidth) / 2;
                    }

                    // Draw text at x,y
                    this.text(txt, x, y);
                };

                var doc = new jsPDF({ compress: true });

                var surevy = await db.TbSurvey.where({ SurveyID: SurveyID }).toArray();
                var SurveyName = (surevy != null && surevy.length > 0) ? surevy[0].SurveyName : "";

                var surevyForm = await db.TbSurveyForm.where({ FormID: FormId }).toArray();
                if (surevyForm != null && surevyForm.length > 0) {
                    // eslint-disable-next-line no-unused-vars
                    referenceNumber = surevyForm[0].ReferenceNumber;
                }

                var vacharheight = 15;
                var base64 = await this.ConverttoBase64URL('@/assets/images/Group49.png');

                doc.addImage(base64, 'PNG', 70, vacharheight, 70, 20);
                vacharheight = vacharheight + 28;

                doc.setFontSize(14);
                doc.setFontStyle('bold');
                doc.myText(SurveyName, { align: "center" }, 0, vacharheight);

                vacharheight = vacharheight + 13;

                doc.setFontSize(10);
                doc.setFontStyle('normal');
                doc.text("User ID :- " + UserToken, 10, vacharheight);
                //vacharheight = vacharheight + 7;

                vacharheight = vacharheight + 8;
                doc.setFontSize(10);
                doc.setFontStyle('normal');

                var ans3 = await db.TbSurveySection.where({ SurveyId: SurveyID }).toArray();
                var ans = (ans3 != null ? ans3.sort(function (a, b) { return a.SectionOrder - b.SectionOrder }) : ans3);

                var conditionSectionIds = await db.TbSurveyQuestions.where({ SurveyID: SurveyID }).toArray();
                conditionSectionIds = conditionSectionIds.filter(x => x.IsConditionQuestion == true);

                for (var cntid = 0; cntid < conditionSectionIds.length; cntid++) {
                    ans = ans.filter(x => x.SectionId != conditionSectionIds[cntid].ConditionSectionId);
                }

                for (var i = 0; i < ans.length; i++) {

                    var SurveyQuestion1 = await db.TbSurveyQuestions.where({ SectionId: ans[i].SectionId }).toArray();
                    SurveyQuestion1 = SurveyQuestion1.filter(x => x.QuestionType != "Notes");
                    var SurveyQuestion = (SurveyQuestion1 != null ? SurveyQuestion1.sort(function (a, b) { return a.QuestionOrder - b.QuestionOrder }) : SurveyQuestion1);

                    for (var j = 0; j < SurveyQuestion.length; j++) {

                        var object = new Object();
                        object.QuestionID = SurveyQuestion[j].QuestionID;
                        object.QuestionName = SurveyQuestion[j].QuestionName;
                        doc.setFontSize(10);
                        doc.setFontStyle('normal');
                        if (vacharheight >= doc.internal.pageSize.height - 5) {//changed from 10 to 5 ad proof of residence image got trimmed
                            console.log("enter:")
                            doc.addPage();
                            vacharheight = 25;
                        }

                        object.QuestionType = SurveyQuestion[j].QuestionType;

                        var RepeatQuestionCount = await db.TbSurveyQuestions.where({ RepeatSectionId: ans[i].SectionId }).count();

                        var Answers = await this.GetSectionAnswer(object.QuestionID, FormId, object.QuestionType);

                        if (Answers != null && Answers.length > 0 && RepeatQuestionCount == 0) {

                            switch (object.QuestionType) {
                                case "Text":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                        object.Answers = Answers[0].Answer;

                                        doc.text(object.QuestionName + " :- " + object.Answers, 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "MultiLineText":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                        object.Answers = Answers[0].Answer;

                                        if (object.Answers != null
                                            && object.Answers != undefined
                                            && object.Answers.length > 0 && object.Answers[0] != undefined) {

                                            var totchlen = object.Answers.length / 100;
                                            totchlen = Math.ceil(totchlen);

                                            for (var chlen = 0; chlen < totchlen; chlen++) {
                                                if (chlen == 0) {
                                                    doc.text(object.QuestionName + " :- " + object.Answers.substring(chlen * 100, (chlen + 1) * 100), 10, vacharheight);
                                                } else {
                                                    doc.text(object.Answers.substring(chlen * 100, (chlen + 1) * 100), 10, vacharheight);
                                                }
                                                vacharheight = vacharheight + 8;
                                            }
                                        }
                                    }
                                    break;
                                case "Number":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                        object.Answers = parseInt(Answers[0].Answer);

                                        doc.text(object.QuestionName + " :- " + object.Answers.toString(), 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
								case "Datalist":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                        object.Answers = ({ "OptionValue": parseInt(Answers[0].OptionID), "OptionText": Answers[0].Answer })

                                        if (object.QuestionID == 41 || object.QuestionID == 5 || object.QuestionID == 7 || object.QuestionID == 17 ||
                                            object.QuestionID == 18 || object.QuestionID == 21 || object.QuestionID == 22 || object.QuestionID == 52 ||
                                            object.QuestionID == 58) {
                                            var drpn = Answers[0].Answer;
                                            drpn = drpn.substring(drpn.indexOf("-") + 1);
                                            doc.text(object.QuestionName + " :- " + drpn, 10, vacharheight);

                                        } else {
                                            doc.text(object.QuestionName + " :- " + Answers[0].Answer, 10, vacharheight);
                                        }

                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "Date":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                        object.Answers = Answers[0].Answer;
                                        var d = new Date(object.Answers);
                                        doc.text(object.QuestionName + " :- " + ("0" + (d.getDate())).slice(-2) + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear(), 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "CheckBox":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
                                        object.Answers = Answers[0].Answer;
                                        object.OptionID = parseInt(Answers[0].OptionID);

                                        doc.text(object.QuestionName + " :- " + object.Answers, 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "Dropdown":
                                    
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                        object.Answers = ({ "OptionValue": parseInt(Answers[0].OptionID), "OptionText": Answers[0].Answer })

                                        // if (object.QuestionID == 41 || object.QuestionID == 5 || object.QuestionID == 7 || object.QuestionID == 17 ||
                                        //     object.QuestionID == 18 || object.QuestionID == 21 || object.QuestionID == 22 || object.QuestionID == 52 ||
                                        //     object.QuestionID == 58) {
                                        //     var drpn = Answers[0].Answer;
                                        //     drpn = drpn.substring(drpn.indexOf("-") + 1);
                                        //     doc.text(object.QuestionName + " :- " + drpn, 10, vacharheight);

                                        // } 
                                        // else {
                                            doc.text(object.QuestionName + " :- " + Answers[0].Answer, 10, vacharheight);
                                        // }

                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "Radio":
                                    
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
                                        object.Answers = Answers[0].Answer;
                                        doc.text(object.QuestionName + " :- " + object.Answers, 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "Yes/No":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
                                        object.Answers = parseInt(Answers[0].Answer);

                                        if (object.Answers == 1) {
                                            doc.text(object.QuestionName + " :- " + 'Yes', 10, vacharheight);
                                        }
                                        else {
                                            doc.text(object.QuestionName + " :- " + 'No', 10, vacharheight);
                                        }
                                        vacharheight = vacharheight + 8;

                                        if (SurveyQuestion[j].IsConditionQuestion) {
                                            var curntanswer = (parseInt(Answers[0].Answer) == 1 ? "Yes" : "No");

                                            if (curntanswer == SurveyQuestion[j].ConditionValue1) {
                                                var SurveyQuestion2 = await db.TbSurveyQuestions.where({ SectionId: SurveyQuestion[j].ConditionSectionId }).toArray();
                                                for (var kk = 0; kk < SurveyQuestion2.length; kk++) {
                                                    SurveyQuestion.splice(j + (kk + 1), 0, SurveyQuestion2[kk]);
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case "Image":
                                    
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                        doc.text(object.QuestionName + ":-", 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                        object.Answers = Answers[0].Answers
                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                        object.Blob = Answers[0].Blob;
                                        // eslint-disable-next-line no-redeclare
                                        var base64 = await this.ConverttoBase64(object.Blob[0]);

                                        doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                        vacharheight = vacharheight + 40;
                                    }
                                    break;
                                case "CaptureImage":
                                    // if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                    //     doc.text(object.QuestionName + " :- " + "Yes", 10, vacharheight);
                                    //     vacharheight = vacharheight + 8;
                                    // } else {
                                    //     doc.text(object.QuestionName + " :- " + "No", 10, vacharheight);
                                    //     vacharheight = vacharheight + 8;
                                    // }
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                            doc.text(object.QuestionName + ":-", 10, vacharheight);
                                            vacharheight = vacharheight + 1;
                                            object.Answers = Answers[0].Answers
                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                            object.Blob = Answers[0].Blob;
                                            // eslint-disable-next-line no-redeclare
                                            var base64 = await this.ConverttoBase64(object.Blob[0]);

                                            doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 50, 22);
                                            vacharheight = vacharheight + 40;
                                            }
                                    break;
                                    case "ProofOfResidence":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                            doc.text(object.QuestionName + ":-", 10, vacharheight);
                                            vacharheight = vacharheight + 5;
                                            object.Answers = Answers[0].Answers
                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                            object.Blob = Answers[0].Blob;
                                            // eslint-disable-next-line no-redeclare
                                            var base64 = await this.ConverttoBase64(object.Blob[0]);

                                            doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                            vacharheight = vacharheight + 40;
                                            }
                                    break;
                                    case "ProofOfUtilityBill":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                            doc.text(object.QuestionName + ":-", 10, vacharheight);
                                            vacharheight = vacharheight + 8;
                                            object.Answers = Answers[0].Answers
                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                            object.Blob = Answers[0].Blob;
                                            // eslint-disable-next-line no-redeclare
                                            var base64 = await this.ConverttoBase64(object.Blob[0]);

                                            doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                            vacharheight = vacharheight + 40;
                                            }
                                    break;
                                    case "ProofForSourceOfFunds":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

                                            doc.text(object.QuestionName + ":-", 10, vacharheight);
                                            vacharheight = vacharheight + 5;
                                            object.Answers = Answers[0].Answers
                                            object.OrginalFileName = Answers[0].OrginalFileName;
                                            object.Blob = Answers[0].Blob;
                                            // eslint-disable-next-line no-redeclare
                                            var base64 = await this.ConverttoBase64(object.Blob[0]);

                                            doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                            vacharheight = vacharheight + 40;
                                            }
                                    break;
                                case "Audio":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                        object.Answers = Answers[0].Answers;
                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                        object.Blob = Answers[0].Blob;
                                        doc.text(object.OrginalFileName, 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                                case "Sign":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                                        object.Answers = Answers[0].Answers
                                        object.OrginalFileName = Answers[0].OrginalFileName;
                                        object.Blob = Answers[0].Blob;

                                        // eslint-disable-next-line no-redeclare
                                        var base64 = await this.ConverttoBase64(object.Blob[0]);

                                        doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
                                        vacharheight = vacharheight + 40;
                                    }
                                    break;
                                case "GPS":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
                                        object.Answers = Answers[0].Answer;
                                        var arr = Answers[0].Answer.split(",");
                                        object.latitude = arr[0];
                                        object.longitude = arr[1];
                                    }
                                    break;
                                case "masterdb":
                                    if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
                                        var mstdb = Answers[0].Answer;
                                        mstdb = mstdb.substring(mstdb.indexOf("-") + 1);
                                        doc.text(object.QuestionName + " :- " + mstdb, 10, vacharheight);
                                        vacharheight = vacharheight + 8;
                                    }
                                    break;
                            }
                        }
                        else {
                            // if (object.QuestionID == 2 || object.QuestionID == 400 || object.QuestionID == 500) {
                            if (object.QuestionName == "Account Class" || object.QuestionName == "Source of Funds / Income Proof") {
                                // doc.text(object.QuestionName + " :- " + 'No', 10, vacharheight);
                                // vacharheight = vacharheight + 8;
                                console.log("Leave Extra drpdwn Class");
                            } else if(object.QuestionName == 'Physical Address' || object.QuestionName == 'Postal Address'){
                                //to not print the label value
                            }
                            else {
                                doc.text(object.QuestionName + " :- " + 'None', 10, vacharheight);
                                vacharheight = vacharheight + 8;
                            }
                        }
                    }
                }
                // eslint-disable-next-line no-unused-vars
                var ff = doc.output('datauristring');// alert(ff);
                //console.log(ff);
                doc.save("Form-" + FormId + '.pdf');
                this.TableActionPopup = false;
            },

            ConverttoBase64(file) {
                // eslint-disable-next-line no-unused-vars
                return new Promise((resolve, reject) => {
                    let fr = new FileReader();
                    // eslint-disable-next-line no-unused-vars
                    fr.onload = x => resolve(fr.result.split(',')[1]);
                    fr.readAsDataURL(file) // or readAsText(file) to get raw content
                })
            }, async ConverttoBase64URL(URL) {

                return fetch(URL)
                    .then(response => response.blob())
                    .then(blob => new Promise((resolve, reject) => {
                        const reader = new FileReader()
                        reader.onloadend = () => resolve(reader.result)
                        reader.onerror = reject
                        reader.readAsDataURL(blob)
                    }));
            },
            keymonitor: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode != 8 && (charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                }
            }, async checkSpcialChar(event) {
                var k = event.keyCode;
                if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)) {
                    // ;
                    event.returnValue = true;
                    return;
                }
                else {
                    //;
                    event.returnValue = false;
                }
            },
            async CallBankApis(SectionList, SurveySectionList, indexid, userId, hdngpslocation) {
            var self = this;
            var customercreationId = "";
            var correlationId = "";
            var CasaAccountId = "";
            var apiStatus = false;

            var objectArray = await this.$sunidhi.SubmitToBankApisNew(SectionList, SurveySectionList, indexid, userId, hdngpslocation);

            var object = new Object();
            var objectData = new Object();

            if (objectArray != null && objectArray.object != null &&
                objectArray.object.length > 0 &&
                objectArray.objectData != null &&
                objectArray.objectData.length > 0) {

                object = objectArray.object[0];
                objectData = objectArray.objectData[0];

            } else {
                apiStatus = false;
                return apiStatus;
            }

            customercreationId = await this.$sunidhi.SubmitCustomerCreation(object, userId);

            if (customercreationId != null &&
                customercreationId != undefined &&
                customercreationId.length > 0) {

                this.customerCreationNo = customercreationId;

                self.processLoader = 2;
                self.SubmitProgressMessage = "Processing AML Query...";

                correlationId = await this.$sunidhi.SubmitCustomerAML(object.Data.Individual, customercreationId, userId);

                if (correlationId != null &&
                    correlationId != undefined &&
                    correlationId.length > 0) {

                    var aml2Status = false;

                    self.processLoader = 3;
                    self.SubmitProgressMessage = "Processing CASA Account Creation...";

                    // eslint-disable-next-line no-undef
                    sleep(aml2waitTime);

                    // eslint-disable-next-line no-unused-vars
                    aml2Status = await this.$sunidhi.QueryResponseAML(correlationId, userId);

                    CasaAccountId = await this.$sunidhi.CASAAccountCreation(objectData, customercreationId, userId);

                    if (CasaAccountId != null && CasaAccountId != undefined &&
                        CasaAccountId.length > 0) {

                        this.casaAccountNo = CasaAccountId;
                        apiStatus = true;

                        self.processLoader = 4;
                        self.SubmitProgressMessage = "Processing Form Submission to dc...";

                        var objectSMS = [];
                        var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
                        if (genzdata1 != null && genzdata1.length > 0) {
                            if (genzdata1[0].mobilenumber != null && genzdata1[0].mobilenumber != undefined) {
                                objectSMS.push({ "Name": "mobilenumber", "Value": "91" + genzdata1[0].mobilenumber });
                            }

                            objectSMS.push({ "Name": "templateid", "Value": "SMS749" });
                        }

                        objectSMS.push({ "Name": "accountid", "Value": CasaAccountId.substring(CasaAccountId.length - 4) });

                        this.$sunidhi.SendSMS(objectSMS, userId);
                    }
                }
            }

            return apiStatus;
        },
             
        async SubmitDataProcess(IsDirectSubmit = false) {

                var errorCount = 0;
                var UserId = 0;
				this.dataProcessed = false;
                this.showProcessMsg = false;
                this.onceProcessed = false;

                if (IsDirectSubmit) {
                    await this.GetSurveySections(this.SelectedSurveyID, this.SelectedFormID, 0, false, true);
                }

                errorCount = await this.ValidateCurrentForm();

                if (errorCount > 0) {
                    return false;
                } else {
                    errorCount = await this.ValidateAllForms();

                    if (errorCount > 0) {
                        await this.NextSectionQuestions(this.CurrentSectionQuestions[0].SurveyID,this.CurrentSectionQuestions[0].SectionId+1);
                        $('#qstDiv').scrollTop(0);
                        /*this.ErrorMessage = "Please fill all mandatory questions in all sections before submitting the form !";
                        this.dialogError = true;
                        return false;*/
                    } else {
                        if (localStorage) {
                            UserId = localStorage.getItem("UserId");
                        }
                        $("#process-btn").attr("disabled",true);
                        this.showProcessMsg = true;
                        //this.ProcessMsg = "Form Data Processing.....";

                        await this.StartDataProcessing(this.SurveySectionList, UserId, false, true, this.sectionArray, this.SelectedFormID, 0);
                        this.todo();
                        return false;
                    }
                }
            }, todo: async function () {
                this.intervalid1 = setInterval(async function () {
                    if (this.onceProcessed) {
                        if (JSON.stringify(this.ProcessedSurveySectionList) != JSON.stringify(this.SurveySectionList)) {
                            clearInterval(this.intervalid1);
                            this.dataProcessed = false;
                            this.showProcessMsg = false;
                            this.onceProcessed = false;
                            this.processedStatus = true;
                        }
                    }
                }.bind(this), 500);
            }, 
// eslint-disable-next-line no-unused-vars
async StartDataProcessing(SurveySectionList, UserId, IsSubmitted, IsSaved, SectionList, FormId = 0, EntryId = 0) {
            this.uploadSuccess = [];
            // var unName = "";
            // var password = "";
            var userTokenID = "";

            var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata1 != null || genzdata1.length > 0) {
                // eslint-disable-next-line no-unused-vars
                userTokenID = genzdata1[0].token;
            }

            if (SectionList != null && SectionList.length > 0) {

                var SurveyId = 0;
                var SurveyName = 0;

                if (SurveySectionList != null && SurveySectionList.length > 0) {
                    SurveyId = SurveySectionList[0].SurveyID;
                    SurveyName = SurveySectionList[0].SurveyName;
                }

                var ID = this.$sunidhi.IDGenerator();
                var FormCount = await db.TbSurveyForm.where("SurveyID").equals(SurveyId).toArray();
                var FormName = SurveyName + '_' + (FormCount.length + 1);

                /// Insert into TbSurveyForm Table
                // eslint-disable-next-line no-unused-vars
                var pkId = await db.TbSurveyForm.put({ FormID: ID, Name: FormName, SurveyID: SurveyId, CreatedDate: Date(), CreatedBy: parseInt(UserId), IsActive: true, IsSubmitted: IsSubmitted, IsSaved: IsSaved, UserID: parseInt(UserId) });

                for (var i = 0; i < SectionList.length; i++) {
                    var Section = SurveySectionList.filter(x => x.SectionId == SectionList[i]);

                    if (Section != null && Section.length > 0 &&
                        Section[0].Questions != null && Section[0].Questions.length > 0) {

                        ///  Insert into TbSurveyAnswers Table
                        for (var j = 0; j < Section[0].Questions.length; j++) {
                            var item = Section[0].Questions[j];

                            if (item.QuestionType == "Dropdown" || item.QuestionType == "masterdb" || item.QuestionType == "ConditionalDropdown") {

                                if (Object.keys(item.Answers).length > 0) {
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers.OptionValue, OptionID: item.Answers.OptionValue, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: null, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: null, Blob: null });
                                }
                            } else if (item.QuestionType == "Image" || item.QuestionType == "Audio" || item.QuestionType == "Sign") {
                                if (item.Blob.length > 0 && item.OrginalFileName != "") {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            } else if (item.QuestionType == "CaptureImage" || item.QuestionType == "ProofOfResidence" || item.QuestionType == "ProofOfUtilityBill" || item.QuestionType == "ProofForSourceOfFunds") {
                                if (item.Blob.length > 0) {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            // else if (item.QuestionType == "CheckBox" ) {
                            //     var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });

                            // }
                            else if (item.QuestionType == "CheckBox" || item.QuestionType == "Radio") {
                                if (item.Answers.length == 0) {
                                    item.Answers = "No";
                                    // eslint-disable-next-line no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                } else {
                                    // eslint-disable-next-line no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }

                            }
                            else if (item.Answers > 0 || item.Answers.length > 0) {

                                if (item.Answers instanceof Array) {

                                    if (typeof item.Answers[item.Answers.length - 1] != 'string') {

                                        // eslint-disable-next-line no-redeclare
                                        var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                    else {
                                        // eslint-disable-next-line no-redeclare
                                        var AnswerID = await db.TbAnswers.put({ Answer: item.Answers[item.Answers.length - 1], QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                }
                                else {
                                    if (item.QuestionName == "First Name" || item.QuestionName == "Last Name" || item.QuestionName == "Middle Name" || item.QuestionName == "Name on Debit card") {
                                        item.Answers = (item.Answers != null && item.Answers != undefined) ? item.Answers.toUpperCase() : "";
                                    }

                                    // eslint-disable-next-line no-unused-vars, no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }
                            }
                        }
                    }
                }
            }

            var SyncQueuePKID = await db.ClientSyncQueue.put({ FormID: ID, SurveyID: SurveyId, CreatedDate: Date(), TagName: "SurveyForm" });
            this.processedFormId = ID;
            var response = await this.$sunidhi.DataProcess(1, SyncQueuePKID);

            if (response.Message == "Success" && response.resultStatus == "Form Saved") {
                this.ProcessedSurveySectionList = [];
                this.ProcessedSurveySectionList = JSON.parse(JSON.stringify(this.SurveySectionList));
                this.dataProcessed = true;
                this.dispProcessBtn = false
                this.onceProcessed = true;
                // this.ProcessMsg = "Process Completed. You can submit form Now.";
                this.dataprocessedsuccess = true;
                this.dataprocessedfailure = false;
                await this.SubmitSurveyFom()
            } else {
                this.ProcessedSurveySectionList = [];
                this.dataProcessed = false;
                this.dispProcessBtn = true;
                this.onceProcessed = false;
                this.ProcessMsg = "Form data process failed. Please try again.";
                this.processedStatus = false;
                this.dataprocessedsuccess = false;
                this.dataprocessedfailure = true;
            }
        },
        async CalPincodeApi(pin) {

if (pin.length == 6) {
    this.PreLoader = true;
    var userTokenID = "";
    var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
    if (genzdata1 != null || genzdata1.length > 0) {
        userTokenID = genzdata1[0].token;
    }

    var url = "https://ccapi.gieom.com/api/SearchbyPincode?userid=" + userTokenID + "&pincode=" + pin;

    try {

        var self = this;
        await $.ajax({
            url: url,
            type: 'GET',
            success: async function (data) {

                if (data.Status == "success") {

                    if (data != null && data != undefined &&
                        data.Data != null && data.Data != undefined &&
                        data.Data.Data != null && data.Data.Data != undefined &&
                        data.Data.Data.ResponseData != null && data.Data.Data.ResponseData != undefined) {

                        if (self.SurveySectionList != null && self.SurveySectionList.length > 0) {
                            var sections = self.SurveySectionList.filter(x => x.SectionId == 3);

                            if (sections != null && sections.length > 0) {
                                var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                                var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                                // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                                if (varcity != null && varcity.length > 0) {
                                    varcity[0].Answers = data.Data.Data.ResponseData.City;
                                }

                                if (vardistrict != null && vardistrict.length > 0) {
                                    vardistrict[0].Answers = data.Data.Data.ResponseData.District;
                                }

                                // if (state != null && state.length > 0) {
                                //     var stname = data.Data.Data.ResponseData.StateCode + "-" + data.Data.Data.ResponseData.StateName;
                                //     state[0].Answers = { "OptionValue": stname, "OptionText": data.Data.Data.ResponseData.StateName };
                                // }
                            }
                        }

                        self.PreLoader = false;
                    } else {

                        if (self.SurveySectionList != null && self.SurveySectionList.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var sections = self.SurveySectionList.filter(x => x.SectionId == 3);

                            if (sections != null && sections.length > 0) {
                                // eslint-disable-next-line no-redeclare
                                var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                                // eslint-disable-next-line no-redeclare
                                var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                                // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                                if (varcity != null && varcity.length > 0) {
                                    varcity[0].Answers = "";
                                }

                                if (vardistrict != null && vardistrict.length > 0) {
                                    vardistrict[0].Answers = "";
                                }

                                // if (state != null && state.length > 0) {
                                //     state[0].Answers = null;
                                // }
                            }
                        }

                        self.PreLoader = false;
                    }
                }
            },
            // eslint-disable-next-line no-unused-vars
            error: function (ex) {
                if (this.SurveySectionList != null && this.SurveySectionList.length > 0) {
                    var sections = this.SurveySectionList.filter(x => x.SectionId == 3);

                    if (sections != null && sections.length > 0) {
                        var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                        if (varcity != null && varcity.length > 0) {
                            varcity[0].Answers = "";
                        }

                        var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                        if (vardistrict != null && vardistrict.length > 0) {
                            vardistrict[0].Answers = "";
                        }

                        // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                        // if (state != null && state.length > 0) {
                        //     state[0].Answers = null;
                        // }
                    }
                }
                self.PreLoader = false;
            }
        });
    } catch (error) {

        if (this.SurveySectionList != null && this.SurveySectionList.length > 0) {
            var sections = this.SurveySectionList.filter(x => x.SectionId == 3);

            if (sections != null && sections.length > 0) {
                var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                if (varcity != null && varcity.length > 0) {
                    varcity[0].Answers = "";
                }

                var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                if (vardistrict != null && vardistrict.length > 0) {
                    vardistrict[0].Answers = "";
                }

                // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                // if (state != null && state.length > 0) {
                //     state[0].Answers = null;
                // }
            }
        }

        self.PreLoader = false;

    }
}
}
        }, beforeRouteLeave(to, from, next) {
            if (this.$sunidhi.backbuttonpressed) {
                // if (confirm('You may have unsaved changes. Do you want to continue?')) {
                return next(false);
                //  }
            } else {
                return next();
            }
        }
    }
</script>
<style scoped>
    .v-tabs__wrapper {
        padding-bottom: 10px;
    }
</style>